// *******************************************************************************************************************************
// * appsubtitles from appbase
// *******************************************************************************************************************************
import React from "react";
import Icon from '../../components/bases/icone/icon.js';

import AppBase from '../appBase.js';
import AppSettings from './appcomponents/appsettings/appsettings.js';
import AppHeader from './appcomponents/appheader/appheader.js';

import SimplePopup from "../../components/bases/popup/simplePopup.js";
import Zoom from "./appcomponents/timeline/zoom/zoom.js";
import ApplyOffsetVideo from "../dialogs/applyoffsetvideo.js";
import { AppResizeHandle } from "../../utils/apputils.js";
import { appAsset_getCorrectedFromOriginal, appAsset_getAssetById,appAsset_getFirstAssetByType } from "../../utils/apputils.js";
import { appAsset_generateUUID, appAsset_getCurrentDate } from "../../utils/apputils.js";

import { apiReadOneVideo } from "../../utils/apis.js";
import { getVideoPath, getCpPaths, getAudioPath } from "../../utils/apis.js";

import VideoPlayerST from '../../components/bases/videoplayer/videoplayerst.js';

import AppMediaAssets from "./appcomponents/appmediaassets/appmediaassets.js";
import TimeLine from './appcomponents/timeline/timeline.js';
import ToolsBar from '../../components/bases/toolsbar/toolsbar.js';
import SpeakersList from "./appcomponents/speakerslist/speakerslist.js";
import SequencesBlock from "./appcomponents/sequences/sequenceblock.js";
import User from "./appcomponents/user/user.js"
import { getAssetColorsByType } from '../../utils/colors.js';
import { apiSaveUserConfig } from "../../utils/apis.js";

import styles from "../appstyles/styles.module.css"
import "../appstyles/subtitle.css"
import EnTravaux from '../../components/bases/entravaux/entravaux.js';
import { apiCreateFromAsset,apiReadOneAsset, apiSearchAssetsFromProject } from '../../utils/apis.js';
import { configuration_createBlankSubtitle,configurations_framestotime, configurations_getDefaultParams, configurations_getDefaultPlayerParams, configurations_getDefaultTimeLineParams } from "../../utils/configurations.js";
import { directDownloadTxt,directDownloadJson } from '../../utils/download.js';

import { apiCreateSequences } from "../../utils/apis.js";

import { sequencesCreateDefaultSequenceV2, getSequenceVersionFile, createV2SequencesFiles } from "../../utils/sequences.js";
import { apiReadOneConfiguration, apiDeleteConfiguration, apiSetAssetConfiguration } from "../../utils/apis.js";
import { keyboard_multi_getKey, keyboard_multi_getShorCutList_by_apps_and_keyboard, keyboard_multi_savePersonnalKey } from '../../utils/keyboard_multi.js';
import { getStickyWordsList } from '../../utils/download';

import { globalAddCP, globalIsACp, checkSubtitle, getTCInFromPreviousSTorCP, getTCOutFromNextSTorCP, getLisibility, getIdealDuration } from '../../utils/checksubtitles.js';
import { getCurrentUserDatas, setCurrentUserDatas } from "../../utils/software.js";
import { keyboard_special_down, keyboard_special_up} from "../../utils/keyboard.js";

import {getCurrentProjectDatas, getMaxUndo, getCurrentMode, setCurrentMode} from "../../utils/software.js"
import { getlocalhostDatas } from '../../utils/apis.js';
import { getCurrentVersion, getDefaultLayout, getIsVisibleLayoutBlock, loadLayout, saveLayout } from '../../utils/software.js';

import {secondsToTimecodeWithMilliseconds, truncateTimeCode} from './appcomponents/utils.js'
import { V2_RoundedTimeCode } from "../../utils/timecodev2.js";

import { GlobalContext, SideBarRef, UploadComponentRef } from '../../utils/globalprovider.js';
import imgblue from "./assets/toolsbar/blue.png"
import imggreen from "./assets/toolsbar/green.png"
import imgcyan from "./assets/toolsbar/cyan.png"
import imgred from "./assets/toolsbar/red.png"
import imgmagenta from "./assets/toolsbar/magenta.png"
import imgyellow from "./assets/toolsbar/yellow.png"
import imgwhite from "./assets/toolsbar/white.png"

import imgsave from "./assets/toolsbar/save.png"

import imgleft from "./assets/toolsbar/gauche.png"
import imgcenter from "./assets/toolsbar/centre.png"
import imgright from "./assets/toolsbar/droite.png"
import imgcadenas from "./assets/toolsbar/cadenas.png"
import imgsimul from "./assets/toolsbar/simul.png"
import imgseek from "./assets/toolsbar/seek.png"
import imgshortcuts from "./assets/toolsbar/shortcuts.png"
import imgaletter from "./assets/toolsbar/aletter.png"
import imgdisplaytranscription from "./assets/toolsbar/display/transcription.png"
import imgdisplaysubtitles from "./assets/toolsbar/display/soustitres.png"
import imgdisplaysequences from "./assets/toolsbar/display/sequences.png"
import imgdisplaytc from "./assets/toolsbar/display/displaytc.png"
import imgdisplaytimeline from "./assets/toolsbar/display/timeline.png"
import imgdisplayplayer from "./assets/toolsbar/display/player.png"
import imgOffsetAll from "./assets/toolsbar/offsetglobal.png"
import imgOffsetFrom from "./assets/toolsbar/offsetfrom.png"

import imglayoutloaddefault from "./assets/toolsbar/layouts/layoutloaddefault.png"
import imglayoutload from "./assets/toolsbar/layouts/layoutload.png"
import imglayoutsave from "./assets/toolsbar/layouts/layoutsave.png"

import imgsquencesplus from "./assets/toolsbar/sequences/sequencesplus.png"
import imgaddsequence from "./assets/toolsbar/sequences/addsequence.png"
import imgdeletesequenceafter from "./assets/toolsbar/sequences/deletesequenceafter.png"
import imgdeletesequencebefore from "./assets/toolsbar/sequences/deletesequencebefore.png"
import imgundosequence from "./assets/toolsbar/sequences/undosequence.png"



import ftva from "../../assets/ftva.png"
import easytt from "../../assets/logoEasyTTSmall.png"

// Emmanuelle
import { cloneDeep, first, flatMapDeep, isEqual, last, orderBy, uniqBy, union, flatMap, trimEnd, words, reduce, clone } from 'lodash';
import Transcript from "./appcomponents/transcript/transcript.js"
import EditListSt from "./appcomponents/subtitles/list-st/edit-list-st.js";
import CommonRaccourcis from "./appcomponents/allsettings/commonraccourcis/commonraccourcis.js";
import CommonTableCaracteres from "./appcomponents/allsettings/commontablecaracteres/commontablecaracteres.js";
import CommonGoTo from "./appcomponents/allsettings/commongoto/commongoto.js";
import Grammalecte from "./appcomponents/subtitles/common/grammalecte.js";
//import { onSelectUpOrDownSentence } from "./appcomponents/subtitles/list-st/actions/keyboard.js";
import { V2_CorrectInterval, V2_ConvertTimeCodeStringToSecond, V2_checkTimeCode, V2_ConvertSecondToTimeCodeStringFromAsset, V2_ConvertTimeCodeStringToSecondFromAsset, V2_getIntervalStringFromAsset, V2_GetOneFrameDurationFromAsset, V2_GetSecondTimeCodeStart, V2_recfps } from "../../utils/timecodev2.js";
import { startClipboardRead } from "./appcomponents/subtitles/common/clipboard.js";
import { wait, cloneSubtitle, replaceWordsWithDifferentCount } from "./appcomponents/subtitles/common/functions.js";



class AppSubtitle extends AppBase
{
    static contextType = GlobalContext;
  constructor(props) {
    super(props);
    // *********************************************************************************************************************
    // app
    // *********************************************************************************************************************
    this.onCancelKeyboardEvent = this.onCancelKeyboardEvent.bind(this);
    this.cancelKeyboardEvent = false;
    this.appHeaderRef = React.createRef();
    this.bodyDivRef = React.createRef();
    this.divEditSTRef = React.createRef();
    this.transcriptRef = React.createRef();
    this.state.pjid = getCurrentProjectDatas().pjid;
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.autoSave = this.autoSave.bind(this);
    this.saveSubtitles = this.saveSubtitles.bind(this);
    this.OtherFilesdownloadDone = this.OtherFilesdownloadDone.bind(this);
    this.shortcuts_list = [];

    this.state.refreshKey = this.getTimeHHMMSSforKey();
    // app assets manager
    this.onAppMediaAssetsAction = this.onAppMediaAssetsAction.bind(this);

    this.appMediaAssetsRef = React.createRef();

    this.loadCurrentConfiguration = this.loadCurrentConfiguration.bind(this)
    this.loadCurrentConfigurationDone = this.loadCurrentConfigurationDone.bind(this);
    this.loadCurrentConfigurationFromAppMediaAsset = this.loadCurrentConfigurationFromAppMediaAsset.bind(this);
    this.loadCurrentConfigurationFromAppMediaAssetDone = this.loadCurrentConfigurationFromAppMediaAssetDone.bind(this);
    this.writeCurrentConfigurationInAsset = this.writeCurrentConfigurationInAsset.bind(this);
    this.writeCurrentConfigurationInAssetDone = this.writeCurrentConfigurationInAssetDone.bind(this);
    this.onDeleteConfiguration = this.onDeleteConfiguration.bind(this);
    this.onDeleteConfigurationDone = this.onDeleteConfigurationDone.bind(this);
    this.firstLoadConfiguration = this.firstLoadConfiguration.bind(this);
    this.firstLoadConfigurationDone = this.firstLoadConfigurationDone.bind(this);


    
    this.initialised = false;
    // *********************************************************************************************************************
    // app subtitles specifics functions
    // *********************************************************************************************************************
    this.app_FirstassetsDownloaded = false;
    this.appSubtitles_SearchFirstCurrentAssets = this.appSubtitles_SearchFirstCurrentAssets.bind(this);
    this.appSubtitles_SetCurrentToAssetsManager = this.appSubtitles_SetCurrentToAssetsManager.bind(this);
    this.appSubtitles_startWithOneVideoCallback = this.appSubtitles_startWithOneVideoCallback.bind(this);
    this.appSubtitles_apiCallBackReadOneAsset = this.appSubtitles_apiCallBackReadOneAsset.bind(this);
    this.appSubtitles_apiCallBackReadOneAssetOriginal = this.appSubtitles_apiCallBackReadOneAssetOriginal.bind(this);
    this.appSubtitles_apiCallBackReadOneAssetCorrected = this.appSubtitles_apiCallBackReadOneAssetCorrected.bind(this)
    this.appSubtitles_apiCallBackCreateOneAssetFromOriginal = this.appSubtitles_apiCallBackCreateOneAssetFromOriginal.bind(this)
    this.app_subtitles_checkSubtitle = this.app_subtitles_checkSubtitle.bind(this);
    this.app_subtitles_movetoSubtitle = this.app_subtitles_movetoSubtitle.bind(this);
    this.assetsList = [];
    this.currentVideoId = -1;
    this.currentOriginalSubtitleId = -1;
    this.currentCorrectedSubtitleId = -1;
    this.currentOriginalTranscription = -1;
    this.currentCorrectedTranscription = -1;
    this.currentSequencesId = 0;
  
    this.getTimeCodeString = this.getTimeCodeString.bind(this);
    this.getIntervalString = this.getIntervalString.bind(this);

        
    this.ondetectionButton = this.ondetectionButton.bind(this)
    this.onMouseUpOnSubtitle = this.onMouseUpOnSubtitle.bind(this)
        
    this.state.createANewSubtitleFilePopup = false;
    this.state.deleteConsfigurationPopup = false;
    this.state.popupText = false;

    this.onCreateNewSubtitleFile = this.onCreateNewSubtitleFile.bind(this);
    this.returnToMainPage = this.returnToMainPage.bind(this);
    this.restartReloadPage = this.restartReloadPage.bind(this);
    this.exitAllPopup = this.exitAllPopup.bind(this)


    // *********************************************************************************************************************
    // Assets Manager
    // *********************************************************************************************************************

    this.onClickOnAsset = this.onClickOnAsset.bind(this)
    this.onAssetsManagerChange = this.onAssetsManagerChange.bind(this)
    this.assetsManagerRef = React.createRef();
    this.appsettingsRef = React.createRef();

    // *********************************************************************************************************************
    // sequences 
    // *********************************************************************************************************************

    this.state.sequencesasset  = {asid:0, astitle:""};
    this.state.sequences = {sequences:[]};
    
    this.undosequences = [];
    this.maxUndoSequences = 10;


    this.sequences_createsequences = this.sequences_createsequences.bind(this);
    this.sequences_createsequences_callback = this.sequences_createsequences_callback.bind(this);
    this.sequences_setsequences_callback = this.sequences_setsequences_callback.bind(this);
    this.sequences_onGetText = this.sequences_onGetText.bind(this);
    this.doActionSequence = this.doActionSequence.bind(this)
    this.sequences_add_one_undo = this.sequences_add_one_undo.bind(this)
    
    this.sequences_onChangeSequences = this.sequences_onChangeSequences.bind(this);
    this.sequences_goto = this.sequences_goto.bind(this);
    this.onClickOnSequence = this.onClickOnSequence.bind(this);
    this.sequencesRef = React.createRef();


    // *********************************************************************************************************************
    // Params
    // *********************************************************************************************************************
    this.onchangeparams = this.onchangeparams.bind(this)


    // *********************************************************************************************************************
    // Tool Bar
    // *********************************************************************************************************************

    const mode = getCurrentMode();

    this.state.modeA = mode.modeA;
    this.state.modeB = mode.modeB;
    this.state.modeC = mode.modeC;
    this.state.modeSimulation = false;
    this.state.displayCommonRaccourcis = false;
    this.state.displayCommonTableCaracteres = false;
    this.state.displayGoToSubtitleNumber = false;
    this.state.showTimecodes = false;

    this.commonRaccourcisRef = React.createRef();
    this.commonTableCaracteresRef = React.createRef();
    this.commonGoToSubtitleNumberRef = React.createRef();

    

    this.state.toolsbar =
    {
      height: 18,


      families: [

        {
            fr: "actions",
            en: "actions",
            items: [
              {img: imgsave ,type:"button", disable:false,fr:"Sauvegarder",en:"Save", nochangecolor:false, key:{key:"SAVE", cat:"transcriptshortcut"}},
            ],
        },

        {
          fr: "couleurs",
          en: "colors",

          items: [
            { img: imgblue, type: "button", disable: false, fr: "Bleu", en: "Blue", nochangecolor: true, key: { key: "BLUE", cat: "transcriptshortcut" } },
            { img: imggreen, type: "button", disable: false, fr: "Vert", en: "Green", nochangecolor: true, key: { key: "GREEN", cat: "transcriptshortcut" } },
            { img: imgcyan, type: "button", disable: false, fr: "Cyan", en: "Cyan", nochangecolor: true, key: { key: "CYAN", cat: "transcriptshortcut" } },
            { img: imgred, type: "button", disable: false, fr: "Rouge", en: "Red", nochangecolor: true, key: { key: "RED", cat: "transcriptshortcut" } },
            { img: imgmagenta, type: "button", disable: false, fr: "Magenta", en: "Magenta", nochangecolor: true, key: { key: "MAGENTA", cat: "transcriptshortcut" } },
            { img: imgyellow, type: "button", disable: false, fr: "Jaune", en: "Yellow", nochangecolor: true, key: { key: "YELLOW", cat: "transcriptshortcut" } },
            { img: imgwhite, type: "button", disable: false, fr: "Blanc", en: "White", nochangecolor: true, key: { key: "WHITE", cat: "transcriptshortcut" } },

          ],
        },
        {
          fr: "alignement",
          en: "aligment",

          items: [
            { img: imgleft, type: "button", disable: false, fr: "A gauche", en: "To left", nochangecolor: false, key: { key: "MOVESUBTITLETOLEFT", cat: "transcriptshortcut" } },
            { img: imgcenter, type: "button", disable: false, fr: "Au centre", en: "Center", nochangecolor: false, key: { key: "MOVESUBTITLETOCENTER", cat: "transcriptshortcut" } },
            { img: imgright, type: "button", disable: false, fr: "A droite", en: "To right", nochangecolor: false, key: { key: "MOVESUBTITLETORIGHT", cat: "transcriptshortcut" } },

          ],
        },

        {
          fr: "mode",
          en: "mode",

          items: [
            { toogle: true, value: this.state.modeA, img: imgcadenas, type: "button", disable: false, fr: "Faire suivre la vidéo", en: "Lock video", nochangecolor: false, key: { key: "LOCKVIDEO", cat: "mode" } },
            { toogle: true, value: this.state.modeB, img: imgseek, type: "button", disable: false, fr: "Faire suivre les sous-titres", en: "Lock subtitles", nochangecolor: false, key: { key: "LOCKSUBTITLES", cat: "mode" } },
            { toogle: true, value: this.state.modeC, img: imgsimul, type: "button", disable: false, fr: "Simulation en play", en: "Simulation when play", nochangecolor: false, key: { key: "SIMUL", cat: "mode" } },

          ],
        },

        {
          fr: 'Divers',
          en: 'Misc.',
          items: [
            { img: imgshortcuts, type: "button", disable: false, fr: "Modifier la programmation des touches", en: "Edit programming keys", nochangecolor: false, key: { key: "commonShortcuts", cat: "shortcuts" } },
            { img: imgaletter, type: "button", disable: false, fr: "Afficher la table des caractères", en: "Display the character table", nochangecolor: false, key: { key: "commonCharacters", cat: "shortcuts" } },
            { img: imgdisplaytc, type: "button", disable: false, fr: "Affichage des timecodes dans la fenêtre du player", en: "Display timecodes on player", nochangecolor: false, key: { key: "timecodes", cat: "shortcuts" } },
          ]
        },
        {
          fr: 'Offsets',
          en: 'Offsets',
          items: [
            { img: imgOffsetAll, type: "button", disable: false, fr: "Offset global", en: "Global Offset", nochangecolor: false, key: { key: "offsetglobal", cat: "shortcuts" } },
            { img: imgOffsetFrom, type: "button", disable: false, fr: "Offset à partir du sous-titre", en: "Offset From subtitle", nochangecolor: false, key: { key: "offsetfrom", cat: "shortcuts" } },
          ]
        },
        {
          fr: "Affichage",
          en: "Display",

          items: [
            { img: imgdisplayplayer, type: "button", disable: false, fr: "Player", en: "Player", nochangecolor: false, key: { key: "player", cat: "display" } },
            { img: imgdisplaytimeline, type: "button", disable: false, fr: "TimeLine", en: "TimeLine", nochangecolor: false, key: { key: "timeline", cat: "display" } },
            { img: imgdisplaytranscription, type: "button", disable: false, fr: "Transcription", en: "Transcription", nochangecolor: false, key: { key: "transcription", cat: "display" } },
            { img: imgdisplaysubtitles, type: "button", disable: false, fr: "Sous-Titres", en: "Subtitles", nochangecolor: false, key: { key: "subtitles", cat: "display" } },
            {img: imgdisplaysequences ,type:"button", disable:false,fr:"Séquences",en:"Sequences", nochangecolor:false, key:{key:"sequences", cat:"display"}},
            
          ],
        },
        {
          fr: 'Séquences',
          en: 'Sequences',
          items: [
            { img: imgsquencesplus, type: "button", disable: false, fr: "Ajouter un asset de séquences", en: "Add sequences asset", nochangecolor: false, key: { key: "sequencesplus", cat: "sequences" } },
            { img: imgaddsequence, type: "button", disable: true, fr: "Ajouter une séquence ici", en: "Add a sequence here", nochangecolor: false, key: { key: "addsequence", cat: "sequences" } },
            { img: imgdeletesequencebefore, type: "button", disable: true, fr: "Supprimer et prolonger la séquence précédente", en: "Delete and extend the previous sequence", nochangecolor: false, key: { key: "deletesequencebefore", cat: "sequences" } },
            { img: imgdeletesequenceafter, type: "button", disable: true, fr: "Supprimer et avancer la séquence suivante", en: "Delete and advance to the next sequence", nochangecolor: false, key: { key: "deletesequenceafter", cat: "sequences" } },
            { img: imgundosequence, type: "button", disable: true, fr: "Undo (Séquences)", en: "Undo (Séquences)", nochangecolor: false, key: { key: "undosequence", cat: "sequences" } },
          ]
        },



        {
          fr: "Présentations",
          en: "Layouts",

          items: [
            { img: imglayoutloaddefault, type: "button", disable: false, fr: "Charger présentation prédéfinie n°1", en: "Load predefined layout #1", nochangecolor: true, key: { key: "loaddef1", cat: "layouts" } },
            { img: imglayoutloaddefault, type: "button", disable: false, fr: "Charger présentation prédéfinie n°2", en: "Load predefined layout #2", nochangecolor: true, key: { key: "loaddef2", cat: "layouts" } },
            { img: imglayoutloaddefault, type: "button", disable: false, fr: "Charger présentation prédéfinie n°3", en: "Load predefined layout #3", nochangecolor: true, key: { key: "loaddef3", cat: "layouts" } },
            { type: "space" },
            { img: imglayoutload, type: "button", disable: false, fr: "Charger présentation utilisateur n° 1", en: "Load personnal layout #1", nochangecolor: true, key: { key: "load1", cat: "layouts" } },
            { img: imglayoutload, type: "button", disable: false, fr: "Charger présentation utilisateur n° 2", en: "Load personnal layout #2", nochangecolor: true, key: { key: "load2", cat: "layouts" } },
            { img: imglayoutload, type: "button", disable: false, fr: "Charger présentation utilisateur n° 3", en: "Load personnal layout #3", nochangecolor: true, key: { key: "load3", cat: "layouts" } },
            { type: "space" },
            { img: imglayoutsave, type: "button", disable: false, fr: "Sauvergarder présentation utilisateur n° 1", en: "Save personnal layout #1", nochangecolor: true, key: { key: "save1", cat: "layouts" } },
            { img: imglayoutsave, type: "button", disable: false, fr: "Sauvergarder présentation utilisateur n° 2", en: "Save personnal layout #2", nochangecolor: true, key: { key: "save2", cat: "layouts" } },
            { img: imglayoutsave, type: "button", disable: false, fr: "Sauvergarder présentation utilisateur n° 3", en: "Save personnal layout #3", nochangecolor: true, key: { key: "save3", cat: "layouts" } },


          ],
        },


      ],
    }
        
        
    this.onClickToolsBar = this.onClickToolsBar.bind(this)
    this.onClickCommonRaccourcis = this.onClickCommonRaccourcis.bind(this);
    this.onClickCommonTableCaracteres = this.onClickCommonTableCaracteres.bind(this);
    this.onClickCommonGoToSubtitleNumber = this.onClickCommonGoToSubtitleNumber.bind(this);
      
    // *********************************************************************************************************************
    // Player
    // *********************************************************************************************************************
    
    this.state.playerparams = getCurrentUserDatas().config.subtitling.player;
    this.state.currentplayerparams = getCurrentUserDatas().config.subtitling.player;
    

    this.handleOnMustReload = this.handleOnMustReload.bind(this);
    this.handleEndApplyVideo = this.handleEndApplyVideo.bind(this)
    this.state.displayApplyOffset = false;

    this.state.videopath = "";
    this.state.videoready = false;
    this.state.videoforplayer = null;

    this.state.timecodeAsset =
    {
      asid: 0,
      asframerate: 25,
      asnum: 25,
      asden: 1,
      asdropframe: 0,
      astimecode: "00:00:00:00",
    };

    this.state.isPlaying = false;

    this.videoPlayerRef = React.createRef();
    this.onNewTime = this.onNewTime.bind(this)
    this.videoReady = this.videoReady.bind(this)

    this.state.internalcplist = [];
    this.downloadCPDone = this.downloadCPDone.bind(this);
    this.addcp = this.addcp.bind(this);

    // *********************************************************************************************************************
    // application params
    // *********************************************************************************************************************
    this.state.applicationsparams = getCurrentUserDatas().config.paramsapp;

    // *********************************************************************************************************************
    // Time Line
    // *********************************************************************************************************************

    this.timelinePanelRef = React.createRef();
    this.timelineRef = React.createRef();
    
    
    this.onChangeTimeLineZoom = this.onChangeTimeLineZoom.bind(this)    
    this.state.zoomValue = 9;

        
    this.state.timelineHeight = 30;
    this.state.timelineHeightInPixel = 10;
    //this.state.timelineparams = configurations_getDefaultTimeLineParams();

    

    this.state.timelineparams = getCurrentUserDatas().config.subtitling.timeline;
    this.currenttimelineparams = getCurrentUserDatas().config.subtitling.timeline;

    this.currenttimelineparams.sttrackaudio1 = this.currenttimelineparams.sttrackaudio;
    this.currenttimelineparams.sttrackaudio2 = this.currenttimelineparams.sttrackaudio;

    this.currenttimelineparams.stsmalltrackaudio1 = this.currenttimelineparams.stsmalltrackaudio;
    this.currenttimelineparams.stsmalltrackaudio2 = this.currenttimelineparams.stsmalltrackaudio;
        
    this.handleTimeLineWheel = this.handleTimeLineWheel.bind(this)
    this.handleGotoTime = this.handleGotoTime.bind(this)
        
    this.onNewSubtitleTimeCode = this.onNewSubtitleTimeCode.bind(this);

    this.appSubtitles_onReadVideoForCP = this.appSubtitles_onReadVideoForCP.bind(this);
    this.appSubtitles_onReadVideoForAudio1 = this.appSubtitles_onReadVideoForAudio1.bind(this);
    this.appSubtitles_onReadVideoForAudio2 = this.appSubtitles_onReadVideoForAudio2.bind(this);
    this.setSubtitlesChange = this.setSubtitlesChange.bind(this);
    this.handleCpListLoaded = this.handleCpListLoaded.bind(this);


    
    // *********************************************************************************************************************
    // subtitle errors
    // *********************************************************************************************************************
    this.onClickOnErrorSubtitle = this.onClickOnErrorSubtitle.bind(this)
    // *********************************************************************************************************************
    // layout
    // *********************************************************************************************************************

    this.state.blocks = getDefaultLayout("subtitling", 1);

    const user  = getCurrentUserDatas();
    var layout = [];
    switch (user.config.subtitling.current)
    {
      case 0: layout = user.config.subtitling.blocks.usine1; break;
      case 1: layout = user.config.subtitling.blocks.usine2; break;
      case 2: layout = user.config.subtitling.blocks.usine3; break;
      case 3: layout = user.config.subtitling.blocks.user1; break;
      case 4: layout = user.config.subtitling.blocks.user2; break;
      case 5: layout = user.config.subtitling.blocks.user3; break;
        
    }

    try
    {
      layout.forEach(block => {block.span = (<></>)});
      
    }
    catch(e)
    {
      console.log(e)
      console.log("layout", layout)
      layout = user.config.subtitling.blocks.usine1;
      layout.forEach(block => {block.span = (<></>)});
    }

    this.state.blocks = layout;


    this.state.b_displaySubtitlesList = getIsVisibleLayoutBlock(this.state.blocks,"subtitles");
        
    this.state.action = { current: "none" };
    this.state.aciveid = "";
    this.containerBlockRef = React.createRef();
    this.blocks_onMouseMove = this.blocks_onMouseMove.bind(this);
    this.blocks_onMouseUp = this.blocks_onMouseUp.bind(this);

    // *********************************************************************************************************************
    // Speakers
    // *********************************************************************************************************************
    this.state.speakers = [];
    this.state.speakerIdsOrderByAppearance = [];
    this.onChangeSpeakers = this.onChangeSpeakers.bind(this);
    this.onUpdateAppearenceSpeakers = this.onUpdateAppearenceSpeakers.bind(this);
    this.speakersListRef = React.createRef();


    // *********************************************************************************************************************
    // subtitle list
    // *********************************************************************************************************************

    this.editListeStRef = React.createRef();

    this.state.subtitleParameters = configurations_getDefaultParams();
    this.state.defaultsparams = configurations_getDefaultParams();
    
    this.displayParameters = {
      borderWidth: '5px', // épaisseur de la bordure autour du caractère
      borderColor: 'black', // « black »
      marginLeft: '5%',
      marginRight: '5%',
      marginTop: '5%',
      marginBottom: '5%',
    };

    this.subtitlelist_move = this.subtitlelist_move.bind(this);
    this.subtitlelist_change = this.subtitlelist_change.bind(this);
    this.subtitlelist_applyFilter = this.subtitlelist_applyFilter.bind(this);
    this.subtitlelist_addNewActionForUndo = this.subtitlelist_addNewActionForUndo.bind(this);
    this.subtitlelist_onUndoOrRedo = this.subtitlelist_onUndoOrRedo.bind(this);
    this.subtitlelist_setNewCorrectedSubtitles = this.subtitlelist_setNewCorrectedSubtitles.bind(this);
    this.subtitlelist_onUpdateSubtitles = this.subtitlelist_onUpdateSubtitles.bind(this);
    this.subtitlelist_onUpdateSubtitlesOnState = this.subtitlelist_onUpdateSubtitlesOnState.bind(this);
    this.subtitlelist_onSelectSubtitles = this.subtitlelist_onSelectSubtitles.bind(this);
    this.subtitlelist_onGoToTimeCodeFromCurrentSubtitleToVideo = this.subtitlelist_onGoToTimeCodeFromCurrentSubtitleToVideo.bind(this);
    this.subtitlelist_onGoToSubtitleFromTimeCode = this.subtitlelist_onGoToSubtitleFromTimeCode.bind(this);
    this.subtitlelist_onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle = this.subtitlelist_onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle.bind(this);
    this.subtitlelist_onProcessShortcutToEditListSubtitle = this.subtitlelist_onProcessShortcutToEditListSubtitle.bind(this);
    this.subtitlelist_onChangeCorrectedOrOriginalSubtitles = this.subtitlelist_onSwapSubtitles.bind(this);  

    this.subtitlelist_nextSubtitle = this.subtitlelist_nextSubtitle.bind(this)
    this.subtitlelist_prevSubtitle = this.subtitlelist_prevSubtitle.bind(this)
      
    this.subtitle_onChangeSubtitle = this.subtitle_onChangeSubtitle.bind(this);
    this.subtitle_onChangeIsPlaying = this.subtitle_onChangeIsPlaying.bind(this);

    this.state.undo = []
    this.state.redo = [];

    this.state.subtitles = []; // Liste des sous-titres
    this.state.currentSubtitleId = 0; // Index du sous-titre actif
    this.state.currentTimeCode = 0; // A voir ?????
    this.state.currentTimeCodePlayer = 0; 
    this.state.timecode = { // pour changer le timecode in ou out
      isTyping: false,
      isTimecodeOut: false,
      value: null,
      newTimeCodeString: null,
    };

    this.state.hasDisplayOriginalSubtitles = false;

    /*this.state.displaySubtitles = {
      hasDisplayOriginalSubtitles: false,
      original: {
        id: null,
        subtitles: [],
      },
      corrected: {
        id: null,
        subtitles: []
      }
    }*/
          
    this.state.showSubtitleNumber = false;

    this.subtitlesChanged = false;
    this.subtitlesToSave = null;
      
    this.grammalecte = new Grammalecte();

    // Gestion des queues des raccourcis
    this.actionQueue = [];
    this.isProcessingAction = false;

    this.enqueueAction = this.enqueueAction.bind(this);
    this.processNextAction = this.processNextAction.bind(this);
  
  }

    onClickOnErrorSubtitle (id)
    {
        var subtitle = null;
        if ((id >=0) && (id < this.state.subtitles.length))
          subtitle = this.state.subtitles[id];

        if (subtitle) {
          this.editListeStRef.current.setCurrentSubtitle(
            subtitle.id,
            this.editListeStRef.current.active
          );

          const editSubtitleRef = this.subtitle_GetEditSubtitleRef();
          editSubtitleRef.setCurrentSubtitle(subtitle, editSubtitleRef.active);

          this.app_subtitles_movetoSubtitle(subtitle.id);

          this.setState({ currentSubtitleId: subtitle.id });
        }
    }


    // *********************************************************************************************************************
    // formatage time code
    // *********************************************************************************************************************
    getTimeCodeString(time) {
      return V2_ConvertSecondToTimeCodeStringFromAsset(time, this.state.timecodeAsset, this.state.playerparams.displaytcms);
    } 
  
    getIntervalString(timebefore, time)
    {
      return V2_getIntervalStringFromAsset(timebefore, time, this.state.timecodeAsset, this.state.playerparams.displaytcms);
    }


    appSubtitles_computeAllSubtitles()
    {
      // to do
    }

    // *********************************************************************************************************************
    // keyboard Events
    // *********************************************************************************************************************
    onCancelKeyboardEvent(value)
    {
      this.cancelKeyboardEvent =  value;
    }

    handleKeyUp = (event) => {
        
      if (this.state.timecode.isTyping) {
        
        if (!event.ctrlKey) {
          this.onUpdateTimeCode();
          return;
        }

        return;
      }
              
      if (this.cancelKeyboardEvent) return;
              
      const ret = keyboard_special_up(event.code, event.key, event.shift, event.ctrl, event.alt);
        
      if (ret !== "") {
        var char = event.key;
        var code = char.codePointAt(0);
                
        if (code >= 32) {
          if (this.subtitle_GetEditSubtitleRef())
            this.subtitle_GetEditSubtitleRef().addChar(char);
          if (this.editListeStRef && this.editListeStRef.current)
            this.editListeStRef.current.addChar(char);
        }
                  
                
      }
        
    }
  
  enqueueAction(action) {
    this.actionQueue.push(action);


    this.processNextAction();
    
  }

  async processNextAction() {
    if (this.isProcessingAction) {
      return; // empêche la ré-entrance
    }

    this.isProcessingAction = true;

    while (this.actionQueue.length > 0) {
      const action = this.actionQueue.shift();
      await action();
    }

    this.isProcessingAction = false;
  }
  
  async handleKeyDown(e)
  {
    this.reantrance=true;

    
    await this.handleKeyDown2(e)
    this.reantrance=false;
  }

  handleKeyDown2 = async (event) => {
        
    
    if (this.cancelKeyboardEvent) return;
    
    if (this.state.displayCommonRaccourcis) {
      if (this.commonRaccourcisRef && this.commonRaccourcisRef.current) {
        this.commonRaccourcisRef.current.handleKeyDown(event);
        return;
      }
    }
      
    if ((this.containerBlockRef) && ((this.containerBlockRef).current))
      this.containerBlockRef.current.focus();
    

    if (keyboard_special_down(event.code, event.key, event.shiftKey, event.ctrlKey, event.altKey)) return;
    

    if (this.videoPlayerRef) {
      if (this.videoPlayerRef.current.keyboard_multi_gereKeyBoard(this.shortcuts_list, event.key, event.shiftKey, event.ctrlKey, event.altKey)) {
        event.preventDefault();
        return;
      }
    }
    
    var key = keyboard_multi_getKey("subtitling",
      this.shortcuts_list,
      event.key,
      event.shiftKey,
      event.ctrlKey,
      event.altKey
    );

    console.log ("key=", key)

    switch (key)
    {
      case "QUICKOFFSET":
        this.setOffset(false);
        break;

      case "SEARCH":
         event.preventDefault();
        if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
        {
            this.appMediaAssetsRef.current.displayOption ('subtitles','search');
        }
        return;
      case "REPLACE":
        event.preventDefault();
        if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
        {
            this.appMediaAssetsRef.current.displayOption ('subtitles','replace');
        }
        return;
    }
    

    if (event.ctrlKey) {
      const { isTyping, isTimeCodeOut } = this.state.timecode;

      const fired = !event.shiftKey || event.altKey;

      if ((isTyping && key && !key.includes('TIMECODE')) || !fired) {
        setTimeout(() => {
          this.setState({
            timecode: {
              ...this.state.timecode,
              isTyping: false,
              isTimeCodeOut: false,
            },
          });
        }, 50);
      } else {
        if (!isTyping || isTimeCodeOut !== event.altKey) {

          if(isTimeCodeOut !== event.altKey){
            this.onUpdateTimeCode();
            await wait(100);
          }

          this.setState({
            timecode: {
              ...this.state.timecode,
              isTyping: true,
              isTimeCodeOut: event.altKey,
            },
          });
        }
      }
    }
    
    if (key !== '' || event.key.length === 1) {

      if (key === "PASTE") {
        startClipboardRead();
      }

      this.enqueueAction(async () => {
        
        await this.processShortcut(event, key);
      });
    }
    
  };

    processShortcut = (event, key) => {    
    
      if (key !== '') {
                  
        event.preventDefault();

        console.log("process", event,key)        

        if ((key === "MODEA") || (key === "MODEB") || (key === "MODEC"))
        {
          switch (key)
          {
            case "MODEA":
              setCurrentMode ({modeA: !this.state.modeA, modeB: this.state.modeB, modeC: this.state.modeC});
              this.updateToggleValueInToolBar("LOCKVIDEO", !this.state.modeA);
              this.setState({modeA: !this.state.modeA})
              break;
            case "MODEB":
              setCurrentMode ({modeA: this.state.modeA, modeB: !this.state.modeB, modeC: this.state.modeC});
              this.updateToggleValueInToolBar("LOCKSUBTITLES", !this.state.modeB);
              this.setState({modeB: !this.state.modeB})
              break;
            case "MODEC":
              setCurrentMode ({modeA: this.state.modeA, modeB: this.state.modeB, modeC: !this.state.modeC});
              this.updateToggleValueInToolBar("SIMUL", !this.state.modeC);
              this.setState({modeC: !this.state.modeC})
              break;
          }
          return;
        }

        if (key === "CHANGESUBTITLE") {
          this.subtitlelist_onSwapSubtitles();
          return;
        }


        
        if (key === 'GOTOSUBTITLENUMBER') {
          this.setState({ displayGoToSubtitleNumber: true });
          return;
        }

        if (key === 'SHOWORHIDESUBTITLENUMBER') {
          this.setState({ showSubtitleNumber: !this.state.showSubtitleNumber });
          return;
        }

        if (key === "SETTIMECODEFROMCURRENTSUBTITLETOVIDEO") {
          this.subtitlelist_onGoToTimeCodeFromCurrentSubtitleToVideo();
         
          return;
        }

        if(key === "SETCURRENTSUBTITLEFROMTIMECODE") {
          this.subtitlelist_onGoToSubtitleFromTimeCode();
          return;
        }

        if (key === "BESTLISIBILITY")
        {
          this.subtitlelist_onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle(key);
          return;
        }
          

        if (key === "TAKEIN" || key === "TAKEOUT") {
          
          
          this.subtitlelist_onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle(key);
          return;
        }

        if (key.includes('TIMECODEIN') || key.includes('TIMECODEOUT')) {  
          this.onKeyDownTimeCode(event, key);
          return;
        }

        if (key === "DISPLAYTABLECHAR") {
          this.setState({ displayCommonTableCaracteres: true });
          return;
        }

        if (key === "FIRSTSUBTITLE" || key === "LASTSUBTITLE") {

          const currentSubtitle = key === "FIRSTSUBTITLE" ? first(this.state.subtitles) : last(this.state.subtitles);
          
          const from = this.subtitlelist_getFromComponentActive();
          this.subtitlelist_move(currentSubtitle.id, currentSubtitle.in, from);
          
          return;
        }

        if (key === 'PGUP') {
          this.subtitlelist_prevSubtitle();
          return;
        }
    
        if (key === 'PGDOWN') {
          this.subtitlelist_nextSubtitle();
          return;
        }

        if (key === 'DELETESUBTITLE') {
          this.subtitlelist_onDeleteSubtitle();
          return;
        }
    
        if (key === 'INSERTSUBTITLEAFTERCURRENTSUBTITLE' || key === 'INSERTSUBTITLEBEFORECURRENTSUBTITLE') {
          this.subtitlelist_onInsertSubtitle(key);
          return;
        }

        if (key === "PLAYMODECONCE") {
          if (this.videoPlayerRef && this.videoPlayerRef.current) {
            this.setState({ modeSimulation: true })
            this.videoPlayerRef.current.play();
          }

          return;
        }

        if (key === 'WORDCHECKER') {
          this.subtitlelist_onSubtitlesChecker();
          return;
        }

        if (key === 'GOTOWORDINERROR') {
          this.subtitlelist_onGoToWordInError();
          return;
        }

        if (key === "SETLISIBILITY") {
          this.subtitlelist_onSetLisibilityOnAllSubtitles();
          return;
        }
        
        if (this.subtitle_GetEditSubtitleRef())
        {
          //this.subtitle_GetEditSubtitleRef().cptCurs = 0;
          this.subtitle_GetEditSubtitleRef().processShortcut(key, event);
        }
        
        if (this.editListeStRef && this.editListeStRef.current)
        {
          //this.editListeStRef.current.cptCurs = 0;
          this.editListeStRef.current.processShortcut(key, event);
        }
    
        return;
      }
    
      


      var char = event.key;
      if (char.length === 1) {
          
        var code = char.codePointAt(0);
        if (code >= 32) {
          if (this.subtitle_GetEditSubtitleRef())
          
            this.subtitle_GetEditSubtitleRef().addChar(char);
          if (this.editListeStRef && this.editListeStRef.current)
            this.editListeStRef.current.addChar(char);
        }
      }
      
    }

    // *********************************************************************************************************************
    // timeline Events
    // *********************************************************************************************************************
  
  
  // *********************************************************************************************************************
  // onKeyDownTimeCode permet d'afficher le nouveau timecode sur le sous-titre courant en temps réel
  // *********************************************************************************************************************
  onKeyDownTimeCode(event, key) {

    const { subtitles, currentSubtitleId } = this.state;
    const currentSubtitle = subtitles[currentSubtitleId];

    if (key === 'TAKETIMECODEOUTFROMPREVSUBTITLETOINCURRENTSUBTITLE' ||
      key === 'TAKETIMECODEINFROMNEXTSUBTITLETOOUTCURRENTSUBTITLE') {
      
      const actionType = key === 'TAKETIMECODEOUTFROMPREVSUBTITLETOINCURRENTSUBTITLE' ?
        'onTakeTimeCodeFromPrevSubtitleToCurrentSubtitle' : 'onTakeTimeCodeFromNextSubtitleToCurrentSubtitle';
      
      const undoRedo = {
        undo: {
          id: currentSubtitle.id,
          actionType,
          subtitle: cloneDeep(currentSubtitle),
        },
        redo: undefined,
      };

      if (key === 'TAKETIMECODEOUTFROMPREVSUBTITLETOINCURRENTSUBTITLE') {
        const prevSubtitle = subtitles[currentSubtitleId - 1];
        //if (!prevSubtitle) { // on doit aussi appeller la fonction pour cherche un cp avant
        //  return;
        //}
        
        var newIn = getTCInFromPreviousSTorCP(
          currentSubtitle,
          prevSubtitle,
          this.state.subtitleParameters,
          this.getFirstTimeCode(),
          this.state.internalcplist
        );

        if (prevSubtitle && currentSubtitle.in < prevSubtitle.out)
        {
            newIn = prevSubtitle.out + this.state.subtitleParameters.interst;
            if (newIn > currentSubtitle.out) newIn = currentSubtitle.out;
        }


        currentSubtitle.in = newIn;

      } else {
        
        const nextSubtitle = subtitles[currentSubtitleId + 1];
        //if (!nextSubtitle) {
        //  return;
        //}

        var newOut = getTCOutFromNextSTorCP(
          currentSubtitle,
          nextSubtitle,
          this.state.subtitleParameters,
          this.getFirstTimeCode(),
          this.state.internalcplist
        );


        if (nextSubtitle && currentSubtitle.out > nextSubtitle.in)
        {
            newOut = nextSubtitle.in - this.state.subtitleParameters.interst;
            if (newOut < currentSubtitle.in) newOut = currentSubtitle.in;
        }




        currentSubtitle.out = newOut;
      }

      currentSubtitle.lisibility = getLisibility(currentSubtitle, this.state.subtitleParameters);

      undoRedo.redo = {
        id: currentSubtitle.id,
        actionType,
        subtitle: cloneDeep(currentSubtitle),
      };

      this.subtitlelist_addNewActionForUndo(undoRedo);
      this.subtitlelist_change(currentSubtitle, null, false);
      return;
      
    }

    const isTimeCodeOut = key.includes('TIMECODEOUT');

    if (key.includes('INCREASE') || key.includes('DECREASE')) {
      const isIncrease = key.includes('INCREASE');

      let timecodeSeconds = this.state.timecode.value
        ? this.state.timecode.value
        : isTimeCodeOut
        ? currentSubtitle.out
        : currentSubtitle.in;

      
      
      var STC = V2_ConvertSecondToTimeCodeStringFromAsset(
        timecodeSeconds,
        this.state.timecodeAsset,
        this.state.playerparams.displaytcms
      );

      
      const incrementSeconds = V2_GetOneFrameDurationFromAsset(this.state.timecodeAsset);

      if (isIncrease) {
        timecodeSeconds += incrementSeconds;
      } else {
        timecodeSeconds -= incrementSeconds;

        if (timecodeSeconds < 0) {
          return;
        }
      }

      
      STC = V2_ConvertSecondToTimeCodeStringFromAsset(
        timecodeSeconds,
        this.state.timecodeAsset,
        this.state.playerparams.displaytcms
      );
      

      


      const newTimeCodeString = V2_ConvertSecondToTimeCodeStringFromAsset(
        timecodeSeconds,
        this.state.timecodeAsset,
        this.state.playerparams.displaytcms
      );

      this.setState({
        timecode: {
          isTyping: true,
          isTimeCodeOut,
          newTimeCodeString,
          value: timecodeSeconds,
        },
      });

      setTimeout(() => this.onUpdateTimeCode(false), 50);

      return;
    }

    const value = this.state.timecode.value
      ? this.state.timecode.value + event.key
      : event.key;

    const time = this.getTimeCodeString(
      isTimeCodeOut ? currentSubtitle.out : currentSubtitle.in
    );

    let newTimeCodeString;
    if (this.state.playerparams.displaytcms) {
      if (value.length > 9) {
        return;
      }

      let sanitizedTime = time.replace(/[:.]/g, '');
      const sanitizedTimeArr = sanitizedTime.split('');

      for (let i = 0; i < value.length; i++) {
        sanitizedTimeArr[sanitizedTimeArr.length - i - 1] =
          value[value.length - i - 1];
      }

      const hoursStr = sanitizedTimeArr[0] + sanitizedTimeArr[1];
      const minutesStr = sanitizedTimeArr[2] + sanitizedTimeArr[3];
      const secondsStr = sanitizedTimeArr[4] + sanitizedTimeArr[5];
      const millisecondsStr = sanitizedTimeArr.join('').substring(6);

      newTimeCodeString = `${hoursStr}:${minutesStr}:${secondsStr}.${millisecondsStr}`;
    } else {
      if (value.length > 8) {
        return;
      }

      let sanitizedTime = time.replace(/[:.]/g, '');
      sanitizedTime = sanitizedTime.padStart(8, '0');
      const sanitizedTimeArr = sanitizedTime.split('');

      for (let i = 0; i < value.length; i++) {
        sanitizedTimeArr[sanitizedTimeArr.length - i - 1] =
          value[value.length - i - 1];
      }

      const hoursStr = sanitizedTimeArr[0] + sanitizedTimeArr[1];
      const minutesStr = sanitizedTimeArr[2] + sanitizedTimeArr[3];
      const secondsStr = sanitizedTimeArr[4] + sanitizedTimeArr[5];
      const millisecondsStr = sanitizedTimeArr[6] + sanitizedTimeArr[7];

      newTimeCodeString = `${hoursStr}:${minutesStr}:${secondsStr}:${millisecondsStr}`;
    }

    this.setState({
      timecode: {
        isTyping: true,
        isTimeCodeOut,
        newTimeCodeString,
        value,
      },
    });
  }

  // *********************************************************************************************************************
  // onUpdateTimeCode permet de mettre à jour le nouveau timecode sur le sous-titre courant
  // *********************************************************************************************************************
  onUpdateTimeCode(clearState = true) {
    const { newTimeCodeString, isTimeCodeOut } = this.state.timecode;

    if (!newTimeCodeString) {
      this.setState({
        timecode: {
          isTyping: false,
          isTimeCodeOut: false,
          value: null,
          newTimeCodeString: null,
        },
      });
      return;
    }

    const currentSubtitle = this.state.subtitles[this.state.currentSubtitleId];

    

    if (currentSubtitle) {
      // historiser
      const undoRedo = {
        undo: {
          id: currentSubtitle.id,
          actionType: 'onUpdateTimeCode',
          subtitle: cloneDeep(currentSubtitle),
        },
        redo: undefined,
      };


      
      const validity = V2_checkTimeCode(
        newTimeCodeString,
        this.state.timecodeAsset
      );


      if (!validity) {
        // on réinitialise le state
        this.setState({
          timecode: {
            isTyping: false,
            isTimeCodeOut: false,
            value: null,
            newTimeCodeString: null,
          },
        });

        return;
      }


      

      const totalSeconds = V2_ConvertTimeCodeStringToSecondFromAsset(newTimeCodeString, this.state.timecodeAsset);




      if (isTimeCodeOut) {
        currentSubtitle.out = totalSeconds;
      } else {
        currentSubtitle.in = totalSeconds;
      }

      currentSubtitle.lisibility = getLisibility(currentSubtitle, this.state.subtitleParameters);

      undoRedo.redo = {
        id: currentSubtitle.id,
        actionType: 'onUpdateTimeCode',
        subtitle: cloneDeep(currentSubtitle),
      };

      this.subtitlelist_addNewActionForUndo(undoRedo);
      this.subtitlelist_change(currentSubtitle, null, false);
    }

    if (clearState) {
      // on réinitialise le state
      this.setState({
        timecode: {
          isTyping: false,
          isTimeCodeOut: false,
          value: null,
          newTimeCodeString: null,
        },
      });
    }
  }

addcp(base64, timecode)
  {
      

      
      const cp = globalIsACp(timecode,this.state.subtitleParameters.cplist, 0.020);
      if (cp !== null)
      {
          this.state.subtitleParameters.cplist.splice(cp.index, 1);
          // la time line
          if ((this.timelineRef) && (this.timelineRef.current))
            this.timelineRef.current.setNewCPList(this.state.subtitleParameters.cplist,this.currentVideoId);
          return;
      }




      const newcp = {
        offset:0, size:0, time:timecode, base64:base64, tc: this.getTimeCodeString(timecode),
      }

      if (this.timelineRef.current)
      {

          this.state.subtitleParameters.cplist = this.timelineRef.current.getCPList();
          this.setState({subtitleParameters: this.state.subtitleParameters});
      }

      
      this.state.subtitleParameters.cplist = globalAddCP(this.state.subtitleParameters.cplist, newcp);
      this.setState({subtitleParameters: this.state.subtitleParameters});
     

      // la time line
      if ((this.timelineRef) && (this.timelineRef.current))
        this.timelineRef.current.setNewCPList(this.state.subtitleParameters.cplist);


  }
  onMouseUpOnSubtitle (data)
  {
    // faut il reorganiser les sous titres
    if (data.type == "tcst")
    {


      var subtitles = [];
      if ((this.editListeStRef) && (this.editListeStRef.current))
          subtitles = this.editListeStRef.current.getSubtitles();
      
          

      if (!subtitles)
      {
          if ((this.editSubtitleRef) && (this.editSubtitleRef.current))
              subtitles = this.editSubtitleRef.current.getSubtitles();
      }

      
      
      var sort = false;
      var currentSubtitleId = data.id;
      if (currentSubtitleId !== 0)
        if (subtitles[currentSubtitleId-1].in > subtitles[currentSubtitleId].in)
          sort = true;
        
      if (currentSubtitleId !== (subtitles.length -1))
        if (subtitles[currentSubtitleId+1].in < subtitles[currentSubtitleId].in)
          sort = true;
      if (sort)
      {
        for (var nust=0; nust < subtitles.length; nust++)
          subtitles[nust].id = nust;

        // ***************************************************
        var sortedSubtitles = [...subtitles].sort((a, b) => a.in - b.in);
        var newcurrentid= -1;
        for (var nust=0; nust < sortedSubtitles.length; nust++)
        {
          if ((sortedSubtitles[nust].id === currentSubtitleId) && (newcurrentid === -1))
            newcurrentid = nust;
          sortedSubtitles[nust].id = nust;
          this.checkSubtitle(sortedSubtitles,nust-1,nust,nust+1)
        }

        // a supprimer test sur erreur
        sortedSubtitles.forEach((st,index)=>{
          if (st.tcstatus !==0 ) 
            console.log("erreur tc sur st", index+1, st.tcstatus)
        })

        

        if (newcurrentid !== -1) currentSubtitleId = newcurrentid;
        

        if (this.editListeStRef && this.editListeStRef.current) 
            this.editListeStRef.current.updateSubtitles(sortedSubtitles);
        this.subtitlelist_onUpdateSubtitlesOnState(sortedSubtitles, currentSubtitleId);

        // on informe la time line
        const indexst = this.timelineRef.current.getIndexByType("st");
        // on ajoute la piste de sous-titre si elle n'existe pas
        if (indexst !== -1)
        {
          this.timelineRef.current.setNewST(sortedSubtitles);
          
          this.timelineRef.current.forceRecreate();

        }

        this.setState({ subtitles:sortedSubtitles , currentSubtitleId});
      }
      
    }
  }

  onNewSubtitleTimeCode(data) {

    

    const { subtitles } = this.state;      
      
    var currentSubtitle = subtitles.find((x) => x.id === data.id);
    if (!currentSubtitle) {
      return;
    }

    /*« tcin » seul le tcin a changé, la valeur est dans value1, 
        « tcout » seul le tcout a changé, la valeur est dans value2, 
         « tcst » le tcin et tcout ont changés, les valeurs sont dans valeur1 et valeur2 */

    switch (data.type) {
      case 'tcin':
        currentSubtitle.in = data.value1;
        break;

      case 'tcout':
        currentSubtitle.out = data.value2;
        break;

      case 'tcst':
        currentSubtitle.in = data.value1;
        currentSubtitle.out = data.value2;
        
        break;

      default:
        return;
    }

    var currentSubtitleId = currentSubtitle.id;

    switch (data.type) {
      case 'tcin':
        this.checkSubtitle(
          subtitles,
          currentSubtitleId - 2,
          currentSubtitleId - 1,
          currentSubtitleId
        );
        this.checkSubtitle(
          subtitles,
          currentSubtitleId - 1,
          currentSubtitleId,
          currentSubtitleId + 1
        );
        break;

      case 'tcout':
        this.checkSubtitle(
          subtitles,
          currentSubtitleId - 1,
          currentSubtitleId,
          currentSubtitleId + 1
        );
        this.checkSubtitle(
          subtitles,
          currentSubtitleId,
          currentSubtitleId + 1,
          currentSubtitleId + 2
        );
        break;

      case 'tcst':



        this.checkSubtitle(
          subtitles,
          currentSubtitleId - 2,
          currentSubtitleId - 1,
          currentSubtitleId
        );
        this.checkSubtitle(
          subtitles,
          currentSubtitleId - 1,
          currentSubtitleId,
          currentSubtitleId + 1
        );
        this.checkSubtitle(
          subtitles,
          currentSubtitleId,
          currentSubtitleId + 1,
          currentSubtitleId + 2
        );
        break;

      default:
        break;
    }

    // on met à jour le sous-titre dans le state
    this.setState({ subtitles , currentSubtitleId});
  
    if (this.editListeStRef && this.editListeStRef.current) {
      this.editListeStRef.current.updateSubtitles(subtitles, currentSubtitleId);
    }

    if (this.subtitle_GetEditSubtitleRef())
    {
      const updatedSubtitle = subtitles[currentSubtitleId];
      this.subtitle_GetEditSubtitleRef().updateSubtitle(updatedSubtitle);
    }

    this.setSubtitlesChange(subtitles);
    
  }

  checkSubtitle(subtitles, prevId, id, nextId) {

    var prev = subtitles[prevId];
    var current = subtitles[id];
    var next = subtitles[nextId];

    const ret = this.app_subtitles_checkSubtitle(prev, current, next);
    if (ret !== null) {
      current.tcstatus = ret.tcstatus;
      current.ststatus = ret.ststatus;
      current.textstatus = ret.textstatus;
    }
  }

    handleGotoTime(value)
    {
      if ((this.videoPlayerRef) && (this.videoPlayerRef.current)) {
        this.videoPlayerRef.current.goto(value);
      }

      if (this.timelineRef && this.timelineRef.current) {
        this.timelineRef.current.setCurrentTime(value);
      }
    }
  
  onChangeTimeLineZoom(value)
  {
    if (this.timelineRef && this.timelineRef.current) 
      this.timelineRef.current.setZoom(value);

  }

  handleTimeLineWheel(value) {

    const currentTime = this.state.currentTimeCode + value;

    if (this.videoPlayerRef && this.videoPlayerRef.current) {
      this.videoPlayerRef.current.addtime(value);
    }

    if (this.timelineRef && this.timelineRef.current) {
      this.timelineRef.current.setCurrentTime(currentTime);
    }

  }
    
    // *********************************************************************************************************************
    // app subtitles specifics functions
    // *********************************************************************************************************************

    ondetectionButton(datas)
    {
      var newtimecode = {};
      switch (datas.button)
      {
          case "takein":
            newtimecode.type = "tcin";
            newtimecode.value2 = -1;
            newtimecode.value1 = datas.value;
            newtimecode.id = this.state.currentSubtitleId;
            
            this.onNewSubtitleTimeCode(newtimecode);
            break;
          case "takeout":
            newtimecode.type = "tcout";
            newtimecode.value1 = -1;
            newtimecode.value2 = datas.value;
            newtimecode.id = this.state.currentSubtitleId;
            this.onNewSubtitleTimeCode(newtimecode);
            break;
      }
    }

    // *********************************************************************************************************************
    // app_subtitles_movetoSubtitle permet de déplacer le bon sous-titre sur la timeline
    // *********************************************************************************************************************
    app_subtitles_movetoSubtitle(subtitlenumber)
    {
      if (subtitlenumber === this.state.currentSubtitleId) {
        return;
      }

      if (this.timelineRef && this.timelineRef.current) {
        this.timelineRef.current.setCurrentSubtitle(subtitlenumber);
      }
    }

    app_subtitles_checkSubtitle(previous, st, next)
    {
      const num = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum;
      const den = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden;
      const timecode = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vitimecode:this.state.timecodeAsset.astimecode;
      const dropframe =  "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vidropframe:this.state.timecodeAsset.asdropframe;

      return checkSubtitle(previous, st, next, this.state.subtitleParameters,num,den,dropframe,timecode);
    }



    appSubtitles_SetCurrentToAssetsManager()
    {
      if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
        {
          this.assetsManagerRef.current.setNewCurrent(
          {
            video: this.currentVideoId,
            originaltr: this.currentOriginalTranscription,
            correctedtr: this.currentCorrectedTranscription,
            calculatedsubtitles: this.currentOriginalSubtitleId,
            correctedsubtitle: this.currentCorrectedSubtitleId,
            finaltr: 0,             
            sequences: this.currentSequencesId,       
        })
        }

        this.setState ({blocks: this.V2_SetCurrentAssetsToBlock(this.state.blocks)});

    }    
    appSubtitles_FirstDownloadProjectAssets()
    {
      // Premier lancement de l'app, on charge la liste des assets pour determiner les assets de départ
      if (this.app_FirstassetsDownloaded) return;
      if (this.state.pjid !== 0)
        apiSearchAssetsFromProject({pjid: this.state.pjid}, this.appSubtitles_SearchFirstCurrentAssets); // C'est le grand départ
      this.app_FirstassetsDownloaded = true;
    }

    appSubtitles_SearchFirstCurrentAssets(datas)
    {
      this.assetsList = datas;

      this.currentVideoId = -1;
      this.currentOriginalSubtitleId = -1;
      this.currentCorrectedSubtitleId = -1;
      this.currentOriginalTranscription = -1;
      this.currentCorrectedTranscription = -1;



      // Stade 1 , on regarde si on a une vidéo
      this.appSubtitles_checkOpenFirstVideo();

      // Stade 2, on regarde si on a un fichier de subtitles corrigés
      var asset = appAsset_getFirstAssetByType(this.assetsList, 5);
      if (asset !== null)
      {
          this.currentCorrectedSubtitleId = asset.asid;
          apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetCorrected);
          // on regarde si on a des sous-titres calculés par rapport à ces sous-titres
          asset = appAsset_getAssetById(this.assetsList, asset.asoriid);
          if (asset !== null)
          {
            apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetOriginal);
          }
      

      } 
      else
      {
          asset = appAsset_getFirstAssetByType(this.assetsList, 4);
          if (asset !== null)
          {
              
              apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetOriginal);
              // il faut créer maintenant des sous-titres à partir de ça
              // on peut en créer une à partir de l'original

              const pjid = getCurrentProjectDatas().pjid;
              var datas  = 
              {
                asid: 0,
                aspjid: pjid,
                astype: 5, // sous titres  corrigés
                asviid: asset.asviid,
                asoriid: asset.asid, // transcription originale
                astitle: asset.astitle,
                asfile: appAsset_generateUUID(),
                originalfile: asset.asfile,
                aslang: asset.aslang,
                asext: asset.asext,
                assubtype: asset.assubtype,
                ascreatedate: appAsset_getCurrentDate(),
                asupdatedate: appAsset_getCurrentDate(),
                asframerate: asset.asframerate,
                asnum: asset.asnum,
                asden: asset.asden,
                asdropframe: asset.asdropframe,
                astimecode: asset.astimecode,
                ascoid: asset.ascoid,
              }

              
              
              apiCreateFromAsset(datas, this.appSubtitles_apiCallBackCreateOneAssetFromOriginal)





          }
          else
          {
            // aucun fichier de sous-titres

            // ici on met un popup

              this.setState({
                createANewSubtitleFilePopup: true,
                popupText: {
                  "fr":"Ce projet ne contient aucun fichier de sous-titres. Voulez vous créer en créer un ?",
                  "en": "This project does not contain any subtitles file. Do you want to create a new subtitles file?"
                }
              })
              return;
            

          }
      }

    }

    onCreateNewSubtitleFile()
    {
        this.setState({
          createANewSubtitleFilePopup: false,
          popupText: "",
        });
        
      var asset = appAsset_getFirstAssetByType (this.assetsList, 3);
      var asframerate = 25;
      var asnum = 25;
      var asden = 1;
      var asdropframe = 0;
      var astimecode = "00:00:00:00"
      var asviid = 0;
      var title = this.context.language=="fr"?"Nouveaux sous-titres":"New subtitles";

      if (asset)
      {
        asframerate = asset.asframerate;
        asnum = asset.asnum;
        asden = asset.asden;
        asdropframe = asset.asdropframe;
        astimecode = asset.astimecode;
        asviid = asset.asviid;
        title = asset.astitle;
      }

      this.state.subtitleParameters = configurations_getDefaultParams(asnum,asden,asdropframe);
      this.setState({subtitleParameters: this.state.subtitleParameters});

      // on fait un subtitle file vide

      const newSubtitles = [
          {
            id: 0,
            in:0,
            out:0,
            len:0,
            lines:[
              {
                len:0,
                verticalPos:this.state.subtitleParameters.verticalPos,
                align:this.state.subtitleParameters.defaultAlignment,
                words:[],
              }
            ],
            mark:0,
          }
        ];
      
      const jsondatas = {
        pjid: this.state.pjid,
        subtitles: newSubtitles,
        version: getCurrentVersion(),
        params: this.state.subtitleParameters,
      }

      const memoryFile = new File([JSON.stringify(jsondatas)], "", 
      {
      type: "application/json", // MIME type for JSON
      lastModified: new Date().getTime() // Timestamp for the file
      });
      

      

      const formulaire = {

        ext: "json",
        filename:"",
        subtype:0,
        type: 5,
        asframerate:asframerate,
        asnum:asnum,
        asden:asden,
        astimecode: astimecode,
        asdropframe: asdropframe,
        asviid:asviid,
        ascoid:getCurrentProjectDatas().pjconfig,

        title: title,
        language: this.context.language=="fr"?"fr":"en",
        uploadfile: memoryFile,
      }

      

      UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 5,this.restartReloadPage);    

      
      this.subtitlelist_onUpdateSubtitlesOnState(newSubtitles, 0);
    }

    restartReloadPage()
    {

      
      this.assetsManagerRef.current.reloadAllAssets();

      setTimeout(() => {
        this.app_FirstassetsDownloaded = false;
        this.appSubtitles_FirstDownloadProjectAssets(); // C'est parti
      }, 1000);


    }

    returnToMainPage()
    {
        this.setState({
          createANewTranscriptionPopup: false,
          popupText: "",
        });
        SideBarRef.current.gotoRoute("localprojects");
    }
    // ******************************************************
    //  call back lecture/ creation assets original/ corrigé
    // ******************************************************
    appSubtitles_apiCallBackCreateOneAssetFromOriginal(datas)
    {
        if ((this.assetsManagerRef)&&(this.assetsManagerRef.current))
        {
            if (datas.ret)
            {
              this.assetsManagerRef.current.reloadAllAssets();
              apiReadOneAsset ({asid: datas.id}, this.appSubtitles_apiCallBackReadOneAssetCorrected);
            };
          }
    }

    appSubtitles_apiCallBackReadOneAssetOriginal(datas)    
    {
      this.appSubtitles_apiCallBackReadOneAsset(datas,true)  
    }
    appSubtitles_apiCallBackReadOneAssetCorrected(datas)    
    {
      
      this.appSubtitles_apiCallBackReadOneAsset(datas,false)  
    }


    appSubtitles_readCorrectedTranscription(asoriid)
    {
      
      var asset = appAsset_getAssetById(this.assetsList, asoriid);
      if (asset)
      {
        if (asset.astype === 2) // corrected transcription
        {
          
          apiReadOneAsset ({asid: asoriid}, this.appSubtitles_apiCallBackReadOneAsset);
          if (asset.asoriid > 0)
            apiReadOneAsset ({asid: asset.asoriid}, this.appSubtitles_apiCallBackReadOneAsset);
        }
      }
    }


    appSubtitles_apiCallBackReadOneAsset(datas,original=true)
    {
        if (datas.ret)
        {
            switch (datas.astype)
            {
              case 1:     // original transcription
                
                this.currentOriginalTranscription = datas.asid;
                


                
                // compatibilité avec ancienne version
                var alldatas = JSON.parse(datas.asdatas);
                var transcription = alldatas;
                if ("transcription" in alldatas)
                  transcription = alldatas.transcription;    
                
                this.appSubtitles_SetCurrentToAssetsManager();

                var indextr = this.timelineRef.current.getIndexByType("trjson");
                if (this.currenttimelineparams.storiginaltr)
                {

                  if (indextr == -1)
                    this.timelineRef.current.addTrack ("trjson",transcription, datas.astitle,"",0,this.currentOriginalTranscription);
                  else
                    this.timelineRef.current.setNewDatas (indextr, transcription, this.currentOriginalTranscription);
                    this.timelineRef.current.forceRecreate();
                }
                this.currenttimelineparams.storiginaltr = true;
                
                if ((this.transcriptRef) && (this.transcriptRef.current))
                    this.transcriptRef.current.setOriginalTranscription(transcription,datas.asid,-1,datas.astitle,datas.asfile);

                break;
              case 2:     // corrected transcription
                this.currentCorrectedTranscription = datas.asid;

                // compatibilité avec ancienne version
                var alldatas = JSON.parse(datas.asdatas);
                
                var transcription = alldatas;
                if ("transcription" in alldatas)
                    transcription = alldatas.transcription;               

                this.appSubtitles_SetCurrentToAssetsManager();
                var indextr = this.timelineRef.current.getIndexByType("newtrjson");
                // on ajoute la piste de transcription si elle n'existe pas

                if (this.currenttimelineparams.stcorrectedtr)
                {

                  if (indextr == -1)
                    this.timelineRef.current.addTrack ("newtrjson",transcription, datas.astitle,"",0,this.currentCorrectedTranscription);
                  else
                    this.timelineRef.current.setNewDatas (indextr, transcription, this.currentCorrectedTranscription);
                    this.timelineRef.current.forceRecreate();
                }

                this.currenttimelineparams.stcorrectedtr = true;

                if ((this.transcriptRef) && (this.transcriptRef.current))
                    this.transcriptRef.current.setTranscription(transcription,datas.asid,-1,datas.astitle,datas.asfile);

                break;
              case 4:     // computed subtitles
                // c'est toujours des originaux
                
                this.currentOriginalSubtitleId = datas.asid;
                this.appSubtitles_SetCurrentToAssetsManager();
                var subtitles   = JSON.parse(datas.asdatas);

                const indexst = this.timelineRef.current.getIndexByType("oldst");
                // on ajoute la piste de sous-titre si elle n'existe pas

                if (this.currenttimelineparams.storiginalst)
                {
                    if (indexst === -1)
                      this.timelineRef.current.addTrack ("oldst",[], "subtitles", "",0,this.currentOriginalSubtitleId);
        
                    this.timelineRef.current.setNewSubtitlesByType(subtitles.subtitles, this.currentOriginalSubtitleId,"oldst");
                    this.timelineRef.current.forceRecreate();
                }
                this.currenttimelineparams.storiginalst = true;
                this.appSubtitles_readCorrectedTranscription(datas.asoriid);

                break;
              case 5:     // corrected subtitles
                  if (original)
                  {
                    
                    this.currentOriginalSubtitleId = datas.asid;
                    this.appSubtitles_SetCurrentToAssetsManager();
                    var subtitles   = JSON.parse(datas.asdatas);

                    const indexst = this.timelineRef.current.getIndexByType("oldst");
                    // on ajoute la piste de sous-titre si elle n'existe pas
                    if (indexst === -1)
                      this.timelineRef.current.addTrack ("oldst",[], "subtitles", "",0,this.currentOriginalSubtitleId);
            
                    this.timelineRef.current.setNewSubtitlesByType(subtitles.subtitles, this.currentOriginalSubtitleId,"oldst");
                    this.timelineRef.current.forceRecreate();

                    // on regarde si on a une transcription à partir de ces souis-titres calculés
                    this.appSubtitles_readCorrectedTranscription(datas.asoriid);

                    


                  }
                  else
                  {
                    // corrigés                    
                    this.currentCorrectedSubtitleId = datas.asid;
                    this.appSubtitles_SetCurrentToAssetsManager();
                    var subtitles = JSON.parse(datas.asdatas);

                    if ("params" in subtitles)
                    {
                      this.state.subtitleParameters = subtitles.params;
                    }

                    this.state.subtitleParameters = configurations_framestotime(subtitles.params,datas.asnum, datas.asden, datas.asdropframe);
                    this.setState({subtitleParameters:  this.state.subtitleParameters});

                    const indexst = this.timelineRef.current.getIndexByType("st");
                    // on ajoute la piste de sous-titre si elle n'existe pas
                    if (indexst === -1)
                       this.timelineRef.current.addTrack ("st",[], "subtitles", "",0,this.currentCorrectedSubtitleId);
                    
                    this.timelineRef.current.setNewSubtitlesByType(subtitles.subtitles, this.currentCorrectedSubtitleId,"st");
                    this.timelineRef.current.setParamsST(this.state.subtitleParameters);
                    this.timelineRef.current.forceRecreate();
                    
                    this.subtitlelist_setNewCorrectedSubtitles(this.currentCorrectedSubtitleId, subtitles);
                    // on recupere la configuration $$$
                  
                    if ((this.appsettingsRef) && (this.appsettingsRef.current))
                      this.appsettingsRef.current.setNewStParams(subtitles.params)
                    if (datas.ascoid >0 )
                       this.loadCurrentConfiguration(datas.ascoid);
                    
                  }
              break;

            }
        }
    }

    // *****************************
    //  lecture video
    // *****************************
    

    appSubtitles_checkOpenFirstVideo()
    { // recherche de la peemière vidéo utilisable
      if (this.currentVideoId>=0) return; // déja chargée 
      var asset = appAsset_getFirstAssetByType (this.assetsList, 3);
      this.appSubtitles_StartNewVideo(asset)
      
    }

    appSubtitles_StartNewVideo(asset)
    {
        this.currentVideoId = -1;
        this.appSubtitles_SetCurrentToAssetsManager();
        if (asset)
        {

            this.currentVideoId = asset.asviid;
            
            this.appSubtitles_SetCurrentToAssetsManager();
            apiReadOneVideo({viid: asset.asviid},this.appSubtitles_startWithOneVideoCallback);
        }
    }

    appSubtitles_startWithOneVideoCallback(datas)
    {
        if ("ret" in datas) return; // forcement en erreur

        this.sequences_start_with_first_sequence(datas[0].viid);
     
        if (datas.length > 0)
        {
          
          const videofile = getVideoPath(datas[0]);

          const framerate = datas[0].viframerate.toFixed(2).replace('.', ','); // "1234,56"
          const num = datas[0].vinum;
          const den = datas[0].viden;

          
          this.currentVideoId = datas[0].viid;
          this.appSubtitles_SetCurrentToAssetsManager();
          this.setState(
            {
              videoname: datas[0].vititle,

              videopath: videofile, 
              timecodeAsset: datas[0],
              videoready: true, 
              videoforplayer: datas[0]}
          );
          if ((this.timelineRef) && (this.timelineRef.current))
          {
            this.setState ({internalcplist:[]})
            
            this.appSubtitles_onReadVideoForCP(datas);
            this.appSubtitles_onReadVideoForAudio1(datas);
            this.appSubtitles_onReadVideoForAudio2(datas);
          }
          
          
          this.V2_SetCurrentAssetsToBlock(this.state.blocks);
        }


    }      

    handleCpListLoaded(cplist)
    {
      
      var stparams = this.state.subtitleParameters;
      stparams.cplist = cplist;

      
      this.setState({subtitleParameters: stparams});
      this.appSubtitles_computeAllSubtitles();
      
    }

    downloadCPDone(blob, infos, file)
    {
          // on fait une copie en interne
          var internalcplist = [];
          
          blob.list.forEach(cp=>{
            internalcplist.push ({time: cp.time});
          })
          this.setState({internalcplist: internalcplist});
    }

    appSubtitles_onReadVideoForCP(datas)
    {
      const cpfiles = getCpPaths(datas[0]);

      //this.timelineRef.current.addTrack ("mp4zcp",null, cpfiles.json,cpfiles.jpegs,0, this.currentVideoId);
      if ("json" in cpfiles)
      {

             // on va lire les cp
             directDownloadJson (cpfiles.json, this.downloadCPDone, datas[0].viid.toString());

          
          if (this.currenttimelineparams.sttrackcp)
          {
            const indextr = this.timelineRef.current.getIndexByType("mp4zcp");
            // on ajoute la piste de cp si elle n'existe pas
            if (indextr == -1)
              this.timelineRef.current.addTrack ("mp4zcp",datas[0], cpfiles.json,cpfiles.jpegs,0, datas[0].viid);
            else
              this.timelineRef.current.setNewDatas (indextr, cpfiles.json, datas[0].viid, cpfiles.jpegs);
            this.timelineRef.current.forceRecreate();
            if (this.currenttimelineparams.stsmalltrackcp)
              this.timelineRef.current.minimiseTrack("mp4zcp");
          }


          //this.currenttimelineparams.sttrackcp = true;
          //this.currenttimelineparams.stsmalltrackcp = false;
      }

    }
    appSubtitles_onReadVideoForAudio1(datas)
    {
      const audiofile1 = getAudioPath(1, datas[0]);
      if (audiofile1 ==="") return;

      if (this.currenttimelineparams.sttrackaudio1)
      {
        const indextr = this.timelineRef.current.getIndexByTypeAndChannel("mp4zaudio", 1);
        // on ajoute la piste de cp si elle n'existe pas
        if (indextr == -1)
          this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile1,"",1, datas[0].viid);
        else
          this.timelineRef.current.setNewDatas (indextr, audiofile1, datas[0].viid);

        if (this.currenttimelineparams.stsmalltrackaudio1)
          this.timelineRef.current.minimiseTrack("mp4zaudio");

        this.timelineRef.current.forceRecreate();
      }
      //this.currenttimelineparams.sttrackaudio1 = true;
      //this.currenttimelineparams.stsmalltrackaudio1 = false;
        
    }
    appSubtitles_onReadVideoForAudio2(datas)
    {

      if (this.currenttimelineparams.sttrackaudio2)
      {

        const audiofile2 = getAudioPath(2, datas[0]);
        if (audiofile2 ==="") return;

        const indextr = this.timelineRef.current.getIndexByTypeAndChannel("mp4zaudio", 2);
        // on ajoute la piste de cp si elle n'existe pas
        if (indextr == -1)
          this.timelineRef.current.addTrack ("mp4zaudio",null, audiofile2,"",2, datas[0].viid);
        else
          this.timelineRef.current.setNewDatas (indextr, audiofile2, datas[0].viid);

        if (this.currenttimelineparams.stsmalltrackaudio2)
          this.timelineRef.current.minimiseTrack("mp4zaudio");
        this.timelineRef.current.forceRecreate();
      }
      //this.currenttimelineparams.sttrackaudio2 = true;
      //this.currenttimelineparams.stsmalltrackaudio2 = false;
    }

    
    // *********************************************************************************************************************
    // pure app functions
    // *********************************************************************************************************************
    canClose()
    {
      
      
      if ((this.timelineRef) && (this.timelineRef.current))
      {
        if (this.timelineRef.current.getCPListToSave()) return false;
      }


      if ((this.sequencesRef) && (this.sequencesRef.current))
      {
        if (this.sequencesRef.current.getSequencesModified()) return false;
      }

      return !this.subtitlesChanged;

    }

    componentDidMount() 
    {




      this.shortcuts_list =keyboard_multi_getShorCutList_by_apps_and_keyboard(["player","subtitling", "transcription"]);


      window.addEventListener('keydown', this.handleKeyDown);
      window.addEventListener('keyup', this.handleKeyUp);
      this.startIntervalAutoSave();
      if (this.initialised) return;
      this.initialised = true;
        

      if ((this.timelineRef) && (this.timelineRef.current))
      {
          var h = this.timelineRef.current.createDefaultTimeLine();
      }
      this.downloadDefaultFiles();

      if ((this.timelineRef) && (this.timelineRef.current))
          this.timelineRef.current.setParamsST(this.state.subtitleParameters);



      

      if (getCurrentProjectDatas().pjconfig > 0)
        this.firstLoadConfiguration(getCurrentProjectDatas().pjconfig);
      else
        this.appSubtitles_FirstDownloadProjectAssets(); // C'est parti


      if ((this.divEditSTRef) && (this.divEditSTRef.current))
        this.divEditSTRef.current.focus();

      this.grammalecte.onIgnoreWordsChange = () => {
        this.subtitlelist_onSubtitlesChecker();
      }

      this.editListeStRefCurrent = this.subtitle_GetListSubtitleRef();
      this.editSubtitleRef = this.subtitle_GetEditSubtitleRef();
    }
    // Suppression de l'écouteur lorsque le composant est démonté
    componentWillUnmount() 
    {
      this.stopIntervalAutoSave();
      window.removeEventListener('keydown', this.handleKeyDown);
      window.removeEventListener('keyup',this.handleKeyUp);
      this.grammalecte.stop();
    }  
    componentDidUpdate()
    {
      this.editListeStRefCurrent = this.subtitle_GetListSubtitleRef();
      this.editSubtitleRef = this.subtitle_GetEditSubtitleRef();
    }

    // *********************************************************************************************************************
    // autosave functions
    // *********************************************************************************************************************
    startIntervalAutoSave() 
    {
      this.intervalIdAutoSave = setInterval(() => {
        this.autoSave();
      }, 60000); 
    }
    
    stopIntervalAutoSave()
    {
      clearInterval(this.intervalIdAutoSave);
    }

    setSubtitlesChange(subtitles)
    {
      
      

      this.subtitlesChanged = true;
      this.subtitlesToSave = {
          subtitles: subtitles.map(subtitle => cloneSubtitle(subtitle)),
          framerate: this.state.framerate,
          den: this.state.den,
          num: this.state.num,
          pjid: this.state.pjid,
          params: this.state.subtitleParameters,
          display: this.displayParameters,
          speakers: this.state.speakers
      }

      

      
      
          
      if ((this.timelineRef) && (this.timelineRef.current))
    {
          const indexst = this.timelineRef.current.getIndexByType("st");
          // on ajoute la piste de sous-titre si elle n'existe pas
          if (indexst === -1)
          {
              this.timelineRef.current.addTrack ("st",[], "subtitles", "",0,this.currentCorrectedSubtitleId);


              this.timelineRef.current.setNewST(subtitles);
              
              this.timelineRef.current.setNewSubtitlesByType(subtitles, this.currentCorrectedSubtitleId,"st");
              this.timelineRef.current.forceRecreate();
              this.timelineRef.current.setNewST(subtitles);   
          }
            else
            {
              this.timelineRef.current.setNewSubtitlesByType(subtitles, this.currentCorrectedSubtitleId,"st");  
            }    
          //  this.timelineRef.current.setNewSubtitlesByType(subtitles, this.currentCorrectedSubtitle,"st");


      }
    }

    getCurrentDate = () => {
      const today = new Date();
    
      const year = today.getFullYear(); // Année AAAA
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
      const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)
    
      return `${year}/${month}/${day}`;
    };


    saveSubtitles(callback = null)
    {

        // sauvegarde des changements de plan
        if ((this.timelineRef) && (this.timelineRef.current))
        {
          if (this.timelineRef.current.getCPListToSave()) 
          {
            const datas = this.timelineRef.current.getCPListToSave();
            const infos =  this.timelineRef.current.getCPListToSaveFileInfos();

            
            const memoryFile = new File([datas], infos.datas.vixcpfile, 
                  {
                  type: "application/json", // MIME type for JSON
                  lastModified: new Date().getTime() // Timestamp for the file
                  });            
           
                if ((UploadComponentRef) && (UploadComponentRef.current))
                {
                  const formulaire = {

                    id: infos.id,
                    aspjid: this.state.pjid,
                    astype: 3,
                    uploadfile: memoryFile,
                    filenamedest: "videos/"+ infos.datas.vifile + "/" + infos.datas.vixcpfile +"_cp.json",
                    filenamesource: infos.datas.vixcpfile,
                    asupdatedate: this.getCurrentDate(),

                  }
                  
                  UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 4 ,null);
                  this.timelineRef.current.clearCPListToSave();
              
              }
          }
        }

        if ((this.sequencesRef) && (this.sequencesRef.current))
        {
          if (this.sequencesRef.current.getSequencesModified())
            this.sequences_save_sequences();
        }




        if ((!this.subtitlesChanged) || (!this.subtitlesToSave)) 
        {
          if (callback) callback();
          return;
        }
        this.subtitlesChanged = false;
        if (this.currentCorrectedSubtitleId > 0)
        {


          const asset = appAsset_getAssetById(this.assetsList, this.currentCorrectedSubtitleId);
          if (asset != null)
          {
            this.subtitlesToSave.version = getCurrentVersion();
            const datas = JSON.stringify(this.subtitlesToSave);



            const memoryFile = new File([datas], asset.asfile + "." +asset. asext, 
                  {
                  type: "application/json", // MIME type for JSON
                  lastModified: new Date().getTime() // Timestamp for the file
                  });            

            if ((UploadComponentRef) && (UploadComponentRef.current))
            {
              const formulaire = {
                asid: this.currentCorrectedSubtitleId,
                aspjid: this.state.pjid,
                astype: asset.astype,
                uploadfile: memoryFile,
                filenamedest: asset.asfile + "." +asset. asext,
                filenamesource: asset.asfile,
                asupdatedate: appAsset_getCurrentDate(),
              }
             UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 2 ,callback);
             

          }
        }
      }


    }

    autoSave()
    {
        // to do autosave for subtitles file
        // ne pas appeler directement
        if (this.subtitlesChanged) this.saveSubtitles();
    }
        
    // ********************************************************************************************************************
    // * chargements des fichiers par default
    // *********************************************************************************************************************
    downloadDefaultFiles()
    {
        directDownloadTxt (getlocalhostDatas() + "fr/motscollants.txt",this.OtherFilesdownloadDone,"motsc") 
        directDownloadJson (getlocalhostDatas() + 'fr/common_errors_fra.json',this.OtherFilesdownloadDone,"commonerrors");
    }

    OtherFilesdownloadDone(blob, infos, file)
    {
      switch (infos)
      {
        case "motsc": // liste des mots collants
            this.motsc = getStickyWordsList(blob);
            break;

        case "commonerrors":
        {


            if (this.editListeStRef && this.editListeStRef.current) {
                this.editListeStRef.current.setCommonErrors(blob);
            }

            const editSubtitleRef = this.subtitle_GetEditSubtitleRef();
            if (editSubtitleRef) {
              editSubtitleRef.setCommonErrors(blob);
            }

            break;
        }
      }
    }
    


    // *********************************************************************************************************************
    // params Events
    // *********************************************************************************************************************
    onchangeparams(params)
    {
      // on a changé un paramètres dans la fenêtre de droite
      switch (params.type)
      {
        case "st":

          this.params = configurations_framestotime(params.value,params.value.num,params.value.den,params.value.dropframe);

          this.setState ({subtitleParameters: params.value});

          if ((this.timelineRef) && (this.timelineRef.current))
              this.timelineRef.current.setParamsST(params.value);

          if ((this.editListeStRef) && (this.editListeStRef.current))
            this.editListeStRef.current.setParamsST(params.value);

          if (this.subtitle_GetEditSubtitleRef())
              this.subtitle_GetEditSubtitleRef().refresh();

          var subtitles = null;

          if ((this.editListeStRef) && (this.editListeStRef.current))
              subtitles = this.editListeStRef.current.getSubtitles();
          
              

          if (!subtitles)
          {
              if ((this.editSubtitleRef) && (this.editSubtitleRef.current))
                  subtitles = this.editSubtitleRef.current.getSubtitles();
          }

          if (subtitles)
          {
            this.subtitlesChanged = true;
            this.subtitlesToSave = {
                subtitles: subtitles,
                framerate: this.state.framerate,
                den: this.state.den,
                num: this.state.num,
                pjid: this.state.pjid,
                params: this.state.subtitleParameters,
                display: this.displayParameters,
                speakers: this.state.speakers,
            }
          }
          

          const indexst = this.timelineRef.current.getIndexByType("st");
          // on ajoute la piste de sous-titre si elle n'existe pas
          if (indexst !== -1)
          {
            this.timelineRef.current.setNewSubtitlesByType(subtitles, this.currentCorrectedSubtitleId,"st");
            this.timelineRef.current.forceRecreate();
          }

          break;

        case "applications":
          this.setState({applicationsparams: params.value});
          // on ecrit ça
          const datasapp = {
            id: getCurrentUserDatas().id,
            current: 0,
            mode: 2,
            submode: 0,
            values: JSON.stringify(params.value),

          }
          var userdatas = getCurrentUserDatas();
          userdatas.config.paramsapp = params.value;
          setCurrentUserDatas(userdatas);
          apiSaveUserConfig(datasapp, null);
          break;


        case "timeline":
          this.setState({timelineparams: params.value});
          // on ecrit ça
          const datas = {
            id: getCurrentUserDatas().id,
            current: 0,
            mode: 1,
            submode: 1,
            values: JSON.stringify(params.value),

          }
          var userdatas = getCurrentUserDatas();
          userdatas.config.subtitling.timeline = params.value;
          setCurrentUserDatas(userdatas);
          apiSaveUserConfig(datas, null);
          break;

        case "player":
          
          const datasplayer = {

            id: getCurrentUserDatas().id,
            current: 0,
            mode: 1,
            submode: 2,
            values: JSON.stringify(this.state.playerparams),

          }

          var userdatas = getCurrentUserDatas();
          userdatas.config.subtitling.player = this.state.playerparams;
          setCurrentUserDatas(userdatas);


          apiSaveUserConfig(datasplayer, null);


          if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
              this.videoPlayerRef.current.handleReady();
          if ((this.timelineRef) && (this.timelineRef.current))
              this.timelineRef.current.forceRecreate();

          if ((this.transcriptRef) && (this.transcriptRef.current))
            this.transcriptRef.current.setState({currentTime: this.state.currentTime})

          if ((this.editListeStRef) && (this.editListeStRef.current))
            this.editListeStRef.current.refresh();

          if (this.subtitle_GetEditSubtitleRef())
              this.subtitle_GetEditSubtitleRef().refresh();

          break;
      }
      if ((this.timelineRef) && (this.timelineRef.current)) this.timelineRef.current.forceRecreate();
    }

    // *********************************************************************************************************************
    // toolsbar Events
    // *********************************************************************************************************************
  disableOptionInToolBar(key,disable)
  {
      var ttips = this.state.toolsbar;
      ttips.families.forEach((family, index) => 
      {
          family.items.forEach((item, index) => 
            {
                if ((item.type !== "space") && (item.key.key === key))  item.disable = disable;
          });
      });
      this.setState ({toolsbar: ttips});
  }


    updateToggleValueInToolBar(key,value)
    {
        var ttips = this.state.toolsbar;
        ttips.families.forEach((family, index) => 
        {
            
            family.items.forEach((item, index) => 
              {
                  
                  if ((item.type !== "space") && (item.key.key === key))  item.value = value;
            });
              
        });
        this.setState ({toolsbar: ttips});
    }

    onClickToolsBar(datas) {


      if (datas.key==="SAVE")
      {
        this.saveSubtitles();
        return;
      }
      

      if (datas.cat === "layouts")
      {
        switch (datas.key) {
          case "loaddef1":
            var layout = getDefaultLayout("subtitling", 1);
            layout = this.V2_SetCurrentAssetsToBlock(layout);
            this.setCurrentLayout(0);
            this.setState({ blocks: layout , b_displaySubtitlesList: getIsVisibleLayoutBlock(layout,"subtitles")});
            break;
          case "loaddef2":
            var layout = getDefaultLayout("subtitling", 2);
            layout = this.V2_SetCurrentAssetsToBlock(layout);
            this.setCurrentLayout(1);
            this.setState({ blocks: layout , b_displaySubtitlesList: getIsVisibleLayoutBlock(layout,"subtitles")});
            break;
            
          case "loaddef3":
            var layout = getDefaultLayout("subtitling", 3);
            layout = this.V2_SetCurrentAssetsToBlock(layout);
            this.setCurrentLayout(2);
            this.setState({ blocks: layout , b_displaySubtitlesList: getIsVisibleLayoutBlock(layout,"subtitles")});
            break;

          case "save1":
            saveLayout("subtitling", 1, this.state.blocks);
            this.saveUserLayout (2); 
            
            break;
          case "save2":
            saveLayout("subtitling", 2, this.state.blocks);
            this.saveUserLayout (3); 
            break;
          case "save3":
            saveLayout("subtitling", 3, this.state.blocks);
            this.saveUserLayout (4); 
            break;
            
          case "load1":
            var userdatas = getCurrentUserDatas();
            var layout = userdatas.config.subtitling.blocks.user1;
            layout.forEach(block => {block.span = (<></>)});
            layout = this.V2_SetCurrentAssetsToBlock(layout);
            this.setCurrentLayout(2);
            this.setState({ blocks: layout , b_displaySubtitlesList: getIsVisibleLayoutBlock(layout,"subtitles")});
            break;

          case "load2":
            var userdatas = getCurrentUserDatas();
            var layout = userdatas.config.subtitling.blocks.user2;
            layout.forEach(block => {block.span = (<></>)});
            layout = this.V2_SetCurrentAssetsToBlock(layout);
            this.setCurrentLayout(3);
            this.setState({ blocks: layout , b_displaySubtitlesList: getIsVisibleLayoutBlock(layout,"subtitles")});
            break;
          case "load3":
            var userdatas = getCurrentUserDatas();
            var layout = userdatas.config.subtitling.blocks.user3;
            layout.forEach(block => {block.span = (<></>)});
            layout = this.V2_SetCurrentAssetsToBlock(layout);
            this.setCurrentLayout(4);
            this.setState({ blocks: layout , b_displaySubtitlesList: getIsVisibleLayoutBlock(layout,"subtitles")});
            break;

        }

        return;
    }

    if (datas.cat === "display")
    {
        var block = this.state.blocks.find((b) => b.id === datas.key);
        if (!block) return;
        block.visible = "visible";
        this.setState({ blocks: this.state.blocks , b_displaySubtitlesList: getIsVisibleLayoutBlock(this.state.blocks,"subtitles")});
        return;
            
    }

      if (datas.cat === "sequences")
      {
        switch (datas.key)
        {
          case "sequencesplus":
            this.sequences_createsequences();
            return;
          case "addsequence":

            if ((this.timelineRef) && (this.timelineRef.current) && (this.sequencesRef) && (this.sequencesRef.current))
            {
              const seqtrack = this.timelineRef.current.getSequenceTrack();
              if ((seqtrack) && !this.sequencesRef.current.getOneSequenceModified())
              {
                const timecode = this.videoPlayerRef.current.getTimeCode();
                const sequence = seqtrack.getMouseDown(timecode)
                if (sequence.sequenceId !== -1) 
                {
                    const den= ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden);
                    const num= ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum);

                    if (seqtrack.canCreateSequence(sequence.sequenceId, V2_RoundedTimeCode(timecode,num,den)))
                    {
                        // ici c'est possible
                        this.doActionSequence ("INSERT", sequence.sequence, sequence.sequenceId, timecode, 0,0, 0);
                    }
                }
              }

            }

            break;
          case "deletesequencebefore":
            if ((this.timelineRef) && (this.timelineRef.current) && (this.sequencesRef) && (this.sequencesRef.current))
            {
              const seqtrack = this.timelineRef.current.getSequenceTrack();
              if ((seqtrack) && !this.sequencesRef.current.getOneSequenceModified())
              {
                const timecode = this.videoPlayerRef.current.getTimeCode();
                const sequence = seqtrack.getMouseDown(timecode)
                if (sequence.sequenceId !== -1) 
                {
                    if (seqtrack.canDeleteWithPrevious(sequence.sequenceId))
                    {
                        // ici c'est possible
                        this.doActionSequence ("DELETEWITHPREVIOUS", sequence.sequence, sequence.sequenceId, 0, 0,0, 0);
                    }
                }
              }

            }
            break;


          case "deletesequenceafter":
            if ((this.timelineRef) && (this.timelineRef.current) && (this.sequencesRef) && (this.sequencesRef.current))
            {
              const seqtrack = this.timelineRef.current.getSequenceTrack();
              if ((seqtrack) && !this.sequencesRef.current.getOneSequenceModified())
              {
                const timecode = this.videoPlayerRef.current.getTimeCode();
                const sequence = seqtrack.getMouseDown(timecode)
                if (sequence.sequenceId !== -1) 
                {
                    if (seqtrack.canDeleteWithNext(sequence.sequenceId))
                    {
                        // ici c'est possible
                        this.doActionSequence ("DELETEWITHNEXT", sequence.sequence, sequence.sequenceId, 0, 0,0, 0);
                    }
                }
              }

            }
            break;

          case "undosequence":


              if (this.undosequences.length === 0) return;
              var sequences = structuredClone(this.state.sequences);
              sequences.sequences = this.undosequences.pop();

              this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
              this.setState ({sequences: sequences})
              if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
            break;
        }
      }

      

      const {key} = datas;
      switch (key)
      {
        case "LOCKVIDEO":

          setCurrentMode ({modeA: !this.state.modeA, modeB: this.state.modeB, modeC: this.state.modeC});

          this.updateToggleValueInToolBar(key, !this.state.modeA);
          this.setState({modeA: !this.state.modeA})
          return;

          case "LOCKSUBTITLES":
          setCurrentMode ({modeA: this.state.modeA, modeB: !this.state.modeB, modeC: this.state.modeC});
          this.updateToggleValueInToolBar(key, !this.state.modeB);
          this.setState({modeB: !this.state.modeB})
          return;

        case "SIMUL":
          setCurrentMode ({modeA: this.state.modeA, modeB: this.state.modeB, modeC: !this.state.modeC});
          this.updateToggleValueInToolBar(key, !this.state.modeC);
          this.setState({modeC: !this.state.modeC})
          return;
        
        case "commonShortcuts":
          this.setState({ displayCommonRaccourcis: true });          
          return;
        
        case "commonCharacters":
          this.setState({ displayCommonTableCaracteres: true });
          return;

        case "offsetfrom":
            this.setOffset(false);
          return;
        case "offsetglobal":
          this.setOffset(true);
          return;
        case "timecodes":
          this.setState({ showTimecodes: !this.state.showTimecodes });
          return;
      }

      if (this.subtitle_GetEditSubtitleRef())
        this.subtitle_GetEditSubtitleRef().processShortcut(key, null);
        
      if (this.editListeStRef && this.editListeStRef.current)
        this.editListeStRef.current.processShortcut(key, null);

      
      
    }

  setOffset(global)
  {
     
        var subtitlelist = this.state.subtitles;
        const oldSubtitles = cloneDeep(subtitlelist);
        const { currentSubtitleId } = this.state; 
        
        const timecode = this.videoPlayerRef.current.getTimeCode();
        

        const timecodest = subtitlelist[currentSubtitleId].in;
        

        var startst = 0;
        if (!global) startst = currentSubtitleId;

        const offset = timecode - timecodest;
        // premier passage on teste si possible
        var error = false;
        for (var i=startst; i<subtitlelist.length && !error; i++)
        {
          if (subtitlelist[i].in + offset < 0) error=true;
          if (subtitlelist[i].out + offset < 0) error=true;
        }
        if (error) return; 

        for (var i=startst; i<subtitlelist.length; i++)
        {
          subtitlelist[i].in = subtitlelist[i].in + offset;
          subtitlelist[i].out = subtitlelist[i].out + offset;
        }

        // on historise
        this.subtitlelist_addSubtitlesToUndoOrRedo("setOffset", oldSubtitles, currentSubtitleId, subtitlelist, currentSubtitleId);
        
        // on met à jour
        this.subtitlelist_onUpdateSubtitlesOnState(subtitlelist, currentSubtitleId);       

  }
  
  setCurrentLayout(current)
  {
    var userdatas = getCurrentUserDatas();
    var alllayout = [];
    alllayout.push ([]);
    alllayout.push ([]);
    alllayout.push ([]);
    alllayout.push (userdatas.config.subtitling.blocks.user1);
    alllayout.push (userdatas.config.subtitling.blocks.user2);
    alllayout.push (userdatas.config.subtitling.blocks.user3);
    alllayout = JSON.parse(JSON.stringify(alllayout));

    alllayout.forEach( layout => {
      layout.forEach (block => {
        block.span = "SPAN_1";    
      })      
    })

    

    const datas = {

      id: getCurrentUserDatas().id,
      current: current,
      mode: 1, // sous titrage
      submode: 0,
      values: JSON.stringify(alllayout),

    }

    userdatas.config.subtitling.current = current;
    setCurrentUserDatas(userdatas);

    apiSaveUserConfig(datas, null);
  }

  saveUserLayout(current)
  {
    // 1= subtitling, 0 = blocks



    
    var userdatas = getCurrentUserDatas();
    var alllayout = [];
    alllayout.push ([]);
    alllayout.push ([]);
    alllayout.push (userdatas.config.subtitling.blocks.user1);
    alllayout.push (userdatas.config.subtitling.blocks.user2);
    alllayout.push (userdatas.config.subtitling.blocks.user3);

    alllayout[current] = this.state.blocks;

    alllayout = JSON.parse(JSON.stringify(alllayout));

    alllayout.forEach( layout => {
      layout.forEach (block => {
        block.span = "SPAN_2";    
      })      
    })


    const datas = {

      id: getCurrentUserDatas().id,
      current: current,
      mode: 1,
      submode: 0,
      values: JSON.stringify(alllayout),

    }


    var blocks = JSON.parse(JSON.stringify(this.state.blocks));
    blocks.forEach(block =>{block.span = "SPAN_3"});

    switch (current)
    {
      case 2: userdatas.config.subtitling.blocks.user1 = this.state.blocks; break;
      case 3: userdatas.config.subtitling.blocks.user2 = this.state.blocks; break;
      case 4: userdatas.config.subtitling.blocks.user3 = this.state.blocks; break;

    
    }
    userdatas.config.subtitling.current = current;
    setCurrentUserDatas(userdatas);
    apiSaveUserConfig(datas, null);

  }

  onClickCommonRaccourcis(event) {
    switch (event.name) {
      case 'back':
        this.setState({ displayCommonRaccourcis: false });
        break;
        
      case 'save':
        keyboard_multi_savePersonnalKey(event.items);
        this.setState({ displayCommonRaccourcis: false });

        // On recharge la liste
        this.shortcuts_list = keyboard_multi_getShorCutList_by_apps_and_keyboard(["player", "transcription"]);
        break;
        
      default:
        return;
    }
  
  }


  onClickCommonRaccourcis(event) {

    switch (event.name) {
      case 'back':
        this.setState({ displayCommonRaccourcis: false });
        break;
      
      case 'save':
        keyboard_multi_savePersonnalKey(event.items);
        this.setState({ displayCommonRaccourcis: false });

        // on recharge la liste
        this.shortcuts_list = keyboard_multi_getShorCutList_by_apps_and_keyboard(["player", "subtitling", "transcription"]);
        break;
      
      default:
        return;
    }

  }

  onClickCommonTableCaracteres(event) {
    
    

    switch (event.name) {
      case 'back':
        this.setState({ displayCommonTableCaracteres: false });
        break;
      
      case 'char':
        
        const hasArabicOrHebrew = event.subset === "arabic" || event.subset === "hebrew";
        if (hasArabicOrHebrew) {
          if (this.subtitle_GetEditSubtitleRef()) {
            this.subtitle_GetEditSubtitleRef().addHebrewOrArabicChar(event.value);
          }

          if (this.editListeStRef && this.editListeStRef.current) {
            this.editListeStRef.current.addHebrewOrArabicChar(event.value);
          }
          
          break;
        }

        if (this.subtitle_GetEditSubtitleRef()) {
          this.subtitle_GetEditSubtitleRef().addChar(event.value);
        }

        if (this.editListeStRef && this.editListeStRef.current) {
          this.editListeStRef.current.addChar(event.value);
        }
        break;
      
      default:
        return;
    }
  }


  gotoSubtitle(goToNumber, from = null)
  {
      //const goToNumber = Number.parseInt(event.goToNumber);        
      const subtitle = this.state.subtitles[goToNumber - 1];

      if (subtitle) {


        const editSubtitleRef = this.subtitle_GetEditSubtitleRef();

        if (!from) {
          from = this.editListeStRef && this.editListeStRef.current.active ? 
          "editListSt" : 
          (editSubtitleRef && editSubtitleRef.active ? "editSubtitle" : "");
        }

        if (this.editListeStRef && this.editListeStRef.current){
           this.editListeStRef.current.setCurrentSubtitle(subtitle.id, from === "editListSt");      
        } 

        if (editSubtitleRef) {
          editSubtitleRef.setCurrentSubtitle(subtitle,  from === "editSubtitle");
        }
          
        this.subtitlelist_move(subtitle.id, subtitle.in, from);
      }
  }


  onClickCommonGoToSubtitleNumber(event) {

    switch (event.name) {
      case 'back':
        this.setState({ displayGoToSubtitleNumber: false });
        break;
      
      case 'submit':
        
        this.gotoSubtitle(event.goToNumber);
        this.setState({ displayGoToSubtitleNumber: false });
        break;
      
       default:
        return;
    }
  }
    // *********************************************************************************************************************
    // player Events
    // *********************************************************************************************************************
    
    videoReady(duration)
    {

        console.log("video ready", duration)
      
        if ((this.timelineRef) && (this.timelineRef.current))
            this.timelineRef.current.setCurrentDuration(duration);
  
    }

    onNewTime(time)
    {
      
      console.log("on new time", time);
      if ((this.timelineRef) && (this.timelineRef.current))
      {
          try
          {
            this.timelineRef.current.setCurrentTimeFromPlayer(time, true);
            this.setState({currentTimeCodePlayer:this.videoPlayerRef.current.getTimeCode()})
            
          }
          catch
          {
            return;
          }
      }
    }    

    // *********************************************************************************************************************
    // ASsets Manager Events
    // *********************************************************************************************************************
    onClickOnAsset(asset, type="")
    {
        // on a clicquer sur un asset
          

      if (asset.astype === 1) // on choisie une nouvelle transcription orginale
      {
          
          apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAsset);
          return;
      }
      if (asset.astype === 2) // on choisie une nouvelle transcription corrigée
      {
         
          apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAsset);
          if (asset.asoriid > 0)
            apiReadOneAsset ({asid: asset.asoriid}, this.appSubtitles_apiCallBackReadOneAsset);
          return;
      }


      if (asset.astype === 4)
      {
        
        // on change de sous-titre calculé
        const indexst = this.timelineRef.current.getIndexByType("oldst");
        //if ((asset.asid === this.currentOriginalSubtitleId) && (indexst !== -1) )return;
        this.saveSubtitles();

        if ((this.appsettingsRef) && (this.appsettingsRef.current))
          this.appsettingsRef.current.closetabs();


        this.setState({
          currentOriginalSubtitleId: asset.asid,
        });
        
        apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetOriginal);

        // on cherche des sous titres corrigés correspondant
        const corasset = appAsset_getCorrectedFromOriginal(this.assetsList, asset.asid);

        if (!corasset)
        {
            
            // il faut créer des sous-titres corrigés
              const pjid = getCurrentProjectDatas().pjid;
              var datas  = 
              {
                asid: 0,
                aspjid: pjid,
                astype: 5, // sous titres  corrigés
                asviid: 0,
                asoriid: asset.asid, // transcription originale
                astitle: asset.astitle,
                asfile: appAsset_generateUUID(),
                originalfile: asset.asfile,
                aslang: asset.aslang,
                asext: asset.asext,
                assubtype: asset.assubtype,
                ascreatedate: appAsset_getCurrentDate(),
                asupdatedate: appAsset_getCurrentDate(),
                asframerate: asset.asframerate,
                asnum: asset.asnum,
                asden: asset.asden,
                asdropframe: asset.asdropframe,
                astimecode: asset.astimecode,
                ascoid: asset.ascoid,

              
              
              }


              
              apiCreateFromAsset(datas, this.appSubtitles_apiCallBackCreateOneAssetFromOriginal)

        }

        return;


      }

      if (asset.astype === 5)
      {
        
        // on change de sous-titre corrigé
        const indexst = this.timelineRef.current.getIndexByType("st");
        //if ((asset.asid === this.currentCorrectedSubtitle) && (indexst !== -1) )return;

        if (this.currentCorrectedSubtitleId > 0)
            this.saveSubtitles();

        // on charge la nouvelle liste de sous-titre

          this.currentCorrectedSubtitleId = asset.asid;

          // on close le volet paramètres
          // ***
          if ((this.appsettingsRef) && (this.appsettingsRef.current))
            this.appsettingsRef.current.closetabs();
          apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetCorrected);
          // on regarde si on a des sous-titres calculés par rapport à ces sous-titres
          asset = appAsset_getAssetById(this.assetsList, asset.asoriid);
          if (asset !== null)
          {
            apiReadOneAsset ({asid: asset.asid}, this.appSubtitles_apiCallBackReadOneAssetOriginal);
          }

          return;


      }

      if (asset.astype == 3)
      {
        

        if (type === "")
          {
            if ((this.timelineRef) && (this.timelineRef.current))
            {
                  apiReadOneVideo({viid: asset.asviid},this.appSubtitles_startWithOneVideoCallback);
            }
          }
  

        if (type === "cp")
        {
          if ((this.timelineRef) && (this.timelineRef.current))
          {
                apiReadOneVideo({viid: asset.asviid},this.appSubtitles_onReadVideoForCP);
          }
        }
        if (type === "audio1")
          {
            if ((this.timelineRef) && (this.timelineRef.current))
            {
                  apiReadOneVideo({viid: asset.asviid},this.appSubtitles_onReadVideoForAudio1);
            }
          }
          if (type === "audio2")
            {
              if ((this.timelineRef) && (this.timelineRef.current))
              {
                    apiReadOneVideo({viid: asset.asviid},this.appSubtitles_onReadVideoForAudio2);
              }
            }
            return;
        }

    }
    
    onAssetsManagerChange(datas)
    {
      // l'assets manager a changé ou reloadé sa liste d'asset
      this.assetsList = datas;


      
    }
    exitAllPopup()
    {
        this.setState({
          createANewSubtitleFilePopup: false,
          deleteConsfigurationPopup: false,
        })
        if ((this.assetsManagerRef) && (this.assetsManagerRef.current))
        this.assetsManagerRef.current.reloadAllAssets();
    }

    

    // *********************************************************************************************************************
    // rendering....
    // *********************************************************************************************************************

    render ()
    {
  
      var apptitle = "SOUS-TITRAGE";
      if (this.context.language === "en") apptitle="SUBTITLES";
      // https://neweasysubdatas.easydirect.fr/videos/BR0217LN_EasySub.mp4
     
      var addwindows = []
      if (this.state.displayCommonRaccourcis) {
        addwindows.push(<CommonRaccourcis key={"commonRaccourcisRef"} ref={this.commonRaccourcisRef} display={this.state.displayCommonRaccourcis} onButton={this.onClickCommonRaccourcis} default="subtitling" />)
      }

      if(this.state.displayCommonTableCaracteres) {
        addwindows.push(<CommonTableCaracteres key={"commonTableCaracteresRef"} ref={this.commonTableCaracteresRef} display={this.state.displayCommonTableCaracteres} onButton={this.onClickCommonTableCaracteres} />)
      }

      if (this.state.deleteConsfigurationPopup)
      {
        addwindows.push(
        <SimplePopup display={this.state.deleteConsfigurationPopup} 
              title="" text={this.state.popupText} 
              onCancel={this.exitAllPopup}

              buttons ={
                [
                  {text:{"fr":"Oui","en":"Yes"},onclick:this.onDeleteConfiguration},
                  {text:{"fr":"Non","en":"No"},onclick:this.exitAllPopup},
                ]
              } 
          />
            )
      }

      if (this.state.displayGoToSubtitleNumber) {
        const titleGoTo = {
          fr: 'Aller au sous-titre numéro',
          en: 'Go to subtitle number'
        };

        addwindows.push(<CommonGoTo key={"commonGoToSubtitleNumberRef"} ref={this.commonGoToSubtitleNumberRef} title={titleGoTo} display={this.state.displayGoToSubtitleNumber} onButton={this.onClickCommonGoToSubtitleNumber} />)
      }

      if (this.state.displayApplyOffset)
      {
        addwindows.push(
          <ApplyOffsetVideo
            key={"ApplyOffsetVideo"}
              display = {this.state.displayApplyOffset} 
              onButton={this.handleEndApplyVideo}
              assets = {this.assetsList}
              datas = {this.state.ApplyOffsetDatas}
              pjid={this.state.pjid}
          />
        )
      }

      
      return (
        <>
        <SimplePopup display={this.state.createANewSubtitleFilePopup} 
              title="" text={this.state.popupText} 
              onCancel={this.returnToMainPage}

              buttons ={
                [
                  {text:{"fr":"Oui","en":"Yes"},onclick:this.onCreateNewSubtitleFile},
                  {text:{"fr":"Non","en":"No"},onclick:this.returnToMainPage},
                ]
              } 
          />

        <div className={styles.appDiv}  tabIndex={0} id="AppTranscriptContainer">
          <div className={styles.appDivTop}>
            <div className={styles.appDivLogoFtva}>
                <img src={ftva} style = {{width:"100%", verticalAlign:"middle"}}/>
            </div>
   <        div className={styles.appDivProject}>
                <div className={styles.appDivProjectLeft}>
                <h1>{apptitle}</h1>
                </div>
                <div className={styles.appDivProjectRight}>
                <AppHeader onCancelKeyboardEvent={this.onCancelKeyboardEvent} ref={this.appHeaderRef} canclose={false} canedit={true}/>
                </div>
  
            </div>
          <div className={styles.appDivLogo}>
            <Icon image={easytt} height="100%" width="100%"/>
            </div>
            <div className={styles.appDivUser}>
            <User onnavigate = {this.props.onnavigate} onCancelKeyboardEvent={this.onCancelKeyboardEvent}/>
            </div>
          </div>
          <div className={styles.appDivToolsBar}>
            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} />
            
          </div>
          <div className={styles.appDivBody} ref = {this.bodyDivRef}>
            
            <div className={styles.appPanelsContainer} 
              tabIndex={1} 
              style = {{outline:"none"}}
              ref = {this.divEditSTRef} 
              >
              <AppMediaAssets 

                                pjid={this.state.pjid} 
                                mode = "subtitling"
                                subtitles = {this.state.subtitles}
                                current = {parseInt(this.state.currentSubtitleId + 1)}
                                onCancelKeyboardEvent = {this.onCancelKeyboardEvent}
                                onClick = {this.onClickOnAsset}
                                onClickOnErrorSubtitle = {this.onClickOnErrorSubtitle}
                                onChange = {this.onAssetsManagerChange}
                                mediaassetref={this.assetsManagerRef}
                                tree={true}
                                refreshKey = {this.state.refreshKey}
                                ref = {this.appMediaAssetsRef}
                                codatas = {this.state.codatas}
                                timecodeasset = {this.state.timecodeAsset}
                                timecode = {this.state.currentTimeCodePlayer}
                                stparams = {this.state.subtitleParameters}
                                speakers={this.state.speakers}
                                onChangeSpeakers={this.onChangeSpeakers}
                                onaction = {this.onAppMediaAssetsAction}
                                saveSubtitles = {this.saveSubtitles}   
                                st_list_ref  = {this.editListeStRef}
                                st_edit_ref = {this.editSubtitleRef}

                                appInfos = {this.state.appInfos}>             
                                

            
              <AppSettings refreshKey={this.state.refreshKey} ref={this.appsettingsRef} codatas = {this.state.codatas} 

                  timelineparams = {this.state.timelineparams} 
                  playerparams={this.state.playerparams} 
                  defaultsparams={this.state.defaultsparams}
                  applicationsparams = {this.state.applicationsparams}

                  stparams={this.state.subtitleParameters} 
                  onchange={this.onchangeparams}>
              
                <div
                  ref={this.containerBlockRef}
                  tabIndex={0}
                  style={{
                    outline:"none",
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    overflow: "hidden",
                    marginTop: 0,
                    backgroundColor:'transparent',
                    userSelect: this.state.action ? "none" : "auto",

                  }}
                  >






                  {this.state.blocks.map((block) => (
                    <div 
                      key={block.id}
                      style={{
                        position: "absolute",
                        left: block.x,
                        marginTop: 0,
                        top: block.y,
                        width: block.width,
                        height: block.height,
                        boxSizing: "border-box",
                        backgroundColor: "black",
                        borderRadius: 4,
                        border: "2px solid rgba(80,80,80,1)",
                        color:"white",
                        userSelect: "none",
                        zIndex: ((this.state.activeid===block.id) && (this.state.action.current !=="none"))?1:0,
                        visibility: block.visible,
                        padding: "2px",
                        

                      }}
                      
                      onMouseDown={(e) => {this.Blocks_onBlockMouseDown(block.id, e)}}
                      onMouseMove={(e) => {this.Blocks_onBlockMouseMove(block.id, e)}}
                      onMouseLeave={(e) => {this.Blocks_onBlockMouseLeave(block.id, e)}}  

                    >
                      <div style={{lineHeight:block.id === "timeline"?"1":"1.5",marginTop:"0px",paddingTop:"0px",  width:block.id === "timeline"?"calc(100% - 90px)":"calc(100% - 10px)",overflow:"hidden",whiteSpace: "nowrap"}}>
                        {block.span}
                        </div>
                      <div style={{ paddingTop: "0px", width: "100%", height: "100%" }}>
                        {
                          block.id === "timeline"?<div style={{
                            position: "absolute",
                            top: 1,
                            right: 20,
                            fontSize: 7,
                            cursor: "pointer",
                            userSelect: "none",
                            width: "70px",
                            height: "18px",
                          }}
                            onMouseDown={(e) => {e.stopPropagation()}}
                            onMouseMove={(e) => {e.stopPropagation()}}
                            onMouseLeave={(e) => {e.stopPropagation()}}
                          
                          >
                            <Zoom onChangeZoom = {this.onChangeTimeLineZoom} zoomValue = {this.state.zoomValue}/>
                          </div>:<></>
                        }
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            this.blocks_removeBlock(block.id);
                          }}
                          style={{
                            position: "absolute",
                            top: 1,
                            right: 1,
                            fontSize: 7,
                            cursor: "pointer",
                            userSelect: "none",
                          }}
                        >
                          ✕
                        </button>


                        <div 
                          className={styles.appBlockContainer} 
                          style = {{height:block.id === "timeline"?"calc(100% - 16px)":"calc(100% - 24px)"}}
                          onMouseDown={(e) => {e.stopPropagation()}}
                        >
                            {
                                block.id === "transcription"? 
                                  <Transcript ref = {this.transcriptRef}
                                      readonly={true}                   
                                      noCursor={true}
                                      showPosition={true}
                                      initialFontSize = {13}
                                      timecodeAsset={this.state.timecodeAsset}
                                      speakers={this.state.speakers}
                                      //showSpeakers={false}
                                  />            


                                
                                  :
                                    block.id === "player"?
                                    <VideoPlayerST
                                        cplist = {this.state.internalcplist}
                                        ref={this.videoPlayerRef} 
                                        src={this.state.videopath}
                                        video={this.state.videoforplayer}
                                        timecodeAsset = {this.state.timecodeAsset}
                                        redo={this.state.redo}
                                        undo={this.state.undo}
                                        readOnly={this.state.hasDisplayOriginalSubtitles}                                  
                                        showSubtitleNumber={this.state.showSubtitleNumber}
                                        subtitleParameters={this.state.subtitleParameters}
                                        stparams={this.state.subtitleParameters}
                                        displayParameters={this.displayParameters}
                                        applicationsparams =  {this.state.applicationsparams}

                                        onChange={this.subtitlelist_change}                                  
                                        onMove={this.subtitlelist_move}
                                        addNewActionForUndo={this.subtitlelist_addNewActionForUndo}
                                        onUndoOrRedo={this.subtitlelist_onUndoOrRedo}
                                        
                                        onNewTime={this.onNewTime}
                                        onready={this.videoReady}
                                        params={this.state.playerparams}
                                        
                                        onChangeSubtitle={this.subtitle_onChangeSubtitle}
                                        onChangeIsPlaying={this.subtitle_onChangeIsPlaying}
                                        onSave = {this.saveSubtitles}

                                        onMustReload = {this.handleOnMustReload}

                                        
                                        onAddCP = {this.addcp}

                                        ondetectionButton={this.ondetectionButton}
                                        onProcessShortcutToEditListSubtitle={this.subtitlelist_onProcessShortcutToEditListSubtitle}
                                        grammalecte={this.grammalecte}

                                        showTimecodes={this.state.showTimecodes || !this.state.b_displaySubtitlesList}
                                        getSubtitles={() => {
                                          return this.state.subtitles;
                                        }}
                                        getTimeCodeString={this.getTimeCodeString}
                                        getIntervalString={this.getIntervalString}
                                        timecode={this.state.timecode}
                                  />

                                    :
                                      block.id==="subtitles"?
                                          <div className = "appsubtitle_subtitlelist">
                                            <div className = "appsubtitle_subtitlelist_top">
                                              <EditListSt                                              

                                              ref={this.editListeStRef}
                                              getTimeCodeString={this.getTimeCodeString}
                                              getIntervalString = {this.getIntervalString}

                                              onChange={(subtitle) =>
                                              {
                                                this.subtitlelist_change(subtitle, 'editListSt')}
                                              }
                                              onMove={(id, timecode) =>
                                                this.subtitlelist_move(id, timecode, 'editListSt')
                                              }
                                              readOnly={this.state.hasDisplayOriginalSubtitles}
                                              zIndex={2}
                                              subtitleParameters={this.state.subtitleParameters}
                                              displayParameters={this.displayParameters}
                                              applicationsparams =  {this.state.applicationsparams}
                                              undo={this.state.undo}
                                              redo={this.state.redo}
                                              onSave = {this.saveSubtitles}
                                              addNewActionForUndo={this.subtitlelist_addNewActionForUndo}
                                              onUndoOrRedo={(key, action) =>
                                                this.subtitlelist_onUndoOrRedo(key, action, 'editListSt')
                                              }
                                              onApplyFilter={this.subtitlelist_applyFilter}
                                              onUpdateSubtitles={this.subtitlelist_onUpdateSubtitles}
                                              onSelectSubtitles={this.subtitlelist_onSelectSubtitles}
                                              currentTimeCode={this.state.currentTimeCode}
                                              timecode={this.state.timecode}
                                              grammalecte={this.grammalecte}
                                              speakers={this.state.speakers}
                                              onUpdateAppearenceSpeakers={this.onUpdateAppearenceSpeakers}
                                            />
                                            </div>
                                            <div className = "appsubtitle_subtitlelist_bottom">
                                              N°&nbsp;{this.state.currentSubtitleId+1}/{this.state.subtitles.length}
                                            </div>
                                          </div>
                                        :    
                                          block.id === "timeline"?
                                            <TimeLine ref = {this.timelineRef}  
                                            forceResize ={this.forceResizeTimeLine} 
                                            playaddtime={this.handleTimeLineWheel}
                                            type="subtitling"
                                            onChangeTimeCode = {this.onNewSubtitleTimeCode}
                                            gototime={this.handleGotoTime}
                                            timecodeAsset = {this.state.timecodeAsset}
                                            timelineparams = {this.state.timelineparams}
                                            onCpListLoaded = {this.handleCpListLoaded}
                                            ondetectionButton = {this.ondetectionButton}
                                            onMouseUpOnSubtitle = {this.onMouseUpOnSubtitle}
                                            onClickOnSubtitle = {e=> {
                                              // click on subtitle {id = subtitle}
                                                const from = this.subtitlelist_getFromComponentActive();
                                                this.subtitlelist_move(e.id, e.tcin, from);
                                                
                                            }}
                                            onChangeZoomValue = {e=>{
                                              this.setState({zoomValue:e})
                                            }}

                                            onClickOnSequence = {this.onClickOnSequence}
                                            doActionSequence = {this.doActionSequence}

                                            />
                                            : 
                                            block.id === "speakers"?
                                            <SpeakersList
                                                ref={this.speakersListRef}
                                                speakers = {this.state.speakers}
                                                speakerIdsOrderByAppearance={this.state.speakerIdsOrderByAppearance}
                                                type="subtitling"
                                                onChangeSpeakers={this.onChangeSpeakers}
                                                canMerge={false}
                                                canIdentifySpeakers={false}

                                          />:
                                        <SequencesBlock
                                            type="subtitling"
                                            sequences = {this.state.sequences}
                                            assetSequences = {this.state.sequencesasset}
                                            onChange = {this.sequences_onChangeSequences}
                                            onGetText = {this.sequences_onGetText}
                                            onMove = {this.sequences_goto}
                                            addUndo = {this.sequences_add_one_undo}
                                            timecodeasset = {this.state.timecodeAsset}
                                            timecode = {this.state.currentTimeCodePlayer}

                                            onGetTimeCode ={
                                              e=>{
                                                if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
                                                {
                                                  return this.videoPlayerRef.current.getTimeCode()
                                                }
                                                return 0;
                                              }
                                            }
                                            ref = {this.sequencesRef}

                                        />



                            }


                        </div>
                      </div>
                    </div>
                  ))}

  




          </div>
                </AppSettings>
                </AppMediaAssets>
              </div>
            
            </div>
            
          {addwindows}
       
        </div>
      </>
      )
      }
  
      //  ************************************************************************************************************
    //  * nouvelle gestion de la souris sur les blocks
    //  ************************************************************************************************************
  convertiPourcentToPixel(pourcentValue, maxValueInPixel)
  {
    // pourcentValue = String type "0%"
    const num = parseFloat(pourcentValue);
    return Math.round((num * maxValueInPixel) / 100);
  }
  convertiPixelToPourcent(pixelValue, maxValueInPixel)
  {
   
    const v= (pixelValue/maxValueInPixel)*100;
    return v.toFixed(2) + "%"
  }

    blocks_removeBlock = (id) => {

    var block = this.state.blocks.find((b) => b.id === id);
    if (!block) return;
    block.visible="hidden";

    
    this.setState({blocks: this.state.blocks, b_displaySubtitlesList: getIsVisibleLayoutBlock(this.state.blocks, "subtitles")});
    return;

  };

    Blocks_onBlockMouseLeave(id, e)
    {
        if (this.state.action.current!=="none") return;
        const container = this.containerBlockRef.current;
        if (!container) return;
        
        container.style.cursor = "default";
    }

    Blocks_onBlockMouseDown(id, e)
    {
        

        if (this.state.action.current!=="none") return;

        var { clientX, clientY } = e;
        const block = this.state.blocks.find((b) => b.id === id);
        if (!block) return;

        const container = this.containerBlockRef.current;
        if (!container) return;
        const rect = container.getBoundingClientRect();

        const startX = this.convertiPourcentToPixel(block.x, rect.width);
        const startY = this.convertiPourcentToPixel(block.y, rect.height);
        const width = this.convertiPourcentToPixel(block.width, rect.width);
        const height = this.convertiPourcentToPixel(block.height, rect.height);

        // on cherche si on a un cas qui va
        

        const blockclientX = clientX - startX - rect.left;
        const blockclientY = clientY - startY - rect.top;

        var action = this.Blocks_GetAction(blockclientX,blockclientY,width,height);
        
        if (action.next !=="")
        {
            
            e.stopPropagation();
            e.preventDefault();
            action.current = action.next;
            action.startmouseX = clientX;
            action.startmouseY = clientY;
            action.block={};
            action.block.startX = startX;
            action.block.startY = startY;
            action.block.width = width;
            action.block.height = height;
            action.enCollision = false;


            const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
            // on regarde si le bloc est en collision avec un for
            for (var ind=0; ind < this.state.blocks.length; ind++)
            {
              if (this.state.blocks[ind].id !== block.id)
              {
                  const pixBlockInd = this.blocks_BlockToPixel(this.state.blocks[ind], rect.width, rect.height);
                  if (this.blocks_checkCollision(pixBlock, pixBlockInd))
                  {
                      action.enCollision = true;
                      
                  }
              }
            }

            this.setState({
              action: action,
              activeid: block.id,
              blockid: id,
            }, () => {
              window.addEventListener("mousemove", this.blocks_onMouseMove, {capture:true});
              window.addEventListener("mouseup", this.blocks_onMouseUp);
            });

            
        }


    }

    blocks_onMouseMove(e)
    {
     
        
        if (this.state.action.current==="none") return;

        const id = this.state.blockid;
        var { clientX, clientY } = e;

        
        const block = this.state.blocks.find((b) => b.id === id);
        if (!block) 
          return;
        
        const container = this.containerBlockRef.current;
        if (!container) 
        {
          
          return;
        }
        const rect = container.getBoundingClientRect();

        const startX = this.convertiPourcentToPixel(block.x, rect.width);
        const startY = this.convertiPourcentToPixel(block.y, rect.height);
        const width = this.convertiPourcentToPixel(block.width, rect.width);
        const height = this.convertiPourcentToPixel(block.height, rect.height);
        const minWidth = this.convertiPourcentToPixel(block.minWidth, rect.width);
        const minHeight = this.convertiPourcentToPixel(block.minHeight, rect.height);


        const deltaX = clientX - this.state.action.startmouseX;
        const deltaY = clientY - this.state.action.startmouseY;

        


        if (this.state.action.current === "move")
        {

            var newX = this.state.action.block.startX + deltaX;
            var newY = this.state.action.block.startY + deltaY;


            if (newX + width > rect.width) newX = rect.width - width;
            if (newY + height > rect.height) newY = rect.height - height;
            if (newX < 0) newX = 0;
            if (newY < 0) newY = 0;


            const pnewX = this.convertiPixelToPourcent(newX, rect.width);
            const pnewY = this.convertiPixelToPourcent(newY, rect.height);

          var newblocks = this.state.blocks.map (b => {
            return b.id === id ? { ...b, x: pnewX, y: pnewY } : b
          });

          var action = this.state.action;
          e.stopPropagation();
          e.preventDefault();

          this.setState({blocks: newblocks, action: action});
          return;

        }

        var change=false;
        var newblocks = this.state.blocks;
        var action = this.state.action;
        const intermin = 7;

        var memoblock = JSON.parse(JSON.stringify(newblocks));
        

        if (this.state.action.right) // on grossi à droite
        {
        
            
            var newWidth = this.state.action.block.width + deltaX;

            

            if (startX + newWidth > rect.width) newWidth = rect.width - startX;
            if (newWidth < minWidth) newWidth = minWidth; // a voir les largeurs mini par type
            const pnewWidth = this.convertiPixelToPourcent(newWidth, rect.width);
            newblocks = newblocks.map (b => {
              return b.id === id ? { ...b, width: pnewWidth} : b
            });

            // Collision ?
            if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_right (id, newblocks, memoblock, rect, intermin);

            change=true;
        }


        if (this.state.action.left) // on grossi à gauche
        {
            var newStartX = this.state.action.block.startX + deltaX;
            var newWidth = this.state.action.block.width - deltaX;
            if ((newWidth >= minWidth) && (newStartX >= 0))
            {
              const pnewWidth = this.convertiPixelToPourcent(newWidth, rect.width);
              const pnewStartX = this.convertiPixelToPourcent(newStartX, rect.width);
              newblocks = newblocks.map (b => {
                return b.id === id ? { ...b, width: pnewWidth, x: pnewStartX} : b
              });
              if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_left (id, newblocks, memoblock, rect, intermin);
              change=true;
            }
        }
        
        if (this.state.action.top) // on grossi en haut
        {
            var newStartY = this.state.action.block.startY + deltaY;
            var newHeight = this.state.action.block.height - deltaY;
            if ((newHeight >= minHeight) && (newStartY >= 0))
            {
              const pnewHeight = this.convertiPixelToPourcent(newHeight, rect.height);
              const pnewStartY = this.convertiPixelToPourcent(newStartY, rect.height);
              newblocks = newblocks.map (b => {
                return b.id === id ? { ...b, height: pnewHeight, y: pnewStartY} : b
              });

              if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_top (id, newblocks, memoblock, rect, intermin);
              change=true;
            }
        }


        if (this.state.action.bottom) // on grossi en bas
        {
            var newHeight = this.state.action.block.height + deltaY;
            if (startY + newHeight > rect.height) newHeight = rect.height - startY;
            if (newHeight < minHeight) newHeight = minHeight; // a voir les largeurs mini par type
            const pnewHeight = this.convertiPixelToPourcent(newHeight, rect.height);

            newblocks = newblocks.map (b => {
              return b.id === id ? { ...b, height: pnewHeight} : b
            });

            if (!this.state.action.enCollision) newblocks = this.blocks_CheckCollision_bottom (id, newblocks, memoblock, rect, intermin);
            change=true;
        }




        if (change)
        {
          this.setState({blocks: newblocks, action: action});
        }
        else
        {
          this.setState({action: action});

        }

    }

    // *********************************************************************************************************************
    // * check des collisions
    // *********************************************************************************************************************

lineIntersectsRect(x1, y1, x2, y2, rx, ry, rw, rh) {
  // 1. Si un des points est dans le rectangle
  if (
    this.pointInRect(x1, y1, rx, ry, rw, rh) ||
    this.pointInRect(x2, y2, rx, ry, rw, rh)
  ) {
    return true;
  }

  // 2. Sinon, teste les intersections avec les côtés du rectangle
  return (
    this.linesIntersect(x1, y1, x2, y2, rx, ry, rx + rw, ry) || // top
    this.linesIntersect(x1, y1, x2, y2, rx, ry + rh, rx + rw, ry + rh) || // bottom
    this.linesIntersect(x1, y1, x2, y2, rx, ry, rx, ry + rh) || // left
    this.linesIntersect(x1, y1, x2, y2, rx + rw, ry, rx + rw, ry + rh) // right
  );
}

pointInRect(px, py, rx, ry, rw, rh) {
  return px >= rx && px <= rx + rw && py >= ry && py <= ry + rh;
}

// Fonction qui teste l'intersection de deux segments
linesIntersect(x1, y1, x2, y2, x3, y3, x4, y4) 
{
  function ccw(ax, ay, bx, by, cx, cy) {
    return (cy - ay) * (bx - ax) > (by - ay) * (cx - ax);
  }

  return (
    ccw(x1, y1, x3, y3, x4, y4) !== ccw(x2, y2, x3, y3, x4, y4) &&
    ccw(x1, y1, x2, y2, x3, y3) !== ccw(x1, y1, x2, y2, x4, y4)
  );
}


    blocks_checkCollision(blockA, blockB) 
    {
    return !(
        blockA.x + blockA.width <= blockB.x ||
        blockA.x >= blockB.x + blockB.width ||
        blockA.y + blockA.height <= blockB.y ||
        blockA.y >= blockB.y + blockB.height
      );
  }

  blocks_BlockToPixel(bloc, width, height)
  {
  
    var retbloc = {};
    retbloc.x = this.convertiPourcentToPixel(bloc.x, width);
    retbloc.y = this.convertiPourcentToPixel(bloc.y, height);
    retbloc.width = this.convertiPourcentToPixel(bloc.width, width);
    retbloc.height = this.convertiPourcentToPixel(bloc.height, height);
    retbloc.minWidth = this.convertiPourcentToPixel(bloc.minWidth, width);
    retbloc.minHeight = this.convertiPourcentToPixel(bloc.minHeight, height);
    return retbloc;
  
  }

    blocks_CheckCollision_right (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne verticale gauche entre dans le block en cours
                    if (this.lineIntersectsRect (pixBlockInd.x, pixBlockInd.y,pixBlockInd.x,pixBlockInd.y+pixBlockInd.height,
                        pixBlock.x, pixBlock.y, pixBlock.width+intermin, pixBlock.height))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newx =  pixBlock.x + pixBlock.width + intermin;
                          var newwidth = pixBlockInd.width - (newx - pixBlockInd.x);
                          if (newwidth < pixBlockInd.minWidth) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].width = memoblock[index].width;
                          }
                          else
                          {
                            newblocks[ind].x = this.convertiPixelToPourcent( newx, rect.width);
                            newblocks[ind].width = this.convertiPixelToPourcent( newwidth, rect.width);
                          }
                        }
                }
            }
        }
        return newblocks;

    }

    blocks_CheckCollision_bottom (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne horizontale en haut entre dans le block en cours
                    
                    if (this.lineIntersectsRect (pixBlockInd.x, pixBlockInd.y,pixBlockInd.x+pixBlockInd.width,pixBlockInd.y,
                        pixBlock.x, pixBlock.y, pixBlock.width, pixBlock.height+intermin))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newy =  pixBlock.y + pixBlock.height + intermin;
                          var newheight = pixBlockInd.height - (newy - pixBlockInd.y);
                          if (newheight < pixBlockInd.minHeight) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].height = memoblock[index].height;
                          }
                          else
                          {
                            newblocks[ind].y = this.convertiPixelToPourcent( newy, rect.height);
                            newblocks[ind].height = this.convertiPixelToPourcent( newheight, rect.height);
                          }
                        }
                }
            }
        }
        return newblocks;

    }

    blocks_CheckCollision_top (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne horizontale en haut entre dans le block en cours
                    
                    if (this.lineIntersectsRect (pixBlockInd.x, pixBlockInd.y + pixBlockInd.height,pixBlockInd.x+pixBlockInd.width,pixBlockInd.y+pixBlockInd.height,
                        pixBlock.x, pixBlock.y-intermin, pixBlock.width, pixBlock.height))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newheight = pixBlock.y - pixBlockInd.y - intermin;
                          if (newheight < pixBlockInd.minHeight) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].height = memoblock[index].height;
                          }
                          else
                          {
                            newblocks[ind].height = this.convertiPixelToPourcent( newheight, rect.height);
                          }
                        }
                }
            }
        }
        return newblocks;

    }


    blocks_CheckCollision_left (id, newblocks, memoblock, rect, intermin)
    {

        const index = newblocks.findIndex(item => item.id === id);
        if (index === -1) return newblocks;
        for (var ind = 0; ind < newblocks.length; ind++)
        {
            if ((index !== ind) && (newblocks[ind].visible !=="hidden")) // on ne fait rien sur celui la
            {
                // on regarde si le bloc était déja en collision, dans ce cas on fait rien
                const block = newblocks[index];
                const pixBlock = this.blocks_BlockToPixel(block, rect.width, rect.height);
                const blockIndLast = memoblock[ind];
                const pixBlockIndLast = this.blocks_BlockToPixel(blockIndLast, rect.width, rect.height);
                //if ((!this.blocks_checkCollision(pixBlock, pixBlockIndLast)) || ignoreCollision)
                if (true)
                {
                    // avant il ne l'était pas mais maintenant que vais je faire ?
                    const blockInd = newblocks[ind];
                    const pixBlockInd = this.blocks_BlockToPixel(blockInd, rect.width, rect.height);
                    // test si la ligne horizontale en haut entre dans le block en cours
                    
                    if (this.lineIntersectsRect (pixBlockInd.x+pixBlockInd.width, pixBlockInd.y ,pixBlockInd.x+pixBlockInd.width,pixBlockInd.y+pixBlockInd.height,
                        pixBlock.x-+intermin, pixBlock.y, pixBlock.width, pixBlock.height))
                        {
                          // oui il faut revoir sa copie
                          

                          // ici on peut
                          var newwidth = pixBlock.x - pixBlockInd.x - intermin;
                          if (newwidth < pixBlockInd.minWidth) // on peut pas
                          {
                              // on retabli l'ancienne largeur du bloc
                              newblocks[index].width = memoblock[index].width;
                          }
                          else
                          {
                            newblocks[ind].width = this.convertiPixelToPourcent( newwidth, rect.width);
                          }
                        }
                }
            }
        }
        return newblocks;

    }



    blocks_onMouseUp(e)
    {
        
        window.removeEventListener("mousemove", this.blocks_onMouseMove, {capture:true});
        window.removeEventListener("mouseup", this.blocks_onMouseUp);
        
        const action = {current:"none", next:""}
        
        this.setState({action:action, aciveid:""});
        
        const container = this.containerBlockRef.current;
        if (!container) return;
        container.style.cursor = "default";
    }

    Blocks_GetAction(clientX,clientY, width, height)
    {
        var action = {
          next: "",
          current: "none",
        }
        
        const ecart=5;
        if ((clientX >=0) && (clientX <=ecart) && (clientY >=0) && (clientY <=ecart) ) // en haut à gauche
        {
            action.next =  "nw-resize";
            action.top = true;
            action.left = true;
            action.right = false;
            action.bottom = false;
            return action;
        }

        if ((clientX >=(width-ecart)) && (clientX <=width) && (clientY >=0) && (clientY <=ecart) ) // en haut à droite
        {
            action.next =  "ne-resize";
            action.top = true;
            action.left = false;
            action.right = true;
            action.bottom = false;
            return action;
        }

        if ((clientX >=0) && (clientX <=ecart) && (clientY >=(height-ecart)) && (clientY <=height) ) // en bas à gauche
        {
            action.next =  "sw-resize";
            action.top = false;
            action.left = true;
            action.right = false;
            action.bottom = true;

            return action;
        }

        if ((clientX >=(width-ecart)) && (clientX <=width) && (clientY >=(height-ecart)) && (clientY <=height) ) // en bas à droite
        {
            action.top = false;
            action.left = false;
            action.right = true;
            action.bottom = true;
            action.next =  "se-resize";
            return action;
        }

        if ((clientX >=0) && (clientX <=ecart)  ) // en à gauche
        {
            action.next =  "ew-resize";
            action.top = false;
            action.left = true;
            action.right = false;
            action.bottom = false;

            return action;
        }

        if ((clientX >=(width-ecart)) && (clientX <=width) ) // à droite
        {
            action.top = false;
            action.left = false;
            action.right = true;
            action.bottom = false;
            action.next =  "ew-resize";
            return action;
        }


        if ((clientY >=0) && (clientY <=ecart)  ) // en haut
        {
            action.top = true;
            action.left = false;
            action.right = false;
            action.bottom = false;
            action.next =  "ns-resize";
            return action;
        }

        if ((clientY >=(height-ecart)) && (clientY <=height) ) // en bas
        {
            action.top = false;
            action.left = false;
            action.right = false;
            action.bottom = true;
            action.next =  "ns-resize";
            return action;
        }

        if ((clientX >=0) && (clientX <=width) && (clientY >=0) && (clientY <=20) ) // drag
        {
            action.next =  "move";
            return action;
        }
        return action;

    }

    Blocks_onBlockMouseMove(id, e)
    {

        

        if (this.state.action.current!=="none") return;

        var { clientX, clientY } = e;
        const block = this.state.blocks.find((b) => b.id === id);
        if (!block) return;

        const container = this.containerBlockRef.current;
        if (!container) return;
        const rect = container.getBoundingClientRect();

        const startX = this.convertiPourcentToPixel(block.x, rect.width);
        const startY = this.convertiPourcentToPixel(block.y, rect.height);
        const width = this.convertiPourcentToPixel(block.width, rect.width);
        const height = this.convertiPourcentToPixel(block.height, rect.height);

        // on cherche si on a un cas qui va
        

        clientX = clientX - startX - rect.left;
        clientY = clientY - startY - rect.top;

        var action = this.Blocks_GetAction(clientX,clientY,width,height);
        if (action.next !=="")
        {
            e.stopPropagation();
            e.preventDefault();
            container.style.cursor = action.next;
            action.blockid = id;
            this.setState({action: action});
            return;

        }
        else
            container.style.cursor = "default";

        
    }




  

    // *********************************************************************************************************************************
    // * Emmanuelle...
    // * subtitlelist, subtitleedit
    // *********************************************************************************************************************************
  
  
    subtitle_GetListSubtitleRef()
    {
      if (this.editListeStRef && this.editListeStRef.current)
        return this.editListeStRef.current;
      return null;
    }
    subtitle_GetEditSubtitleRef()
    {
      
      if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
      {
        if ((this.videoPlayerRef.current.editSubtitleRef) && (this.videoPlayerRef.current.editSubtitleRef.current))
          return this.videoPlayerRef.current.editSubtitleRef.current;
      }
      return null;
    }


    subtitlelist_setNewCorrectedSubtitles(id, json)
    {
      const datas = getCurrentProjectDatas();


      if ("speakers" in json)
      {
        if (json.speakers.length) {
          const speakers = orderBy(json.speakers, ['firstName', 'name']);
          const speakerIdsOrderByAppearance = uniqBy(json.subtitles.flatMap(x => x.lines)
            .filter(x => x.speakerId)
            .map((x) => x.speakerId), (x) => x);

          const speakersIds = this.state.speakers.map(x => x.id);

          this.setState({ 
            speakers, 
            speakerIdsOrderByAppearance: union(speakerIdsOrderByAppearance, speakersIds)
          });
        }
      }

       this.grammalecte.setLang(datas.pjorilang);
      

       if (json.subtitles.length) {

        const subtitles = json.subtitles.map((subtitle, index) => ({
          ...subtitle,
          id: index,
        }))

        this.setState({ subtitles, currentSubtitleId: 0 });

        const currentSubtitle = subtitles[0];

        if ((this.editListeStRef) && (this.editListeStRef.current))
          this.editListeStRef.current.setSubtitles(
            id,
            this.state.subtitleParameters,
            cloneDeep(subtitles)
        );


        if (this.subtitle_GetEditSubtitleRef())
          this.subtitle_GetEditSubtitleRef().initSubtitle(
          id,
          cloneDeep(currentSubtitle),
          true
          );


        if (this.timelineRef &&  this.timelineRef.current) {    
          this.timelineRef.current.setCurrentSubtitle(currentSubtitle.id);
        }
        
        setTimeout(() => {
          this.subtitlelist_onSubtitlesChecker();
        }, 100);
      }
    }

 
    // *********************************************************************************************************************
    // subtitle list event
    // *********************************************************************************************************************

  subtitle_onChangeSubtitle(timecode) {


    console.log("subtitle_onChangeSubtitle time code", timecode)
    if (this.state.currentTimeCode === timecode) {
      return;
    }    
    
    const { subtitles, currentSubtitleId } = this.state;
    this.setState ({currentTimeCodePlayer: timecode});


    if(!this.state.isPlaying && this.state.modeC){
       if (this.videoPlayerRef && this.videoPlayerRef.current) {
        // timeCode
        this.videoPlayerRef.current.goto(timecode);
      }

     this.timelineRef.current.setCurrentTimeFromPlayer(timecode, true);
     this.setState ({currentTimeCodePlayer: timecode});

      return;
    }

    // Quand le mode B est actif, la vidéo bouge et on prend le sous-titre le plus proche
    if (this.state.modeB) {

      const prevSubtitle = subtitles[currentSubtitleId - 1];
      const currentSubtitle = subtitles[currentSubtitleId];
      const nextSubtitle = subtitles[currentSubtitleId + 1];

      if(currentSubtitle) {

        if (
          (prevSubtitle && timecode < prevSubtitle.out) ||
          (nextSubtitle && timecode > nextSubtitle.in)
        ) {
          const subtitle = this.subtitle_findSubtitleWithtimecode(timecode, subtitles);

          if (subtitle) {      
            const from = this.subtitlelist_getFromComponentActive();
            this.subtitlelist_move(subtitle.id, timecode, from);
          }

          return;
        }
            
        // Regrouper les timecodes définis dans un tableau avec leur label (optionnel)
        const candidates = [
          { label: "prevSubtitle", value: prevSubtitle?.out, id: prevSubtitle?.id },
          { label: "currentSubtitle", value: currentSubtitle.in, id: currentSubtitle.id },
          { label: "currentSubtitle", value: currentSubtitle.out, id: currentSubtitle.id },
          { label: "nextSubtitle", value: nextSubtitle?.in, id: nextSubtitle?.id }
        ].filter(e => e.value !== undefined);

        // Trouver celui qui a la distance absolue la plus petite
        const closest = candidates.reduce((a, b) =>
          Math.abs(b.value - timecode) < Math.abs(a.value - timecode) ? b : a
        );

        if (closest.id === currentSubtitleId) {
          this.subtitlelist_move(closest.id, timecode, this.state.isPlaying ? undefined : "editSubtitle");
          return;
        }

        this.subtitlelist_move(closest.id, closest.value, this.state.isPlaying ? undefined : "editSubtitle");
        return;
      }
    }

    const subtitle = this.subtitle_findSubtitleWithtimecode(timecode, subtitles);

    if (subtitle) {      
      this.subtitlelist_move(subtitle.id, timecode);
    } else {

      if (this.state.isPlaying && this.state.modeC) {
        const editSubtitleRef = this.subtitle_GetEditSubtitleRef();
        if (editSubtitleRef) {
          editSubtitleRef.clearCurrentSubtitle();
        }
      } else {
        
       /* this.setState({
          currentTimeCode: timecode,
        });*/

        this.subtitlelist_move(this.state.currentSubtitleId, timecode);
      }
    }
  }

  subtitle_findSubtitleWithtimecode(timecode, subtitles){
    const timeCodeTruncated = truncateTimeCode(timecode);

    let subtitle = subtitles.find(
      (x) =>
        truncateTimeCode(x.in) <= timeCodeTruncated &&
        timeCodeTruncated < truncateTimeCode(x.out)
    );
    
    // hack pour 0.000001 second
    if (!subtitle) {
      timecode += 0.000001;
        
      subtitle = subtitles.find(
        (x) =>
          truncateTimeCode(x.in) <= timecode &&
          timecode < truncateTimeCode(x.out)
      );
    }

    return subtitle;
  }
    
 async subtitle_onChangeIsPlaying(isPlaying) {

    console.log("subtitle_onChangeIsPlaying", isPlaying)
    console.log("à voir")
    //this.setState({ isPlaying });

    this.setState({
        isPlaying: isPlaying,

    }, () => {


    });


    wait(100); // le temps que le state se met à jour
    /*
    if (!isPlaying && (this.state.modeC || this.state.modeB))
    {
      this.gotoSubtitle(this.state.currentSubtitleId + 1, "editSubtitle");
    }

    if (!isPlaying && this.state.modeSimulation) {
      this.setState({ modeSimulation: false });
    }
    */

  }

  subtitlelist_onInsertSubtitle(key) {
    const { subtitles, currentSubtitleId } = this.state;

    const oldSubtitles = cloneDeep(subtitles);
    const oldCurrentSubtitleId = clone(currentSubtitleId);

    const { verticalPos, defaultAlignment } = this.state.subtitleParameters;

    const newSubtitle = {
      len: 0,
      lines: [{ len: 0, verticalPos, align: defaultAlignment, words: [] }],
    };

    let actionType = 'OnInsertSubtitle';

    if (!subtitles.length) {
      newSubtitle.id = 0;
      newSubtitle.in = this.state.subtitleParameters.interst;
      newSubtitle.out = newSubtitle.in + this.state.subtitleParameters.min;

      subtitles.push(newSubtitle);

      this.subtitlelist_addSubtitlesToUndoOrRedo(
        actionType,
        oldSubtitles,
        oldCurrentSubtitleId,
        subtitles,
        newSubtitle.id
      );

      this.subtitlelist_onUpdateSubtitlesOnState(subtitles, newSubtitle.id);

      return;
    }

    const currentSubtitle = subtitles[currentSubtitleId];

    if (key === 'INSERTSUBTITLEBEFORECURRENTSUBTITLE') {
      const prevSubtitle = subtitles[currentSubtitleId - 1];

      newSubtitle.in = prevSubtitle ? prevSubtitle.out : 0;
      newSubtitle.out = currentSubtitle.in;

      subtitles.splice(currentSubtitle.id, 0, newSubtitle);
    } else if (key === 'INSERTSUBTITLEAFTERCURRENTSUBTITLE') {
      const nextSubtitle = subtitles[currentSubtitleId + 1];

      newSubtitle.in = currentSubtitle.out;
      newSubtitle.out = nextSubtitle ? nextSubtitle.in : 0;

      if (!nextSubtitle) {
        newSubtitle.in = currentSubtitle.out + this.state.subtitleParameters.interst;
        newSubtitle.out = newSubtitle.in + this.state.subtitleParameters.min;
      }

      subtitles.splice(currentSubtitle.id + 1, 0, newSubtitle);
    } else if (key === 'PGDOWN') {
      newSubtitle.in = currentSubtitle.out + this.state.subtitleParameters.interst;
      newSubtitle.out = newSubtitle.in + this.state.subtitleParameters.min;

      subtitles.push(newSubtitle);
    }

    subtitles.forEach((subtitle, index) => (subtitle.id = index));

    this.subtitlelist_addSubtitlesToUndoOrRedo(
      actionType,
      oldSubtitles,
      oldCurrentSubtitleId,
      subtitles,
      newSubtitle.id
    );

    this.subtitlelist_onUpdateSubtitlesOnState(subtitles, newSubtitle.id);
  }
  
  subtitlelist_onDeleteSubtitle() {
    const { subtitles, currentSubtitleId } = this.state;

    const oldSubtitles = cloneDeep(subtitles);
    const oldCurrentSubtitle = oldSubtitles[currentSubtitleId];

    subtitles.splice(currentSubtitleId, 1);

    subtitles.forEach((subtitle, index) => (subtitle.id = index));

    const newId = subtitles.length ? (
      currentSubtitleId > subtitles.length - 1
        ? last(subtitles).id
        : currentSubtitleId) : -1;

    this.subtitlelist_addSubtitlesToUndoOrRedo(
      'OnDeleteSubtitle',
      oldSubtitles,
      oldCurrentSubtitle.id,
      subtitles,
      newId
    );
    
    this.subtitlelist_onUpdateSubtitlesOnState(subtitles, newId);

    const newSubtitle = subtitles[newId];
    this.subtitlelist_move(newId, newSubtitle?.in);
  }

  subtitlelist_getSubtitleFromId(id)
  {
    if ((id < 0) || (id >=(this.state.subtitles.length-1))) return null;
    return this.state.subtitles[id];
  }
  
  subtitlelist_move(id, timeCode, from) { 
  
    console.log("subtitlelist_move from:", from,"id", id, "timecode", timeCode)
    // Si je n'ai pas d'id, je ne dois pas afficher le sous-titre
    if (id === -1 || id === undefined) {

      if (this.subtitle_GetEditSubtitleRef()) {
        this.subtitle_GetEditSubtitleRef().clearCurrentSubtitle();
      }
      
      return;
    }
    
 

    // const currentSubtitle = this.state.subtitles.find((x) => x.id === id);
    const currentSubtitle = this.subtitlelist_getSubtitleFromId(id);

    if (!currentSubtitle) 
    {
      return;
    }    

     // On synchronise la vidéo et le timeline uniquement si un des modes ou si on change de sous-titre
     this.setState ({currentTimeCodePlayer: timeCode});

     
    if (this.transcriptRef && this.transcriptRef.current) {
      this.transcriptRef.current.goto(timeCode);
    }


    // Si c'est le même id courant mais qu'on a modifié, on met à jour le sous-titre
    if (this.state.currentSubtitleId === id && from) {
      if (this.editListeStRef && this.editListeStRef.current) {
    
        this.editListeStRef.current.setCurrentSubtitle(
          id,
          from === 'editListSt'
        );
      }

      if (this.subtitle_GetEditSubtitleRef()) 
      {

        this.subtitle_GetEditSubtitleRef().setCurrentSubtitle(currentSubtitle, from === 'editSubtitle');

        if (this.grammalecte.wordsInError.length) {
          this.subtitle_GetEditSubtitleRef().setWordsInError(this.grammalecte.wordsInError);
        }
      }
      
      // this.setState({ currentTimeCode: timeCode });
      
      return;
    }

  
  if (timeCode === undefined && currentSubtitle) {
    timeCode = currentSubtitle.in;
  } 

  
  this.setState({ currentSubtitleId: id});   
    
    if (this.state.modeC || this.state.modeB) {
      this.setState({currentTimeCode: timeCode});
    }
       
    // si mode B, on synchronise les sous-titres et la liste des sous-titres
    // si mode C et en play, on synchronise les sous-titres et la liste des sous-titres
    // si l'action vient du composant editListSt ou editSubtitle, on synchronise les sous-titres et la liste des sous-titres
    if (
      (this.state.isPlaying && (this.state.modeC || this.state.modeB))      
      || from) 
     {
      
      if (!from) {
        from = this.subtitlelist_getFromComponentActive();
      }

      this.app_subtitles_movetoSubtitle(id);

      if (this.editListeStRef && this.editListeStRef.current) {       
        this.editListeStRef.current.setCurrentSubtitle(
          id,
          this.state.isPlaying ? false : from === 'editListSt'
        );
      }

      if (this.subtitle_GetEditSubtitleRef()) {
        this.subtitle_GetEditSubtitleRef().setCurrentSubtitle(currentSubtitle, this.state.isPlaying ? false : from === 'editSubtitle');

        if (this.grammalecte.wordsInError.length && !this.state.isPlaying) {
          this.subtitle_GetEditSubtitleRef().setWordsInError(this.grammalecte.wordsInError);
        }
      }
    }
  }



  subtitlelist_change(
    updatedSubtitle,
    from,
    checkSubtitle = true
  ) {

    console.log("subtitlelist_change from:", from)

    const { subtitles, currentSubtitleId } = this.state;

    const updatedSubtitles = subtitles.map((subtitle) =>
      subtitle.id === updatedSubtitle.id ? cloneDeep(updatedSubtitle) : subtitle
    );

    this.setState({ subtitles: updatedSubtitles });

    if (currentSubtitleId !== updatedSubtitle.id) {
      this.setSubtitlesChange(updatedSubtitles);
      
      return;
    }

     if (!from) {
       
       if (this.subtitle_GetEditSubtitleRef())
         this.subtitle_GetEditSubtitleRef().updateSubtitle(updatedSubtitle);
       
       
       if (this.editListeStRef && this.editListeStRef.current)
         this.editListeStRef.current.updateSubtitle(updatedSubtitle);
       
     } else {

       const editSubtitleRef = this.subtitle_GetEditSubtitleRef();
        
        if (!editSubtitleRef.active){
          this.subtitle_GetEditSubtitleRef().updateSubtitle(updatedSubtitle);
        }

        if (!this.editListeStRef.current.active){
          this.editListeStRef.current.updateSubtitle(updatedSubtitle);
        }
     }
        
    this.setSubtitlesChange(updatedSubtitles);

    if (checkSubtitle) {
      setTimeout(() => this.subtitlelist_onSubtitleChecker(updatedSubtitle), 100);
    }
  }
  
    subtitlelist_onUpdateSubtitles(subtitlesToUpdate, id, overwrite = false) {
      const subtitles = overwrite
      ? subtitlesToUpdate
      : this.state.subtitles.map((updatedSubtitle) => {
          const existingSubtitle = subtitlesToUpdate.find(
            (subtitle) => subtitle.id === updatedSubtitle.id
          );
          return existingSubtitle
            ? {
                ...updatedSubtitle,
                ...existingSubtitle,
              }
            : { ...updatedSubtitle };
      });

      this.subtitlelist_onUpdateSubtitlesOnState(subtitles, id ?? this.state.currentSubtitleId, true);
    }
  
    subtitlelist_onSelectSubtitles(subtitlesUpdated) {

      if(!subtitlesUpdated.length){
        return;
      }

      const subtitles = this.state.subtitles.map((subtitleToUpdate) => {
      const subtitleUpdated = subtitlesUpdated.find(
        (subtitle) => subtitle.id === subtitleToUpdate.id
      );

      if (
        subtitleUpdated &&
        (subtitleToUpdate.selected !== subtitleUpdated.selected ||
          !isEqual(
            subtitleToUpdate.lines.map((x) => x.selected),
            subtitleUpdated.lines.map((x) => x.selected)
          ))
      ) {
        subtitleToUpdate.selected = subtitleUpdated.selected;
        subtitleToUpdate.lines
          .filter(x => x.words.length)
          .forEach(
          (x, index) => (x.selected = subtitleUpdated.lines[index].selected)
        );
      }

      return subtitleToUpdate;
    });
      
      this.setState({ subtitles });

      this.setSubtitlesChange(subtitles);
    }
  
  subtitlelist_applyFilter(action) {
    if (action.name === 'color') {
      this.applyFilterOnColor(action);
      return;
    }

    if (action.name === 'colorFiltered') {
      this.applyFilterOnColorFiltered(action);
      return;
    }

    if (action.name === 'delete') {
      this.applyFilterOnDelete(action);
      return;
    }

    if (action.name === 'duplicate' || action.name === 'cutAndPaste') {
      this.applyFilterForDuplicateOrCutAndPaste(action);
      return;
    }

    if (action.name === 'replaceAll') {
      this.applyFilterForReplaceAll(action);
      return;
    }
  }

  applyFilterOnColor(action) {
    const { subtitles, currentSubtitleId: subtitleId } = this.state;

    const oldSubtitles = cloneDeep(subtitles);
    const oldSubtitleId = clone(subtitleId);

    const updatedSubtitles = subtitles.map((subtitle) => {
      const subtitleToUpdate = action.subtitlesSelected.find(
        (x) => x.id === subtitle.id
      );
      if (subtitleToUpdate) {
        const words = flatMapDeep(subtitleToUpdate.lines.map((w) => w.words));

        words.forEach((word) => {
          word.color = action.color.hex;
        });

        return cloneDeep(subtitleToUpdate);
      }

      return subtitle;
    });

    this.subtitlelist_addSubtitlesToUndoOrRedo(
      action.name,
      oldSubtitles,
      oldSubtitleId,
      updatedSubtitles,
      subtitleId
    );

    this.subtitlelist_onUpdateSubtitlesOnState(updatedSubtitles, subtitleId);
  }

  applyFilterOnColorFiltered(action) {
    const { subtitles, currentSubtitleId: subtitleId } = this.state;

    const oldSubtitles = cloneDeep(subtitles);
    const oldSubtitleId = clone(subtitleId);

    const updatedSubtitles = subtitles.map((existingSubtitle) => {
      const updatedSubtitle = action.subtitlesFiltered.find(
        (subtitle) => subtitle.id === existingSubtitle.id
      );

      return updatedSubtitle ? cloneDeep(updatedSubtitle) : existingSubtitle;
    });

    this.subtitlelist_addSubtitlesToUndoOrRedo(
      action.name,
      oldSubtitles,
      oldSubtitleId,
      updatedSubtitles,
      subtitleId
    );

    this.subtitlelist_onUpdateSubtitlesOnState(updatedSubtitles, subtitleId);
  }

  applyFilterOnDelete(action) {
    const { subtitles, currentSubtitleId: subtitleId } = this.state;

    const oldSubtitles = cloneDeep(subtitles);
    const oldSubtitleId = clone(subtitleId);

    const selectedSubtitlesIds = action.subtitlesSelected.map((x) => x.id);
    const firstSubtitleId = first(selectedSubtitlesIds);
    const index = subtitles.findIndex((x) => x.id === firstSubtitleId);

    const updatedSubtitles = subtitles.filter(
      (subtitle) => !selectedSubtitlesIds.includes(subtitle.id)
    );

    // Réinitialiser les index
    updatedSubtitles.forEach((subtitle, index) => {
      subtitle.id = index;
    });

    const newCurrentIndex = index === 0 ? 0 : index - 1;

    this.subtitlelist_addSubtitlesToUndoOrRedo(
      action.name,
      oldSubtitles,
      oldSubtitleId,
      updatedSubtitles,
      newCurrentIndex
    );

    this.subtitlelist_onUpdateSubtitlesOnState(updatedSubtitles, newCurrentIndex);
  }

  applyFilterForDuplicateOrCutAndPaste(action) {
    const { subtitles, currentSubtitleId: subtitleId } = this.state;

    const oldSubtitles = cloneDeep(subtitles);
    const oldSubtitleId = clone(subtitleId);

    const { idTo, selectedSubtitles } = action;

    const subtitleDuplicateTo = subtitles.find((x) => x.id === idTo - 1);
    const beforeSubtitle = subtitles.find((x) => x.id === idTo);
    if (!subtitleDuplicateTo) {
      return;
    }

    let inTime = subtitleDuplicateTo.out;
    const outTime = beforeSubtitle.in;
    let inOutTime = inTime;

    // recalculer les timecodes
    selectedSubtitles.forEach((subtitle) => {
      subtitle.in = inOutTime;

      subtitle.lines.forEach((line) => {
        const sentence = line.words.map((x) => x.text).join(' ');

        const duration = outTime - inOutTime;

        line.words.forEach((word) => {
          const time = (duration / sentence.length) * word.text.length;
          inOutTime = parseFloat((inTime + time).toFixed(2));

          word.in = inTime;
          word.out = inOutTime;

          inTime = inOutTime;
        });
      });

      subtitle.out = inOutTime;
    });

    subtitles.splice(idTo, 0, ...selectedSubtitles);

    if (action.name === 'cutAndPaste') {
      // On supprime
      subtitles.splice(first(selectedSubtitles).id, selectedSubtitles.length);
    }

    // Réinitialiser les index
    subtitles.forEach((subtitle, index) => {
      subtitle.id = index;
      subtitle.selected = false;
    });

    const newCurrentSubtitleId =
      action.name === 'cutAndPaste'
        ? action.idTo - selectedSubtitles.length
        : action.idTo;

    this.subtitlelist_addSubtitlesToUndoOrRedo(
      action.name,
      oldSubtitles,
      oldSubtitleId,
      subtitles,
      newCurrentSubtitleId
    );

    this.subtitlelist_onUpdateSubtitlesOnState(subtitles, newCurrentSubtitleId, true);
  }

  applyFilterForReplaceAll(action) {
    const { subtitles, currentSubtitleId: subtitleId } = this.state;

    const oldSubtitles = cloneDeep(subtitles);
    const oldSubtitleId = clone(subtitleId);

    const { searchText, replaceText, wordsToSearch } = action.replace;

    const searchTextSplitted = searchText.split(' ');
    const textSplitted = replaceText.split(' ');


      // Cas simple : même nombre de mots
    if (searchTextSplitted.length === textSplitted.length) {
      wordsToSearch.forEach((wordToSearch) => {
        const subtitle = subtitles.find((x) => x.id === wordToSearch.id);
        if (!subtitle) {
          return;
        }

        const words = flatMapDeep(subtitle.lines.map((x) => x.words));

       searchTextSplitted.forEach((oldText, index) => {
          words.forEach((word) => {
            const wordToReplace = word.text;
            if (!wordToReplace.includes(oldText)) {
              return;
            }

            const newText = textSplitted[index];
            if (newText) {
              word.text = wordToReplace.replace(oldText, newText);
            }
          });
        });      
      });
    } else {
      // Nombre de mots différent : on résout d'abord les mots de chaque occurrence
      // (références), car les ajouts/suppressions décalent les index
      const occurrences = [];

      wordsToSearch.forEach((wordToSearch) => {
        const subtitle = subtitles.find((x) => x.id === wordToSearch.id);
        if (!subtitle) {
          return;
        }

        const words = flatMapDeep(subtitle.lines.map((x) => x.words));
        const wordsSelected = wordToSearch.words
          .map((w) => words[w.indexWord])
          .filter(Boolean);

        if (wordsSelected.length) {
          occurrences.push({ subtitle, wordsSelected });
        }
      });

      occurrences.forEach(({ subtitle, wordsSelected }) => {
        replaceWordsWithDifferentCount(
          subtitle,
          wordsSelected,
          searchText,
          replaceText
        );
      });
    }

    const currentSubtitle = first(wordsToSearch);

    this.subtitlelist_addSubtitlesToUndoOrRedo(
      action.name,
      oldSubtitles,
      oldSubtitleId,
      subtitles,
      currentSubtitle.id
    );

    this.subtitlelist_onUpdateSubtitlesOnState(subtitles, currentSubtitle.id, true);
  }
  
  // *********************************************************************************************************************
  // subtitlelist_onProcessShortcutToEditListSubtitle : On override les commandes depuis le composant EditSubtitle vers EditListSubtitle
  // *********************************************************************************************************************
  subtitlelist_onProcessShortcutToEditListSubtitle(key, value) {
    console.log("subtitlelist_onProcessShortcutToEditListSubtitle", key,value)

    if (this.editListeStRef && this.editListeStRef.current) {
      this.editListeStRef.current.processShortCutOverride(key, value);
    }
  }
  
  // *********************************************************************************************************************
  // subtitlelist_onGoToCodeFromCurrentSubtitleToVideo : On cale la vidéo au time code IN ou OUT du sous-titre courant
  // *********************************************************************************************************************
  subtitlelist_onGoToTimeCodeFromCurrentSubtitleToVideo() {
    const { subtitles, currentSubtitleId } = this.state;
            
    const currentSubtitle = subtitles[currentSubtitleId];
    if (!currentSubtitle) {
      return;
    }

    const currentTimeCode = this.videoPlayerRef.current.getTimeCode();
    
    let timeCode = Math.round(currentSubtitle.in * 10) === Math.round(currentTimeCode * 10) ? currentSubtitle.out : currentSubtitle.in;

    if (this.timelineRef && this.timelineRef.current) {
      this.timelineRef.current.setCurrentTime(timeCode);
    }

    if (this.videoPlayerRef && this.videoPlayerRef.current) {
      this.videoPlayerRef.current.goto(timeCode);
    }
  }

  subtitlelist_onGoToSubtitleFromTimeCode() {
    const currentTimeCode = this.videoPlayerRef.current.getTimeCode();

    let subtitle = this.state.subtitles.find(
      (x) => x.in <= currentTimeCode && currentTimeCode <= x.out
    );
    
    if (!subtitle) {
      // prendre le sous-titre le plus proche du timecode
      const getDistance = (subtitle) => {
        if (currentTimeCode < subtitle.in) {
          return subtitle.in - currentTimeCode;
        }

        if (currentTimeCode > subtitle.out) {
          return currentTimeCode - subtitle.out;
        }

        return 0;
      };

      const closestSubtitle = this.state.subtitles.reduce((closest, subtitle) =>
        getDistance(subtitle) < getDistance(closest) ? subtitle : closest
      );

      subtitle = closestSubtitle;
    }

    if (subtitle) {
      this.editListeStRef.current.setCurrentSubtitle(
        subtitle.id,
        this.editListeStRef.current.active
      );

      const editSubtitleRef = this.subtitle_GetEditSubtitleRef();
      editSubtitleRef.setCurrentSubtitle(subtitle, editSubtitleRef.active);

      this.app_subtitles_movetoSubtitle(subtitle.id);

      this.setState({ currentSubtitleId: subtitle.id });
    }
  }

  // *********************************************************************************************************************
  // subtitlelist_onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle : On cale le timecode de la video au time code IN ou OUT du sous-titre courant
  // *********************************************************************************************************************

  subtitlelist_onTakeTimeCodeVideoToTimeCodeInOrOutSubtitle(key) {
    const { subtitles, currentSubtitleId } = this.state;
    const currentSubtitle = subtitles[currentSubtitleId];
    if (!currentSubtitle) {
      return;
    }



    const currentTimeCode = this.videoPlayerRef.current.getTimeCode() ;
    this.setState({currentTimeCode});

    
    
    // historiser
    const undoRedo = {
      undo: {
        id: currentSubtitle.id,
        actionType: 'onTakeInOrOut',
        subtitle: cloneDeep(currentSubtitle),
      },
      redo: undefined,
    };

    
    if (key === 'TAKEIN') 
    {

      //if (currentSubtitle.out < currentTimeCode) 
      //{
      //  return;
      //}
      
      currentSubtitle.in = currentTimeCode;
    } 
    else 
    {

      //if (currentSubtitle.in > currentTimeCode) 
      //{
      //  return;
      //}
      if (key === 'TAKEOUT') 
        currentSubtitle.out = currentTimeCode;
      else
      {
        // BEST LISIBILITY
        var dur = getIdealDuration(currentSubtitle,this.state.subtitleParameters);
        var out = currentSubtitle.in + dur;

        if (this.state.currentSubtitleId < this.state.subtitles.length - 1)
        {
          // on regarde avec le sous-titre suivant
          if (out > (this.state.subtitles[this.state.currentSubtitleId+1].in - this.state.subtitleParameters.interst))
            out = this.state.subtitles[this.state.currentSubtitleId+1].in - this.state.subtitleParameters.interst;

          
        }

        if (out > currentSubtitle.in) currentSubtitle.out = out
      }
    }

    currentSubtitle.lisibility = getLisibility(currentSubtitle, this.state.subtitleParameters);

    undoRedo.redo = {
      id: currentSubtitle.id,
      actionType: 'onTakeInOrOut',
      subtitle: cloneDeep(currentSubtitle),
    };

    this.subtitlelist_addNewActionForUndo(undoRedo);
    this.subtitlelist_change(currentSubtitle, null, false);
  }
  
  // *********************************************************************************************************************
  // subtitlelist_prevSubtitle : On va au sous-titre précédent
  // *********************************************************************************************************************
  subtitlelist_prevSubtitle() {

    if (this.state.currentSubtitleId === 0) return;

    const newCurrentSubtitleId = this.state.currentSubtitleId - 1;

    const currentSubtitle = this.state.subtitles[newCurrentSubtitleId];
    if (!currentSubtitle) {
      return;
    }

    const from = this.subtitlelist_getFromComponentActive();
    this.subtitlelist_move(currentSubtitle.id, currentSubtitle.in, from);
  }

  // *********************************************************************************************************************
  // subtitlelist_nextSubtitle : On va au sous-titre suivant
  // *********************************************************************************************************************
  subtitlelist_nextSubtitle() {
    if (this.state.currentSubtitleId === this.state.subtitles.length - 1) {
      // Si le précédent sous-titre est déjà vide, on ne créé pas un nouveau sous-titre
      const prevSubtitle = this.state.subtitles[this.state.currentSubtitleId];

      if (prevSubtitle.len === 0) {
        return;
      }

      this.subtitlelist_onInsertSubtitle('PGDOWN');

      setTimeout(() => {
         if (this.editListeStRef && this.editListeStRef.current) {
          const lastSubtitle = last(this.state.subtitles);
          if (lastSubtitle) {          
              this.editListeStRef.current.scrollToSubtitle(lastSubtitle.id);
          }
        }
      }, 100);

      return;
    }

    const newCurrentSubtitleId = this.state.currentSubtitleId + 1;

    const currentSubtitle = this.state.subtitles[newCurrentSubtitleId];
    if (!currentSubtitle) {
      return;
    }

    const from = this.subtitlelist_getFromComponentActive();
    this.subtitlelist_move(currentSubtitle.id, currentSubtitle.in, from);
  }

  // *********************************************************************************************************************
  // subtitlelist_getFromComponentActive : permet de récupérer le nom du composant si celui-ci est actif
  // *********************************************************************************************************************
  subtitlelist_getFromComponentActive() {
    let from = undefined;

    if (this.editListeStRef && this.editListeStRef.current && this.editListeStRef.current.active) {
      from = "editListSt";
    }
    else {
      if (this.subtitle_GetEditSubtitleRef() && this.subtitle_GetEditSubtitleRef().active) {
        from = "editSubtitle";
      }
    }
    console.log("get active", from)
    return from;
  }

  // *********************************************************************************************************************
  // subtitlelist_addSubtitlesToUndoOrRedo 
  // permet d'ajouter la liste de sous-titres à undo / redo pour pouvoir revenir en arrière ou en avant si besoin
  // *********************************************************************************************************************
  subtitlelist_addSubtitlesToUndoOrRedo(
    actionName,
    oldSubtitles,
    oldId,
    newSubtitles,
    newId
  ) {
    let { undo, redo } = this.state;

    if (!undo) {
      undo = [];
    }

    if (undo.length === getMaxUndo()) {
      undo.shift();
    }

    redo = [];

    const undoAction = {
      undo: {
        actionType: actionName,
        subtitles: cloneDeep(oldSubtitles),
        currentSubtitleId: oldId,
      },
      redo: {
        actionType: actionName,
        subtitles: cloneDeep(newSubtitles),
        currentSubtitleId: newId,
      },
    };

    undo.push(undoAction);

    this.setState({ undo, redo });
  }

  // *********************************************************************************************************************
  // subtitlelist_addNewActionForUndo 
  // permet d'ajouter une action à undo / redo pour pouvoir revenir en arrière ou en avant si besoin
  // *********************************************************************************************************************
    subtitlelist_addNewActionForUndo(action) {


      console.log("subtitlelist_addNewActionForUndo:", action)

      if (!action) {
        return;
      }
  
      let { redo, undo } = this.state;
  
      redo = [];
  
      if (!undo) {
        undo = [];
      }
      
      if (undo.length === getMaxUndo()) {
        undo.shift();
      }
  
      undo.push(cloneDeep(action));
  
      this.setState({ redo, undo });
    }
  
  // *********************************************************************************************************************
  // subtitlelist_onUndoOrRedo 
  // permet de revenir en avant ou en arrière
  // *********************************************************************************************************************
    subtitlelist_onUndoOrRedo(key, action, from) 
    {
      console.log("subtitlelist_onUndoOrRedo key/actio/from", key, action, from)
      if (!action) {
        return;
      }
  
      const { redo, undo } = this.state;
      const isRedo = key === 'REDO';
  
      if (isRedo) {
        if (redo.length === 0) {
          return;
        }
        redo.shift();
        undo.push(action);
      } else {
        if (undo.length === 0) {
          return;
        }
  
        redo.unshift(action);
        undo.pop();
      }
  
      this.setState({ redo, undo });

      const applyAction = isRedo ? action.redo : action.undo;
  
      if (applyAction.subtitles) {
        this.subtitlelist_onUndoOrRedoOnSubtitles(applyAction);
        return;
      }
  
      this.subtitlelist_onUndoOrRedoOnOneSubtitle(applyAction, from);
    }
  
  // *********************************************************************************************************************
  // subtitlelist_onUndoOrRedoOnOneSubtitle 
  // permet de mettre à jour le sous-titre courant après avoir fait undo/redo
  // *********************************************************************************************************************
  async subtitlelist_onUndoOrRedoOnOneSubtitle(action, from) {
      
      if (this.state.currentSubtitleId !== action.subtitle.id) {
        this.subtitlelist_move(action.subtitle.id);
        await wait(100);
      }

      this.subtitlelist_change(action.subtitle);
  
      this.editListeStRef.current.updateSubtitleAfterUndoOrRedo(
        action, from === "editListSt"
      );
  
      this.subtitle_GetEditSubtitleRef().updateSubtitleAfterUndoOrRedo(
        action, from === "editSubtitle"
      );
    }
  
  // *********************************************************************************************************************
  // subtitlelist_onUndoOrRedoOnSubtitles 
  // permet de mettre à jour les sous-titres sélectionnés après avoir fait undo/redo
  // *********************************************************************************************************************
    subtitlelist_onUndoOrRedoOnSubtitles(action) {

      this.subtitlelist_onUpdateSubtitlesOnState(cloneDeep(action.subtitles), action.currentSubtitleId, true);

    }
     
  // *********************************************************************************************************************
  // subtitlelist_onUpdateSubtitlesOnState 
  // permet de mettre à jour les sous-titres dans le state
  // *********************************************************************************************************************
    subtitlelist_onUpdateSubtitlesOnState(subtitles, id, checkSubtitles = false) {

      this.setState({ subtitles });

      const currentSubtitle = subtitles.find((x) => x.id === id);
      if (currentSubtitle) {
        if (this.editListeStRef && this.editListeStRef.current)
          this.editListeStRef.current.updateSubtitles(subtitles, currentSubtitle.id);

        if (this.subtitle_GetEditSubtitleRef())
          this.subtitle_GetEditSubtitleRef().updateSubtitle(currentSubtitle);
      } else {
        this.editListeStRef.current.updateSubtitles(subtitles);
      }
  
      this.setSubtitlesChange(subtitles);

      if(checkSubtitles) {
        setTimeout(() => {
          this.subtitlelist_onSubtitlesChecker();
        }, 100);
      }
    }
  
  // *********************************************************************************************************************
  // subtitlelist_onSubtitlesChecker
  // permet de vérifier l'orthographe, la grammaire et la conjugaison sur les sous-titres
  // *********************************************************************************************************************
  subtitlelist_onSubtitlesChecker() {
    
    const { subtitles, currentSubtitleId } = this.state;

    this.grammalecte.clear();

    if (!subtitles.length) {
      return;
    }

    this.grammalecte
      .enqueueCheck(subtitles)
      .then((wordsInError) => {
        if (!wordsInError || !wordsInError.length) {
          this.editListeStRef.current.setWordsInError([]);
          return;
        }

        if (this.editListeStRef && this.editListeStRef.current) {
          this.editListeStRef.current.setWordsInError(wordsInError);
        }

        if (this.subtitle_GetEditSubtitleRef()) {
          const words = wordsInError.filter(
            (x) => x.subtitleId === currentSubtitleId
          );

          this.subtitle_GetEditSubtitleRef().setWordsInError(words);
        }
      })
      .catch((error) => {
        console.error('error', error);
      });
    }
  
  // *********************************************************************************************************************
  // subtitlelist_onSubtitleChecker
  // permet de vérifier l'orthographe, la grammaire et la conjugaison sur le sous-titre
  // *********************************************************************************************************************
  subtitlelist_onSubtitleChecker(subtitle) {

     // on va supprimer les wordsInError du sous-titre
    this.grammalecte.wordsInError = this.grammalecte.wordsInError.filter(
      (x) => x.subtitleId !== subtitle.id
    );

    this.grammalecte.enqueueCheck([subtitle]).then((wordsInError) => {
     const errors =
        !wordsInError || !wordsInError.length
          ? []
          : wordsInError.filter((x) => x.subtitleId === subtitle.id);

    if (this.editListeStRef && this.editListeStRef.current) {
        this.editListeStRef.current.setWordsInErrorToCurrentSubtitle(errors);
    }

    if(this.subtitle_GetEditSubtitleRef()) {
      this.subtitle_GetEditSubtitleRef().setWordsInError(errors);
    }

    }).then(() => {
      if (this.editListeStRef && this.editListeStRef.current) {
        this.editListeStRef.current.setCountWordsInError(this.grammalecte.wordsInError.length);
      }
    });

  }

  // ***************************************************************************************
  // onGoToWordInError()
  // permet d'aller d'erreur en erreur
  // ***************************************************************************************
  subtitlelist_onGoToWordInError() {
    const nextWord = this.grammalecte.getNextWordInError();
    if (!nextWord) {
      return;
    }
   
    let from = this.subtitlelist_getFromComponentActive();

    this.subtitlelist_move(nextWord.subtitleId, nextWord.in, from);

    setTimeout(() => {
      if (this.editListeStRef && this.editListeStRef.current) {
        this.editListeStRef.current.goToSubtitleAndWord(nextWord.subtitleId, nextWord.in);
      }
      
      if (this.subtitle_GetEditSubtitleRef()) {
        this.subtitle_GetEditSubtitleRef().goToWord(nextWord.in);
      }
    }, 100);
  }

  // *********************************************************************************************************************
  // onSetLisibilityOnAllSubtitles permet d'appliquer la lisibilité sur tous les sous-titres
  // *********************************************************************************************************************
    subtitlelist_onSetLisibilityOnAllSubtitles() {

      const { subtitles, currentSubtitleId } = this.state;

      subtitles.forEach((subtitle) => {

        subtitle.lisibility = getLisibility(subtitle, this.state.subtitleParameters);

      });
      
      this.subtitlelist_onUpdateSubtitlesOnState(subtitles, currentSubtitleId);
    }


  onChangeSpeakers(speakers) {
    const updatedSpeakers = orderBy(speakers, ['firstName', 'name']);
    
    
    this.setState({ speakers: updatedSpeakers });
    
    setTimeout(() => this.saveSubtitles(), 100);
  }

  // *********************************************************************************************************************
  // subtitlelist_onSwapSubtitles permet d'afficher les sous-titres originaux ou corrigés
  // *********************************************************************************************************************
  subtitlelist_onSwapSubtitles() {

    const hasDisplayOriginalSubtitles = !this.state.hasDisplayOriginalSubtitles;

    if (hasDisplayOriginalSubtitles) {
      this.saveSubtitles();
    }

    const id = hasDisplayOriginalSubtitles ? this.currentOriginalSubtitleId : this.currentCorrectedSubtitleId;

    const asset = this.V2_GetAssetFromID(this.assetsList, id);

    if (!asset) return;

    apiReadOneAsset({asid: asset.asid}, (datas) => {
        const asdatas = JSON.parse(datas.asdatas);

        const subtitles = cloneDeep(asdatas.subtitles).map((subtitle, index) => ({
                  ...subtitle,
                  id: index,
                }));
      
        this.subtitlelist_onUpdateSubtitlesOnState(subtitles, this.state.currentSubtitleId);
    });

    this.state.blocks.forEach(block=>{
        if (block.id === "subtitles")
        {
            const colors = this.getCurrentValueByType(asset.astype);
            block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{asset.asid}</span>&nbsp;{asset.astitle}</>);    
        }
      })
    
    this.setState({hasDisplayOriginalSubtitles, blocks:this.state.blocks});

  
  }

  onUpdateAppearenceSpeakers()
  {
        let speakerIdsOrderByAppearance = uniqBy(this.state.subtitles.flatMap(x => x.lines)
            .filter(x => x.speakerId)
            .map((x) => x.speakerId), (x) => x);

        const speakersIds = this.state.speakers.map(x => x.id);

        speakerIdsOrderByAppearance = union(speakerIdsOrderByAppearance, speakersIds);

          this.setState({
            speakerIdsOrderByAppearance,
          });        
  }
  
      getCurrentValueByType(type)
      {
          switch (type)
          {
            case 1: return getAssetColorsByType("trjson");
            case 2: return getAssetColorsByType("newtrjson");
            case 3: return getAssetColorsByType("video");
            case 4: return getAssetColorsByType("oldst");
            case 5: return getAssetColorsByType("st");
            case 6: return getAssetColorsByType("finaltrjson");
            case 7: return getAssetColorsByType("voiceover");
            case 8: return getAssetColorsByType("sequences");
          }
    
      }

    V2_GetAssetFromID(assets, id)
    {
      if (id < 1) return {asid:0};
      for (var i=0; i<assets.length; i++)
        if (assets[i].asid === id) return assets[i];
      return {asid:0};

    }



    V2_SetCurrentAssetsToBlock(blocks)
    {
      blocks.forEach ((block, index) => {
          block.span=(<></>)
          switch (block.id)
          {
                case "transcription":
                  var tr = this.currentCorrectedTranscription;

                  if (tr <=0) tr = this.currentOriginalTranscription;
                  if (tr >0)
                  {
                      const as = this.V2_GetAssetFromID(this.assetsList, tr);
                      
                      if (as.asid > 0)
                      {
                        
                        const colors = this.getCurrentValueByType(as.astype);
                        block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{tr}</span>&nbsp;{as.astitle}</>);    
                      }
                  }
                  break;
                case "player":
                    if (this.currentVideoId>0)
                    {
                        
                        const colors = this.getCurrentValueByType(3);
                        block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{this.currentVideoId}</span>&nbsp;{this.state.videoname}</>);    
                    }

                  break;
                case "timeline":
                  block.span = (<span className={styles.apptitletimeline}>{getCurrentProjectDatas().pjorititle}</span>);    
                  break;

                case "speakers":
                    block.span = (<span className={styles.apptitletimeline}>Speakers</span>);    
                    break;

                case "subtitles":
                  var st = this.currentCorrectedSubtitleId;

                  if (st <=0) tr = this.currentOriginalSubtitleId;
                  if (st >0)
                  {
                      const as = this.V2_GetAssetFromID(this.assetsList, st);
                      
                      if (as.asid > 0)
                      {
                        
                        const colors = this.getCurrentValueByType(as.astype);
                        block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{st}</span>&nbsp;{as.astitle}</>);    
                      }
                  }
                  break;
                case "sequences":
                  if (this.currentSequencesId>0)
                  {
                      const colors = this.getCurrentValueByType(8);
                      block.span = (<><span style={{fontSize:"10px", paddingRight: "3px", paddingLeft: "3px", borderRadius: "3px", color:colors.color,backgroundColor:colors.backcolor}}>{this.currentSequencesId}</span>&nbsp;{this.state.sequencesasset.astitle}</>);    

                  }
                  else
                    block.span = (<span className={styles.apptitletimeline}>Séquences</span>);    
                  break;


          }
      })
      return blocks;
    }

handleOnMustReload(button, datas)
{
  
  if (button !=="ok") return;
  if (!datas.apply) {
    this.props.onnavigate("subtitles");
    return; // on fait rieness
  }
  this.saveSubtitles();
  this.setState({displayApplyOffset: true, ApplyOffsetDatas: datas})
}

handleEndApplyVideo(buttons)
{
  this.setState({displayApplyOffset: false});
  
  this.props.onnavigate("subtitles");
}

// **************************************************************************************************************************************************************
// appmediaassets actions
// ***************************************************************************************************************************************************************

firstLoadConfiguration(nuconf)
{
    apiReadOneConfiguration (nuconf, this.firstLoadConfigurationDone);
}

firstLoadConfigurationDone(datas)
{
    if (datas.length > 0)
    {
        
        var stdatas = JSON.parse(datas[0].codatas);
        var defaultdatas = JSON.parse(datas[0].codatas);

        var den =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden);
        var num =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum);

        stdatas = configurations_framestotime(stdatas, den,num);

        

        this.setState ({
          codatas: datas[0],
          stparams: stdatas,
          defaultsparams: defaultdatas,    // parametres de la configuration de l'asset en cours
          refreshKey: this.getTimeHHMMSSforKey(),

        })

        this.state.stparams = stdatas;
        if ((this.appsettingsRef) && (this.appsettingsRef.current))
            this.appsettingsRef.current.setNewStParams(stdatas)
             
        this.timelineRef.current.setParamsST(this.state.stparams);
        this.timelineRef.current.forceRecreate();


        
    }

    this.appSubtitles_FirstDownloadProjectAssets(); // C'est parti

}


loadCurrentConfiguration(nuconf)
{
    // on charge une configuration
    if (nuconf > 0)
      apiReadOneConfiguration (nuconf, this.loadCurrentConfigurationDone)
}


loadCurrentConfigurationFromAppMediaAsset(nuconf)
{
    // on charge une configuration
    if (nuconf > 0)
      apiReadOneConfiguration (nuconf, this.loadCurrentConfigurationFromAppMediaAssetDone)
}


writeCurrentConfigurationInAsset(nuconfig)
{

  if (this.currentCorrectedSubtitleId > 0)
  {
    apiSetAssetConfiguration( {asid:this.currentCorrectedSubtitleId, coid: nuconfig}, this.writeCurrentConfigurationInAssetDone)
  }
  
}

writeCurrentConfigurationInAssetDone(datas)
{
  
  if ((this.assetsManagerRef) && (this.assetsManagerRef.current))
    this.assetsManagerRef.current.reloadAllAssets();
  this.subtitlesChanged = true;  

  
}

loadCurrentConfigurationDone(datas)
{
  
    if (datas.length > 0)
    {
        
        this.setState ({
          codatas: datas[0],
          defaultsparams: JSON.parse(datas[0].codatas),    // parametres de la configuration de l'asset en cours
          refreshKey: this.getTimeHHMMSSforKey(),
        })
        
    }
    

}

loadCurrentConfigurationFromAppMediaAssetDone(datas)
{

    
    

    if (datas.length > 0)
    {
        
        var stdatas = JSON.parse(datas[0].codatas);
        var defaultdatas = JSON.parse(datas[0].codatas);
        

        var den =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden);
        var num =  ("viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum);

        stdatas = configurations_framestotime(stdatas, den,num);

        

        this.setState ({
          codatas: datas[0],
          subtitleParameters: stdatas,
          defaultsparams: defaultdatas,    // parametres de la configuration de l'asset en cours
          refreshKey: this.getTimeHHMMSSforKey(),

        })

        this.state.subtitleParameters = stdatas;
        if ((this.appsettingsRef) && (this.appsettingsRef.current))
            this.appsettingsRef.current.setNewStParams(stdatas)
             
        this.TranscriptionisModifiedForSubtitle = true;
        this.TranscriptionisModified = true;

        this.timelineRef.current.setParamsST(this.state.subtitleParameters);
        this.timelineRef.current.forceRecreate();
        


        
    }
    
}

changeBlockDisplayState(blockname)
{
  var blockid = "";
    switch (blockname)
    {
        case "displayplayer": blockid = "player"; break;
        case "displaytimeline": blockid = "timeline"; break;
        case "displayspeakers": blockid = "speakers"; break;
        case "displaysequences": blockid = "sequences"; break;
        case "displaysubtitles": blockid = "subtitles"; break;
        case "displaytranscription": blockid = "transcription"; break;

    }

    var blocks = this.state.blocks;

    blocks.forEach (block =>{
      if (block.id === blockid)
        block.visible==="visible"?block.visible="hidden":block.visible="visible";
    

    })

    this.setState({blocks:blocks});


}

onAppMediaAssetsActionParametersProcess(type,parameters,st, subtitles=[], cplist=null,lineonly=false)
{

  const num = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum;
  const den = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden;
  const timecode = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vitimecode:this.state.timecodeAsset.astimecode;
  const dropframe =  "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vidropframe:this.state.timecodeAsset.asdropframe;


    
    switch (type)
    {
      case "interval":
        V2_CorrectInterval(parameters, st.id, subtitles,cplist, num, den, dropframe, timecode);
        break;
      case "color": // nouvealle couleur (color, applyColor)
        if (parameters.applyColor)
        {
          st.lines.forEach(line => {
                  if (
                    !lineonly || line.selected
                  )
                  {
                    
                    if ("words" in line)
                    {
                      line.words.forEach(w=>{
                        w.color = parameters.color;
                      })
                    }
                  }
          })
        }
        break;


        // ***********************************************************************
        // offset de sous titre
        // ***********************************************************************
      case "offset":
        
        st.in = st.in + parameters.offset;
        st.out = st.out + parameters.offset;

        if (st.in<0) st.in = 0;
        if (st.out<0) st.out = 0;

        break;


      case "position": // positionnement horizontal et vertical
        // ***********************************************************************
        // Positionnement de sous titre
        // ***********************************************************************

        if (parameters.applyAlignment)
        {
          st.lines.forEach(line => {
                  
                  if (
                    !lineonly || line.selected
                  )
                  {

                    switch (parameters.alignment)
                    {
                        case "left": line.align = 0; break;
                        case "right": line.align = 1; break;
                        case "center": line.align = 2; break;
                        case "free": line.align = 3; break;
                    }
                  }
          })
        }


        if (parameters.applyRow)
        {
            const nbl = st.lines.length;
            var row = parameters.row;
            for (var l = nbl ; l >=1 ; l--)
            {
              st.lines[l-1].verticalPos = row;
              row -=2;
              if (row < 1) row = 1;
            }

        }

        break;

        // ***********************************************************************
        // ***********************************************************************
    }

}

onAppMediaAssetsActionParameters(action)
{
    // action sur les sous titres
      

    const oldSubtitles = cloneDeep(this.state.subtitles);
    const oldCurrentSubtitleId = clone(this.state.currentSubtitleId);

    var subtitlelist = cloneDeep(this.state.subtitles);

      switch (action.type)
      {
        case "delete":
          subtitlelist = this.onAppMediaAssetsActionDelete(action, subtitlelist);
          break;

        default:
          subtitlelist.forEach((st,index) =>{
        
              const lineonly = action.range.applineonly;

              switch (action.range.subtitles)
              {
                case "current":
                    if (st.id == this.state.currentSubtitleId)
                      this.onAppMediaAssetsActionParametersProcess(action.type,action.parameters,st,subtitlelist,this.state.subtitleParameters.cplist,lineonly);
                  break;
                case "range":
                    if ((st.id >= (action.range.range.min-1)) && ((st.id <= action.range.range.max-1)))
                      this.onAppMediaAssetsActionParametersProcess(action.type,action.parameters,st,subtitlelist,this.state.subtitleParameters.cplist,lineonly);
                  break;
                case "selected":
                    if (st.selected)
                        this.onAppMediaAssetsActionParametersProcess(action.type,action.parameters,st, subtitlelist,this.state.subtitleParameters.cplist,lineonly);
                  break;
                case "unselected":
                    if (!st.selected)
                        this.onAppMediaAssetsActionParametersProcess(action.type,action.parameters,st,subtitlelist,this.state.subtitleParameters.cplist,lineonly);
                  break;
              }
          })
          break;
        }

      var currentSubtitleId = this.state.currentSubtitleId;

      if (currentSubtitleId >= (subtitlelist.length - 1)) currentSubtitleId = subtitlelist.length - 1;
      if (this.editListeStRef && this.editListeStRef.current) 
          this.editListeStRef.current.updateSubtitles(subtitlelist);

      this.subtitlelist_addSubtitlesToUndoOrRedo("option_" + action.type, oldSubtitles, oldCurrentSubtitleId, subtitlelist, currentSubtitleId);

      this.subtitlelist_onUpdateSubtitlesOnState(subtitlelist, currentSubtitleId);


}


// ******************************************************************************************************************************************
// * suppression liste de sous titre
// ******************************************************************************************************************************************
onAppMediaAssetsActionDelete(action, subtitlelist)
{
    
   var newsubtitlelist = [];
   
   subtitlelist.forEach((st,index) =>{
      var selected  = false;
      switch (action.range.subtitles)
      {
        case "current":
          if (st.id == this.state.currentSubtitleId) selected = true;
          break;
        case "range":
          if ((st.id >= (action.range.range.min-1)) && ((st.id <= action.range.range.max-1))) selected=true;
          break;
        case "selected":
          if (st.selected) selected = true;
          break;
        case "unselected":
          if (!st.selected) selected = true;
          break;
      }
      if (!selected)
      {
        newsubtitlelist.push (cloneDeep(st));
        const ind = newsubtitlelist.length - 1;
        newsubtitlelist[ind].id = ind;
      }
   });
   

   if (!newsubtitlelist.length)
      newsubtitlelist.push(configuration_createBlankSubtitle(this.state.timecodeAsset, this.state.subtitleParameters));
   return newsubtitlelist;

}



onAppMediaAssetsAction(action)
{
  switch (action.source)
  {
    

    case "parameters":
      this.onAppMediaAssetsActionParameters(action.action);
      this.appMediaAssetsRef.current.closeAppMediaAsset();
      break;

    case "submenu":
      switch (action.submenu.key)
      {
        case "EXIT":
          if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
            this.appMediaAssetsRef.current.closeAppMediaAsset();
          break;

          // zones affichées

        case "displayplayer":
        case "displaytimeline":
        case "displayspeakers":
        case "displaysequences":
        case "displaysubtitles":
        case "displaytranscription":
          this.changeBlockDisplayState (action.submenu.key);
          break;

        case "selectrange":
          {
            var min = action.values.min - 1;
            var max = action.values.max - 1;
            var subtitlelist = this.state.subtitles;
            const applyAlignment = action.values.attributes.applyAlignment;
            const applyColor = action.values.attributes.applyColor;

            const salignment = action.values.attributes.alignment;
            const scolor = action.values.attributes.color;

            var align = 2;
            switch (salignment)
            {
                case "left": align = 0; break;
                case "right": align = 1; break;
                case "center": align = 2; break;
                case "free": align = 3; break;
            }

            if (!applyColor && !applyAlignment)
            {
                subtitlelist.forEach((st,index) =>{


                  if ((index >=min) && (index <=max)){
                    st.selected = true
                    if (st.lines)
                    {
                      st.lines.forEach (line=>{
                        line.selected = true;
                      }
                      )
                    }
                  }
                })
            }
            else
            {
                subtitlelist.forEach((st,index) =>
                  {
                      if ((index >=min) && (index <=max))
                      {
                            var stselected = false;
                            if (st.lines)
                            {
                              st.lines.forEach (line=>
                                {
                                    if (applyAlignment)
                                    {
                                      if (line.align === align)
                                      {
                                        line.selected = true;
                                        stselected = true;
                                      }
                                    }

                                    if (applyColor)
                                    {
                                      if ("words" in line)
                                      {
                                          var lineselected = false;
                                          line.words.forEach (theword =>{
                                            if (theword.color.toLowerCase() == scolor.toLowerCase())
                                              lineselected = true;
                                          })
                                          if (lineselected)
                                          {
                                            line.selected = true;
                                            stselected = true;
                                          }
                                      }
                                    }
                                }
                              )
                            }
                            if (stselected) st.selected = true;

                      }
                });
            }
            this.subtitlelist_onUpdateSubtitlesOnState(subtitlelist, this.state.currentSubtitleId);
          }
          break;





        case "unselectrange":
          {
            var min = action.values.min - 1;
            var max = action.values.max - 1;
            var subtitlelist = this.state.subtitles;


            const applyAlignment = action.values.attributes.applyAlignment;
            const applyColor = action.values.attributes.applyColor;

            const salignment = action.values.attributes.alignment;
            const scolor = action.values.attributes.color;

            var align = 2;
            switch (salignment)
            {
                case "left": align = 0; break;
                case "right": align = 1; break;
                case "center": align = 2; break;
                case "free": align = 3; break;
            }


            if (!applyColor && !applyAlignment)
            {
                subtitlelist.forEach((st,index) =>{

                  if ((index >=min) && (index <=max)){
                    st.selected = false
                    if (st.lines)
                    {
                        st.lines.forEach (line=>{
                          line.selected = false;
                        }
                      )
                    }
                  }
                })
            }
            else
            {
                subtitlelist.forEach((st,index) =>
                  {
                      if ((index >=min) && (index <=max))
                      {
                            if (st.lines)
                            {
                              st.lines.forEach (line=>
                                {
                                    if (applyAlignment)
                                    {
                                      if (line.align === align)
                                        line.selected = false;
                                    }

                                    if (applyColor)
                                    {
                                      if ("words" in line)
                                      {
                                          var lineselected = false;
                                          line.words.forEach (theword =>{
                                            if (theword.color.toLowerCase() == scolor.toLowerCase())
                                              lineselected = true;
                                          })
                                          if (lineselected)
                                            line.selected = false;
                                      }
                                    }
                                }
                              )
                            }
                            var stselected = false;
                            st.lines.forEach (line=>
                                {
                                  if (line.selected) stselected = true;
                                }
                              );
                            st.selected = stselected;



                      }
                });
                  


            }
            this.subtitlelist_onUpdateSubtitlesOnState(subtitlelist, this.state.currentSubtitleId);
          }
          break;

        case "invertselection":
          var subtitlelist = this.state.subtitles;
          subtitlelist.forEach((st,index) =>
          {
            if ("lines" in st)
            {
                st.lines.forEach (line =>{
                  line.selected = !line.selected

                })
                var stselected = false;
                st.lines.forEach (line=>
                    {
                      if (line.selected) stselected = true;
                    }
                  );
                st.selected = stselected;
            }
          })
          this.subtitlelist_onUpdateSubtitlesOnState(subtitlelist, this.state.currentSubtitleId);
          break;


        case "selectallst":
          var subtitlelist = this.state.subtitles;
          subtitlelist.forEach(st =>{
              st.selected = true
              if (st.lines)
              {
                st.lines.forEach (line=>{
                  line.selected = true;
                }
                )
              }
            })
          this.subtitlelist_onUpdateSubtitlesOnState(subtitlelist, this.state.currentSubtitleId);
          break;
        case "unselectallst":
          var subtitlelist = this.state.subtitles;
          subtitlelist.forEach(st =>{
            st.selected = false
              if (st.lines)
              {
                st.lines.forEach (line=>{
                  line.selected = false;
                }
                )
              }

          })
          this.subtitlelist_onUpdateSubtitlesOnState(subtitlelist, this.state.currentSubtitleId);
          if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
            this.appMediaAssetsRef.current.closeAppMediaAsset();
          break;
      }
      break;


    case "ConfManager":
      switch (action.action)
      {
        case "EXIT":
          // on ferme appmediaasset
          if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
            this.appMediaAssetsRef.current.closeAppMediaAsset();
          break;
        case "DELETE":
          
          
          var texte = {
            "fr":"Voulez vous supprimer la configuration " + action.coname,
            "en": "Do you realy want to delete the configuration " + action.coname,
          }

          this.setState({
            deleteConsfigurationPopup: true,
            deleteConfigurationId: action.coid,
            popupText: texte,
          })



          break;

        case "NEWCONFIG": // ici on a chargé une nouvelle configuration
          
          this.loadCurrentConfigurationFromAppMediaAsset(action.coid)
          this.writeCurrentConfigurationInAsset(action.coid)
          // on ferme appmediaasset
          if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
            this.appMediaAssetsRef.current.closeAppMediaAsset();
          break;

      }
  }

}


onDeleteConfiguration()
{
  this.setState({deleteConsfigurationPopup:false});
  if ((this.appMediaAssetsRef) && (this.appMediaAssetsRef.current))
    this.appMediaAssetsRef.current.closeAppMediaAsset();
  if (this.state.deleteConfigurationId > 0)
  {
    
    apiDeleteConfiguration({coid: this.state.deleteConfigurationId}, this.onDeleteConfigurationDone);

  }

}
onDeleteConfigurationDone (datas)
{

    this.setState ({codatas: {coid:-1}, refreshKey: this.getTimeHHMMSSforKey()});
    this.assetsManagerRef.current.reloadAllAssets();
}

getTimeHHMMSSforKey() 
{
  const now = new Date();

  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');

  return hh + mm + ss;
}



getFirstTimeCode()
{
  if (!this.state.timecodeAsset) return 0;
  

  const num = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vinum:this.state.timecodeAsset.asnum;
  const den = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.viden:this.state.timecodeAsset.asden;
  const timecode = "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vitimecode:this.state.timecodeAsset.astimecode;
  const dropframe =  "viid" in this.state.timecodeAsset?this.state.timecodeAsset.vidropframe:this.state.timecodeAsset.asdropframe;


  
  return V2_GetSecondTimeCodeStart(timecode,num, den,dropframe, timecode);

}

//  ***********************************************************************************
//  * Gestion des séquences
//  ***********************************************************************************

doActionSequence (action, sequence, sequenceId, time, timelinetime,cpbefore, cpafter, maxduration)
{
  

  switch (action)
  {
    case "SETTCIN":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId-1].out = timelinetime;
      sequences.sequences[sequenceId].in = timelinetime;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;

    case "SETTCOUT":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId+1].in = timelinetime;
      sequences.sequences[sequenceId].out = timelinetime;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;

    
    case "SETTCINSHOT":
      
      if (cpbefore === -1) break;
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId-1].out = cpbefore;
      sequences.sequences[sequenceId].in = cpbefore;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;




      case "SETTCOUTSHOT":
        
        if (cpafter === -1) break;
        this.sequences_add_one_undo();
        var sequences = cloneDeep(this.state.sequences);
        sequences.sequences[sequenceId+1].in = cpafter;
        sequences.sequences[sequenceId].out = cpafter;
        this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
        this.setState ({sequences: sequences})
        if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
        break;
    
    case "EXTEND":
     this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId].out = maxduration;
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;
    


    case "INSERT":
     this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);

      const tcin = time;
      const tcout = sequences.sequences[sequenceId].out;
      sequences.sequences[sequenceId].out = time;
      var newsequence = sequencesCreateDefaultSequenceV2(tcin, tcout)
      sequences.sequences.splice(sequenceId+1, 0, newsequence);
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();

      break;


    case "DELETEWITHPREVIOUS":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId-1].out = sequences.sequences[sequenceId].out;
      sequences.sequences.splice(sequenceId,1);
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;


    case "DELETEWITHNEXT":
      this.sequences_add_one_undo();
      var sequences = cloneDeep(this.state.sequences);
      sequences.sequences[sequenceId+1].in = sequences.sequences[sequenceId].in;
      sequences.sequences.splice(sequenceId,1);
      this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), sequences)
      this.setState ({sequences: sequences})
      if (this.sequencesRef.current) this.sequencesRef.current.setSequencesModified();
      break;
  }

}
onClickOnSequence(sequence, movevideo)
{
  if ((this.sequencesRef) && (this.sequencesRef.current))
    return this.sequencesRef.current.gotoSequence(sequence.sequenceId, movevideo);
  return false;
}

sequences_createsequences()
{
  if (this.state.videoforplayer)  
  {
    this.sequences_save_sequences();
    const datas = {
      viid: this.state.videoforplayer.viid,
      pjid: this.state.pjid,
      ascreatedate: this.getCurrentDate(),
      asupdatedate: this.getCurrentDate(),
      asfile: appAsset_generateUUID(),
      asext: "json",
    }
    
    apiCreateSequences(datas, this.sequences_createsequences_callback);
  }
}
sequences_createsequences_callback(datas)
{
    
    if (datas.ret)
    {
      this.assetsManagerRef.current.reloadAllAssets();
      this.sequences_setSequences(datas.asid);
    }
}

sequences_setSequences(sequencesId)
{

    var datas = {asid: sequencesId};
    apiReadOneAsset (datas, this.sequences_setsequences_callback)          
}

sequences_start_with_first_sequence(viid)
{
    // on cherche le premier fichier de séquences disponible
    if (this.currentSequencesId <1)
    {

      var asid = 0;
      // on cherche d'abord avec la video
      for (var i=0; i<this.assetsList.length && asid===0; i++)
        if ((this.assetsList[i].astype === 8) && (this.assetsList[i].asoriid === viid)) asid = this.assetsList[i].asid;

      if (asid ===0)      
      {
        // sans vidéo
        for (var i=0; i<this.assetsList.length && asid===0; i++)
          if (this.assetsList[i].astype === 8)  asid = this.assetsList[i].asid;

      }
      if (asid !==0)      
      {
        const asset = this.V2_GetAssetFromID(this.assetsList, asid);
        
        if (asset.asid > 0)
            this.sequences_setSequences(asid);
      }
    }

}

sequences_save_sequences()
{
  if (this.sequencesRef && this.sequencesRef.current && this.sequencesRef.current.getSequencesModified()) 
  {
    this.sequencesRef.current.clearSequencesModified();
    // sauvegarde des séquences
    
    var towrite = 
    {
      
      den: this.state.sequencesasset.asden,
      num: this.state.sequencesasset.asnum,
      timecode: this.state.sequencesasset.astimecode,
      framerate: this.state.sequencesasset.asframerate,
      pjid: this.state.pjid,
      version: getSequenceVersionFile(),
      sequences: this.state.sequences.sequences,
    }
    

    const memoryFileSequence = new File([JSON.stringify(towrite)], this.state.sequencesasset.asfile + "." +this.state.sequencesasset.asext, 
      {
      type: "application/json", // MIME type for JSON
      lastModified: new Date().getTime() // Timestamp for the file
      });            
      if ((UploadComponentRef) && (UploadComponentRef.current))
      {
        const formulaire = {
          asid: this.state.sequencesasset.asid,
          aspjid: this.state.pjid,
          astype: 8,
          uploadfile: memoryFileSequence,
          filenamedest: this.state.sequencesasset.asfile + "." +this.state.sequencesasset.asext,
          filenamesource: this.state.sequencesasset.asfile,
          asupdatedate: this.getCurrentDate(),
          
        }
        
        UploadComponentRef.current.addUpload(this.state.pjid, formulaire, 2 ,null);
      }
      
  }
  this.sequencesModified = false;

}


sequences_check_sequences(sequences)
{

  
  
  if (!("sequences" in sequences))
    sequences.sequences = [];

  if (sequences.sequences.length === 0)
  {
    // premier utilisation des sequences

    var start = 0;
    var end = 0;
    if (this.state.videoforplayer)
    {
      this.sequencesModified = true;
      start = V2_ConvertTimeCodeStringToSecondFromAsset(this.state.videoforplayer.vitimecode,this.state.videoforplayer);
      const duration = V2_ConvertTimeCodeStringToSecondFromAsset(this.state.videoforplayer.viduration,this.state.videoforplayer);
      end = start + duration;
    }
    else
    {
      start = 0;
      end = start + 60 * 60 * 24;
    }

    sequences.sequences.push(sequencesCreateDefaultSequenceV2(start,end));

  }
  else
  {
      sequences = createV2SequencesFiles(sequences);

  }

  
  return sequences;
}


sequences_add_one_undo()
{
  if (this.undosequences.length >= this.maxUndoSequences)
    this.undosequences.shift();
  this.undosequences.push(structuredClone(this.state.sequences.sequences))
  
}

sequences_setsequences_callback(datas)
{
    
    this.undosequences = [];
    
    if (datas.ret == 1)
    {

      
      const sequences = this.sequences_check_sequences (JSON.parse(datas.asdatas));
      var sequencesasset = cloneDeep(datas);
      delete sequencesasset.asdatas;

      this.currentSequencesId = sequencesasset.asid;
      this.appSubtitles_SetCurrentToAssetsManager();

      this.sequences_add_sequences_track (sequencesasset, sequences);
      this.setState ({sequences: sequences, sequencesasset: sequencesasset})

      this.disableOptionInToolBar("sequencesplus", true);
      this.disableOptionInToolBar("addsequence", false);
      this.disableOptionInToolBar("deletesequencebefore", false);
      this.disableOptionInToolBar("deletesequenceafter", false);
      this.disableOptionInToolBar("undosequence", false);

      
      
    }
}

sequences_onChangeSequences(sequence, sequenceNumber)
{


  var newsequences = cloneDeep(this.state.sequences);
  newsequences.sequences[sequenceNumber] = sequence;

  this.sequences_add_one_undo()
  
  this.sequences_add_sequences_track(this.V2_GetAssetFromID(this.assetsList, this.currentSequencesId), newsequences)
  this.setState({sequences: newsequences})


}

sequences_add_sequences_track (asset, sequences)
{
    const indexseq = this.timelineRef.current.getIndexByType("sequences");
    // on ajoute la piste de sequences si elle n'existe pas
    if (indexseq == -1)
      this.timelineRef.current.addTrack ("sequences",sequences, asset,null,0, asset.asid);
    else
    {
      this.timelineRef.current.setNewDatas (indexseq, sequences, 0, asset);
    }

}

sequences_goto (timecode)
{
    if ((this.videoPlayerRef) && (this.videoPlayerRef.current))
        this.videoPlayerRef.current.goto(timecode);

}

sequences_onGetText(tcin, tcout, sequenceindex = 0)
{
  
  var script = "";
  this.state.subtitles.forEach(subtitle =>{
      if ((subtitle.out > tcin ) && (subtitle.out <= tcout))
      {
        if ("lines" in subtitle)
        {
          subtitle.lines.forEach(line =>{
            if ("words" in line)
            {
              line.words.forEach (word =>{
                if (script !=="") script = script + " ";
                script = script + word.text;
              })
            }
          })
        }
      }
  })
  return script;
}




  }
  export default AppSubtitle;